import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
};

export type ApiKey = {
  __typename?: 'ApiKey';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ApiKeyConnection = {
  __typename?: 'ApiKeyConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<ApiKey>;
};

export type BlockSectionProps = {
  __typename?: 'BlockSectionProps';
  hiddenCondition?: Maybe<Scalars['String']['output']>;
};

export type BlockSectionPropsInput = {
  hiddenCondition?: InputMaybe<Scalars['String']['input']>;
};

export type ConnectionMeta = {
  __typename?: 'ConnectionMeta';
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
};

export type Contact = {
  __typename?: 'Contact';
  createdAt: Scalars['Date']['output'];
  emailAddress: Scalars['String']['output'];
  emailMessagesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastEmailMessageAt?: Maybe<Scalars['Date']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  names: Array<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type ContactConnection = {
  __typename?: 'ContactConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<Contact>;
};

export enum ContactListOptPolicy {
  OptIn = 'OPT_IN',
  OptOut = 'OPT_OUT'
}

export type ContactsGroup = {
  __typename?: 'ContactsGroup';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  optPolicy: ContactListOptPolicy;
  unsubscribeLinkTemplate: Scalars['String']['output'];
  unsubscribePageConfirmationMessageTemplate: Scalars['String']['output'];
  unsubscribePageEmailInputLabelTemplate: Scalars['String']['output'];
  unsubscribePageInvalidEmailAddressMessageTemplate: Scalars['String']['output'];
  unsubscribePageSubmitButtonLabelTemplate: Scalars['String']['output'];
  unsubscribePageSubtitleTemplate: Scalars['String']['output'];
  unsubscribePageTitleTemplate: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ContactsGroupConnection = {
  __typename?: 'ContactsGroupConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<ContactsGroup>;
};

export type ContactsGroupContact = {
  __typename?: 'ContactsGroupContact';
  contactEmailAddress: Scalars['String']['output'];
  contactId: Scalars['ID']['output'];
  contactsGroupId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type ContactsGroupContactConnection = {
  __typename?: 'ContactsGroupContactConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<ContactsGroupContact>;
};

export type CreatedApiKey = {
  __typename?: 'CreatedApiKey';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
};

export type CssStyle = {
  __typename?: 'CssStyle';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  backgroundColorTemplate?: Maybe<Scalars['String']['output']>;
  border?: Maybe<Scalars['String']['output']>;
  borderRadius?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  colorTemplate?: Maybe<Scalars['String']['output']>;
  fontFamily?: Maybe<Scalars['String']['output']>;
  fontSize?: Maybe<Scalars['String']['output']>;
  fontWeight?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['String']['output']>;
  margin?: Maybe<Scalars['String']['output']>;
  maxHeight?: Maybe<Scalars['String']['output']>;
  maxWidth?: Maybe<Scalars['String']['output']>;
  minHeight?: Maybe<Scalars['String']['output']>;
  minWidth?: Maybe<Scalars['String']['output']>;
  padding?: Maybe<Scalars['String']['output']>;
  textAlign?: Maybe<Scalars['String']['output']>;
  textTransform?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type CssStyleInput = {
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  backgroundColorTemplate?: InputMaybe<Scalars['String']['input']>;
  border?: InputMaybe<Scalars['String']['input']>;
  borderRadius?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  colorTemplate?: InputMaybe<Scalars['String']['input']>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  fontSize?: InputMaybe<Scalars['String']['input']>;
  fontWeight?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['String']['input']>;
  margin?: InputMaybe<Scalars['String']['input']>;
  maxHeight?: InputMaybe<Scalars['String']['input']>;
  maxWidth?: InputMaybe<Scalars['String']['input']>;
  minHeight?: InputMaybe<Scalars['String']['input']>;
  minWidth?: InputMaybe<Scalars['String']['input']>;
  padding?: InputMaybe<Scalars['String']['input']>;
  textAlign?: InputMaybe<Scalars['String']['input']>;
  textTransform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['String']['input']>;
};

export enum DomainNameApprovalStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Requested = 'REQUESTED'
}

export type DomainNameMailFromConfiguration = {
  __typename?: 'DomainNameMailFromConfiguration';
  domain: Scalars['String']['output'];
  records: Array<DomainNameVerificationDnsRecord>;
  status: Scalars['String']['output'];
  subdomain: Scalars['String']['output'];
};

export type DomainNameVerification = {
  __typename?: 'DomainNameVerification';
  approvalStatus: DomainNameApprovalStatus;
  createdAt: Scalars['Date']['output'];
  domainName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mailFromConfiguration?: Maybe<DomainNameMailFromConfiguration>;
  status: DomainNameVerificationStatus;
  updatedAt: Scalars['Date']['output'];
  verificationDnsRecords: Array<DomainNameVerificationDnsRecord>;
};

export type DomainNameVerificationConnection = {
  __typename?: 'DomainNameVerificationConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<DomainNameVerification>;
};

export type DomainNameVerificationDnsRecord = {
  __typename?: 'DomainNameVerificationDnsRecord';
  isPresent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum DomainNameVerificationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export type EmailMessage = {
  __typename?: 'EmailMessage';
  attachments: Array<EmailMessageAttachment>;
  contactsGroupId?: Maybe<Scalars['ID']['output']>;
  context?: Maybe<Scalars['JSONObject']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  lastEvent?: Maybe<TimelineLogItem>;
  logExpirationStatus?: Maybe<EmailMessageLogExpirationStatus>;
  message: WaypointMessage;
  metaId?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSONObject']['output'];
  processedAt?: Maybe<Scalars['Date']['output']>;
  renderError?: Maybe<EmailMessageRenderError>;
  source: EmailMessageSource;
  sourceEmailMessagesBatchId?: Maybe<Scalars['ID']['output']>;
  sourceWorkflowRunId?: Maybe<Scalars['ID']['output']>;
  status: EmailMessageStatus;
  updatedAt: Scalars['Date']['output'];
  variables?: Maybe<Scalars['JSONObject']['output']>;
  waypointTemplateId?: Maybe<Scalars['ID']['output']>;
};

export type EmailMessageAttachment = {
  __typename?: 'EmailMessageAttachment';
  contentBytesSize: Scalars['Int']['output'];
  contentType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type EmailMessageConnection = {
  __typename?: 'EmailMessageConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<EmailMessage>;
  report: EmailMessageConnectionReport;
};

export type EmailMessageConnectionReport = {
  __typename?: 'EmailMessageConnectionReport';
  bouncedCount: Scalars['Int']['output'];
  clickedCount: Scalars['Int']['output'];
  complainedCount: Scalars['Int']['output'];
  deliveredCount: Scalars['Int']['output'];
  erroredCount: Scalars['Int']['output'];
  openedCount: Scalars['Int']['output'];
  suppressedCount: Scalars['Int']['output'];
  unsubscribedCount: Scalars['Int']['output'];
};

export enum EmailMessageEnvironmentFilter {
  All = 'ALL',
  Live = 'LIVE',
  Sandbox = 'SANDBOX'
}

export enum EmailMessageEventTypeFilter {
  All = 'ALL',
  Bounced = 'BOUNCED',
  Clicked = 'CLICKED',
  Complained = 'COMPLAINED',
  Delivered = 'DELIVERED',
  Errored = 'ERRORED',
  Opened = 'OPENED',
  Suppressed = 'SUPPRESSED',
  Unsubscribed = 'UNSUBSCRIBED'
}

export enum EmailMessageLogExpirationStatus {
  Active = 'ACTIVE',
  HardArchived = 'HARD_ARCHIVED',
  SoftArchived = 'SOFT_ARCHIVED'
}

export type EmailMessageRenderError = {
  __typename?: 'EmailMessageRenderError';
  message: Scalars['String']['output'];
  template: Scalars['String']['output'];
  variables?: Maybe<Scalars['JSONObject']['output']>;
};

export enum EmailMessageSource {
  Api = 'API',
  Batch = 'BATCH',
  Broadcast = 'BROADCAST',
  Preview = 'PREVIEW',
  SandboxApi = 'SANDBOX_API',
  SandboxBatch = 'SANDBOX_BATCH',
  SandboxBroadcast = 'SANDBOX_BROADCAST',
  SandboxSmtp = 'SANDBOX_SMTP',
  SandboxWorkflow = 'SANDBOX_WORKFLOW',
  Smtp = 'SMTP',
  Workflow = 'WORKFLOW'
}

export enum EmailMessageStatus {
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Halted = 'HALTED',
  Paused = 'PAUSED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export enum EmailMessageTimePeriodFilter {
  All = 'ALL',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type EmailMessagesFilterInput = {
  environment?: InputMaybe<EmailMessageEnvironmentFilter>;
  eventType?: InputMaybe<EmailMessageEventTypeFilter>;
  query?: InputMaybe<Scalars['String']['input']>;
  recipientContactId?: InputMaybe<Scalars['ID']['input']>;
  sourceEmailMessagesBatchId?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<EmailMessageTimePeriodFilter>;
};

export enum EmailMessagesSort {
  CreatedAtAsc = 'createdAt_ASC'
}

export enum EmailTemplateHtmlPreviewType {
  Sample = 'SAMPLE',
  Template = 'TEMPLATE'
}

export type HttpPostTriggerProperties = {
  __typename?: 'HttpPostTriggerProperties';
  token: Scalars['ID']['output'];
};

export type HttpPostTriggerPropertiesInput = {
  token: Scalars['ID']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  archiveWaypointTemplate: WaypointTemplate;
  archiveWorkflow: Workflow;
  createApiKey: CreatedApiKey;
  createContactsGroup: ContactsGroup;
  createContactsGroupContact: ContactsGroupContact;
  createDomainNameVerification: DomainNameVerification;
  createDuplicateTemplate: WaypointTemplate;
  createLayoutFromExisting: WaypointTemplate;
  createPlatformBillingPlan: PlatformBillingInformation;
  createSenderEmailAddress: VerifiedEmailAddress;
  createStripeCustomerPortalUrl?: Maybe<Scalars['String']['output']>;
  createSvixCustomerPortalUrl: Scalars['String']['output'];
  createTemplate: WaypointTemplate;
  createTemplateFromExisting: WaypointTemplate;
  createTemplateFromSample: WaypointTemplate;
  createTemplateSection: TemplateSection;
  createWaypointTemplatePreview: EmailMessage;
  createWaypointTemplateUploadImageUrl: WaypointTemplateImage;
  createWorkflow: Workflow;
  createWorkflowPreview: WorkflowEvent;
  createWorkflowRunCommand: WorkflowRunCommand;
  deleteContactsGroupContact: Scalars['Boolean']['output'];
  deleteTemplateSection: Scalars['Boolean']['output'];
  previewWaypointTemplate: WaypointMessage;
  refreshWaypointTemplateImageStatus: WaypointTemplateImage;
  requestDomainNameVerificationApproval: DomainNameVerification;
  requestPlatformDelete: Scalars['Boolean']['output'];
  sendDnsInformationEmailMessage: DomainNameVerification;
  updateContactsGroup: ContactsGroup;
  updateEmailTemplateName: WaypointTemplate;
  updatePlatformBillingInformation: PlatformBillingInformation;
  updatePlatformBillingPlan: PlatformBillingInformation;
  updatePlatformSesEventTracking: PlatformSesConfiguration;
  updateTemplateSection: TemplateSection;
  updateTemplateSectionsOrder: Array<TemplateSection>;
  updateVerifiedEmailAddress: VerifiedEmailAddress;
  updateWaypointTemplate: WaypointTemplate;
  updateWaypointTemplateSection: WaypointTemplate;
  updateWorkflow: Workflow;
  updateWorkflowName: Workflow;
};


export type MutationArchiveWaypointTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateApiKeyArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateContactsGroupArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unsubscribeLinkTemplate: Scalars['String']['input'];
  unsubscribePageConfirmationMessageTemplate: Scalars['String']['input'];
  unsubscribePageEmailInputLabelTemplate: Scalars['String']['input'];
  unsubscribePageInvalidEmailAddressMessageTemplate: Scalars['String']['input'];
  unsubscribePageSubmitButtonLabelTemplate: Scalars['String']['input'];
  unsubscribePageSubtitleTemplate: Scalars['String']['input'];
  unsubscribePageTitleTemplate: Scalars['String']['input'];
};


export type MutationCreateContactsGroupContactArgs = {
  contactEmailAddress: Scalars['String']['input'];
  contactsGroupId: Scalars['ID']['input'];
};


export type MutationCreateDomainNameVerificationArgs = {
  domainName: Scalars['String']['input'];
};


export type MutationCreateDuplicateTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateLayoutFromExistingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreatePlatformBillingPlanArgs = {
  tier: WaypointFeatureTier;
  token: Scalars['String']['input'];
};


export type MutationCreateSenderEmailAddressArgs = {
  domainNameVerificationId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type MutationCreateTemplateArgs = {
  type: WaypointTemplateType;
};


export type MutationCreateTemplateFromExistingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateTemplateFromSampleArgs = {
  sampleTemplateId: Scalars['ID']['input'];
};


export type MutationCreateTemplateSectionArgs = {
  name: Scalars['String']['input'];
};


export type MutationCreateWaypointTemplatePreviewArgs = {
  configuration: WaypointTemplateConfigurationInput;
  id: Scalars['ID']['input'];
  variables: Scalars['JSONObject']['input'];
};


export type MutationCreateWaypointTemplateUploadImageUrlArgs = {
  contentLength: Scalars['Int']['input'];
  mimeType: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateWorkflowPreviewArgs = {
  id: Scalars['ID']['input'];
  stepDefinitions: Array<WorkflowStepDefinitionInput>;
  variables: Scalars['JSONObject']['input'];
};


export type MutationCreateWorkflowRunCommandArgs = {
  commandName: WorkflowRunCommandName;
  workflowRunId: Scalars['ID']['input'];
};


export type MutationDeleteContactsGroupContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTemplateSectionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPreviewWaypointTemplateArgs = {
  configuration: WaypointTemplateConfigurationInput;
  variables: Scalars['JSONObject']['input'];
};


export type MutationRefreshWaypointTemplateImageStatusArgs = {
  waypointTemplateImageId: Scalars['ID']['input'];
};


export type MutationRequestDomainNameVerificationApprovalArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSendDnsInformationEmailMessageArgs = {
  id: Scalars['ID']['input'];
  toEmailAddress: Scalars['String']['input'];
};


export type MutationUpdateContactsGroupArgs = {
  id: Scalars['ID']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  unsubscribeLinkTemplate: Scalars['String']['input'];
  unsubscribePageConfirmationMessageTemplate: Scalars['String']['input'];
  unsubscribePageEmailInputLabelTemplate: Scalars['String']['input'];
  unsubscribePageInvalidEmailAddressMessageTemplate: Scalars['String']['input'];
  unsubscribePageSubmitButtonLabelTemplate: Scalars['String']['input'];
  unsubscribePageSubtitleTemplate: Scalars['String']['input'];
  unsubscribePageTitleTemplate: Scalars['String']['input'];
};


export type MutationUpdateEmailTemplateNameArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdatePlatformBillingInformationArgs = {
  billingEmailAddress: Scalars['String']['input'];
};


export type MutationUpdatePlatformBillingPlanArgs = {
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  tier: WaypointFeatureTier;
};


export type MutationUpdatePlatformSesEventTrackingArgs = {
  events: Array<SesEventName>;
};


export type MutationUpdateTemplateSectionArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateTemplateSectionsOrderArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationUpdateVerifiedEmailAddressArgs = {
  domainNameVerificationId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


export type MutationUpdateWaypointTemplateArgs = {
  configuration: WaypointTemplateConfigurationInput;
  defaultPreviewVariables: Scalars['JSONObject']['input'];
  id: Scalars['ID']['input'];
  testScenarios: Array<TestScenarioInput>;
};


export type MutationUpdateWaypointTemplateSectionArgs = {
  templateId: Scalars['ID']['input'];
  templateSectionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpdateWorkflowArgs = {
  id: Scalars['ID']['input'];
  stepDefinitions: Array<WorkflowStepDefinitionInput>;
  triggers: Array<WorkflowTriggerInput>;
};


export type MutationUpdateWorkflowNameArgs = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type PlatformBillingInformation = {
  __typename?: 'PlatformBillingInformation';
  activeWaypointTier: WaypointFeatureTier;
  billingEmailAddress?: Maybe<Scalars['String']['output']>;
  billingPaymentInstrumentsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
};

export type PlatformSesConfiguration = {
  __typename?: 'PlatformSesConfiguration';
  events: Array<SesEventName>;
  id: Scalars['ID']['output'];
};

export type PlatformUsageInformation = {
  __typename?: 'PlatformUsageInformation';
  baseTierLimit: Scalars['Int']['output'];
  overage: Scalars['Int']['output'];
  overageCostPerThousand: Scalars['Int']['output'];
  periodEnd: Scalars['Date']['output'];
  periodStart: Scalars['Date']['output'];
  totalUsage: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  ApiKeys: ApiKeyConnection;
  Contact: Contact;
  Contacts: ContactConnection;
  ContactsGroup: ContactsGroup;
  ContactsGroupContacts: ContactsGroupContactConnection;
  ContactsGroups: ContactsGroupConnection;
  DomainNameVerification: DomainNameVerification;
  DomainNameVerifications: DomainNameVerificationConnection;
  EmailMessage: EmailMessage;
  EmailMessageTimelineLogItems: TimelineLogItemConnection;
  EmailMessages: EmailMessageConnection;
  EmailTemplateHtmlPreview?: Maybe<Scalars['String']['output']>;
  PlatformBillingInformation: PlatformBillingInformation;
  PlatformSesConfiguration: PlatformSesConfiguration;
  RequestLog: RequestLog;
  RequestLogs: RequestLogConnection;
  SampleWaypointTemplates: WaypointTemplateConnection;
  TemplateSections: Array<TemplateSection>;
  VerifiedEmailAddresses: VerifiedEmailAddressConnection;
  WaypointTemplate: WaypointTemplate;
  WaypointTemplateImage: WaypointTemplateImage;
  WaypointTemplateImages: WaypointTemplateImageConnection;
  WaypointTemplates: WaypointTemplateConnection;
  WebhookEndpoints: WebhookEndpointConnection;
  Workflow: Workflow;
  WorkflowEvent: WorkflowEvent;
  WorkflowEvents: WorkflowEventConnection;
  WorkflowRunTimelineLogItems: TimelineLogItemConnection;
  Workflows: WorkflowConnection;
  currentPlatformUsageInformation?: Maybe<PlatformUsageInformation>;
  findOneContact: Contact;
};


export type QueryApiKeysArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactsGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsGroupContactsArgs = {
  contactsGroupId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryContactsGroupsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDomainNameVerificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDomainNameVerificationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEmailMessageTimelineLogItemsArgs = {
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEmailMessagesArgs = {
  filter?: InputMaybe<EmailMessagesFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<EmailMessagesSort>;
};


export type QueryEmailTemplateHtmlPreviewArgs = {
  id: Scalars['ID']['input'];
  type: EmailTemplateHtmlPreviewType;
};


export type QueryRequestLogArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRequestLogsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySampleWaypointTemplatesArgs = {
  filter?: InputMaybe<WaypointSampleTemplateFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVerifiedEmailAddressesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWaypointTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWaypointTemplateImageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWaypointTemplateImagesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWaypointTemplatesArgs = {
  filter?: InputMaybe<WaypointTemplateFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkflowEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWorkflowEventsArgs = {
  filter?: InputMaybe<WorkflowEventsFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkflowRunTimelineLogItemsArgs = {
  id: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWorkflowsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindOneContactArgs = {
  emailAddress: Scalars['String']['input'];
};

export type RequestLog = {
  __typename?: 'RequestLog';
  apiKeyId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  elapsed: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  method: Scalars['String']['output'];
  requestBody?: Maybe<Scalars['String']['output']>;
  requestHeaders: Scalars['JSONObject']['output'];
  responseBody: Scalars['String']['output'];
  statusCode: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export type RequestLogConnection = {
  __typename?: 'RequestLogConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<RequestLog>;
};

export type SendEmailTemplateMessageProperties = {
  __typename?: 'SendEmailTemplateMessageProperties';
  bccTemplate?: Maybe<Scalars['String']['output']>;
  ccTemplate?: Maybe<Scalars['String']['output']>;
  templateId: Scalars['ID']['output'];
  toTemplate: Scalars['String']['output'];
};

export type SendEmailTemplateMessagePropertiesInput = {
  bccTemplate?: InputMaybe<Scalars['String']['input']>;
  ccTemplate?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['ID']['input'];
  toTemplate: Scalars['String']['input'];
};

export type SendEmailTemplateMessageResult = {
  __typename?: 'SendEmailTemplateMessageResult';
  emailMessageId: Scalars['ID']['output'];
  templateId: Scalars['ID']['output'];
  templateVariables: Scalars['JSONObject']['output'];
};

export type SendMarkdownEmailMessageProperties = {
  __typename?: 'SendMarkdownEmailMessageProperties';
  bccTemplate?: Maybe<Scalars['String']['output']>;
  ccTemplate?: Maybe<Scalars['String']['output']>;
  fromTemplate?: Maybe<Scalars['String']['output']>;
  messageTemplate: Scalars['String']['output'];
  senderType: SendMarkdownEmailSenderType;
  senderVerifiedEmailAddressId?: Maybe<Scalars['ID']['output']>;
  subjectTemplate: Scalars['String']['output'];
  toTemplate: Scalars['String']['output'];
};

export type SendMarkdownEmailMessagePropertiesInput = {
  bccTemplate?: InputMaybe<Scalars['String']['input']>;
  ccTemplate?: InputMaybe<Scalars['String']['input']>;
  fromTemplate?: InputMaybe<Scalars['String']['input']>;
  messageTemplate: Scalars['String']['input'];
  senderType: SendMarkdownEmailSenderType;
  senderVerifiedEmailAddressId?: InputMaybe<Scalars['ID']['input']>;
  subjectTemplate: Scalars['String']['input'];
  toTemplate: Scalars['String']['input'];
};

export type SendMarkdownEmailMessageResult = {
  __typename?: 'SendMarkdownEmailMessageResult';
  emailMessageId: Scalars['ID']['output'];
};

export enum SendMarkdownEmailSenderType {
  Template = 'TEMPLATE',
  VerifiedEmailAddress = 'VERIFIED_EMAIL_ADDRESS'
}

export enum SesEventName {
  Click = 'CLICK',
  Open = 'OPEN'
}

export type SleepProperties = {
  __typename?: 'SleepProperties';
  timeAmount: Scalars['Int']['output'];
  timeUnit: SleepTimeUnits;
};

export type SleepPropertiesInput = {
  timeAmount: Scalars['Int']['input'];
  timeUnit: SleepTimeUnits;
};

export type SleepResult = {
  __typename?: 'SleepResult';
  wakeupCommandAt?: Maybe<Scalars['Date']['output']>;
  wakeupScheduledAt: Scalars['Date']['output'];
  wokeupAt?: Maybe<Scalars['Date']['output']>;
};

export enum SleepTimeUnits {
  Days = 'DAYS',
  Hours = 'HOURS',
  Minutes = 'MINUTES',
  Seconds = 'SECONDS',
  Weeks = 'WEEKS'
}

export type TemplateBlock = {
  __typename?: 'TemplateBlock';
  id: Scalars['ID']['output'];
  props: Scalars['JSONObject']['output'];
  sectionProps: BlockSectionProps;
  style: CssStyle;
  type: TemplateBlockType;
};

export type TemplateBlockInput = {
  id: Scalars['ID']['input'];
  props: Scalars['JSONObject']['input'];
  sectionProps: BlockSectionPropsInput;
  style: CssStyleInput;
  type: TemplateBlockType;
};

export enum TemplateBlockType {
  Avatar = 'Avatar',
  Button = 'Button',
  ColumnsSection = 'ColumnsSection',
  Container = 'Container',
  ContainerYield = 'ContainerYield',
  Divider = 'Divider',
  Heading = 'Heading',
  Html = 'Html',
  Image = 'Image',
  LoopContainer = 'LoopContainer',
  ProgressBar = 'ProgressBar',
  Spacer = 'Spacer',
  Text = 'Text'
}

export type TemplateSection = {
  __typename?: 'TemplateSection';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderIndex: Scalars['Int']['output'];
};

export type TestScenario = {
  __typename?: 'TestScenario';
  name: Scalars['String']['output'];
  variables: Scalars['JSONObject']['output'];
};

export type TestScenarioInput = {
  name: Scalars['String']['input'];
  variables: Scalars['JSONObject']['input'];
};

export type TimelineLogItem = {
  __typename?: 'TimelineLogItem';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  level: TimelineLogLevel;
  message: Scalars['String']['output'];
  messageKey: TimelineLogMessageKey;
  updatedAt: Scalars['Date']['output'];
};

export type TimelineLogItemConnection = {
  __typename?: 'TimelineLogItemConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<TimelineLogItem>;
};

export enum TimelineLogLevel {
  Error = 'ERROR',
  Info = 'INFO'
}

export enum TimelineLogMessageKey {
  EmailMessageBounceSesEvent = 'EMAIL_MESSAGE_BOUNCE_SES_EVENT',
  EmailMessageBounceSuppressed = 'EMAIL_MESSAGE_BOUNCE_SUPPRESSED',
  EmailMessageClickedSesEvent = 'EMAIL_MESSAGE_CLICKED_SES_EVENT',
  EmailMessageComplaintSesEvent = 'EMAIL_MESSAGE_COMPLAINT_SES_EVENT',
  EmailMessageComplaintSuppressed = 'EMAIL_MESSAGE_COMPLAINT_SUPPRESSED',
  EmailMessageContactUnsubscribed = 'EMAIL_MESSAGE_CONTACT_UNSUBSCRIBED',
  EmailMessageCreated = 'EMAIL_MESSAGE_CREATED',
  EmailMessageDeliveredSesEvent = 'EMAIL_MESSAGE_DELIVERED_SES_EVENT',
  EmailMessageEmptyRecipientsError = 'EMAIL_MESSAGE_EMPTY_RECIPIENTS_ERROR',
  EmailMessageHalted = 'EMAIL_MESSAGE_HALTED',
  EmailMessageInvalidDomainNameError = 'EMAIL_MESSAGE_INVALID_DOMAIN_NAME_ERROR',
  EmailMessageInvalidEmailAddressError = 'EMAIL_MESSAGE_INVALID_EMAIL_ADDRESS_ERROR',
  EmailMessageInvalidFileError = 'EMAIL_MESSAGE_INVALID_FILE_ERROR',
  EmailMessageInvalidParameterError = 'EMAIL_MESSAGE_INVALID_PARAMETER_ERROR',
  EmailMessageInvalidRecipientsError = 'EMAIL_MESSAGE_INVALID_RECIPIENTS_ERROR',
  EmailMessageInvalidSenderError = 'EMAIL_MESSAGE_INVALID_SENDER_ERROR',
  EmailMessageInvalidTestModeRecipientError = 'EMAIL_MESSAGE_INVALID_TEST_MODE_RECIPIENT_ERROR',
  EmailMessageOpenSesEvent = 'EMAIL_MESSAGE_OPEN_SES_EVENT',
  EmailMessagePaused = 'EMAIL_MESSAGE_PAUSED',
  EmailMessageRemovedOptOutRecipientEvent = 'EMAIL_MESSAGE_REMOVED_OPT_OUT_RECIPIENT_EVENT',
  EmailMessageRendered = 'EMAIL_MESSAGE_RENDERED',
  EmailMessageRenderError = 'EMAIL_MESSAGE_RENDER_ERROR',
  EmailMessageSenderNotApprovedError = 'EMAIL_MESSAGE_SENDER_NOT_APPROVED_ERROR',
  EmailMessageSendingDisabledError = 'EMAIL_MESSAGE_SENDING_DISABLED_ERROR',
  EmailMessageSentSandboxEvent = 'EMAIL_MESSAGE_SENT_SANDBOX_EVENT',
  EmailMessageSentSesEvent = 'EMAIL_MESSAGE_SENT_SES_EVENT',
  UnknownEmailMessageRenderError = 'UNKNOWN_EMAIL_MESSAGE_RENDER_ERROR',
  UnknownEmailMessageSendError = 'UNKNOWN_EMAIL_MESSAGE_SEND_ERROR'
}

export type VerifiedEmailAddress = {
  __typename?: 'VerifiedEmailAddress';
  createdAt: Scalars['Date']['output'];
  domainNameVerificationId?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  username: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type VerifiedEmailAddressConnection = {
  __typename?: 'VerifiedEmailAddressConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<VerifiedEmailAddress>;
};

export enum WaypointFeatureTier {
  Free = 'FREE',
  Growth = 'GROWTH',
  Pro = 'PRO',
  Sample = 'SAMPLE',
  Sandbox = 'SANDBOX',
  Starter = 'STARTER',
  Unlimited = 'UNLIMITED'
}

export type WaypointMessage = {
  __typename?: 'WaypointMessage';
  bcc?: Maybe<Scalars['String']['output']>;
  bodyHtml?: Maybe<Scalars['String']['output']>;
  bodyText?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  preheader?: Maybe<Scalars['String']['output']>;
  replyTo?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type WaypointMessageInput = {
  bcc?: InputMaybe<Scalars['String']['input']>;
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  bodyText?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type WaypointSampleTemplateFilterInput = {
  type?: InputMaybe<WaypointTemplateType>;
};

export type WaypointTemplate = {
  __typename?: 'WaypointTemplate';
  activeConfiguration: WaypointTemplateConfiguration;
  createdAt: Scalars['Date']['output'];
  defaultPreviewVariables: Scalars['JSONObject']['output'];
  eventsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastEventAt?: Maybe<Scalars['Date']['output']>;
  lastPublishedAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  nonPreviewEventsCount: Scalars['Int']['output'];
  sectionId?: Maybe<Scalars['String']['output']>;
  status: WaypointTemplateStatus;
  testScenarios?: Maybe<Array<TestScenario>>;
  type: WaypointTemplateType;
  updatedAt: Scalars['Date']['output'];
};

export type WaypointTemplateConfiguration = {
  __typename?: 'WaypointTemplateConfiguration';
  backdropStyle: CssStyle;
  blocks: Array<TemplateBlock>;
  canvasStyle: CssStyle;
  layoutId?: Maybe<Scalars['ID']['output']>;
  legacyTemplatesEnabled: Scalars['Boolean']['output'];
  linkStyle: CssStyle;
  preheaderTemplate?: Maybe<Scalars['String']['output']>;
  rawHtml?: Maybe<Scalars['String']['output']>;
  rawSubject?: Maybe<Scalars['String']['output']>;
  senderVerifiedEmailAddressId?: Maybe<Scalars['ID']['output']>;
  strictVariablesRendering: Scalars['Boolean']['output'];
  subjectTemplate: Scalars['String']['output'];
};

export type WaypointTemplateConfigurationInput = {
  backdropStyle: CssStyleInput;
  blocks: Array<TemplateBlockInput>;
  canvasStyle: CssStyleInput;
  layoutId?: InputMaybe<Scalars['ID']['input']>;
  legacyTemplatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  linkStyle: CssStyleInput;
  preheaderTemplate?: InputMaybe<Scalars['String']['input']>;
  senderVerifiedEmailAddressId?: InputMaybe<Scalars['ID']['input']>;
  strictVariablesRendering: Scalars['Boolean']['input'];
  subjectTemplate: Scalars['String']['input'];
};

export type WaypointTemplateConnection = {
  __typename?: 'WaypointTemplateConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<WaypointTemplate>;
};

export type WaypointTemplateFilterInput = {
  type?: InputMaybe<WaypointTemplateType>;
};

export type WaypointTemplateImage = {
  __typename?: 'WaypointTemplateImage';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  signedS3UploadUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  uploadStatus: WaypointTemplateImageUploadStatus;
  url: Scalars['String']['output'];
};

export type WaypointTemplateImageConnection = {
  __typename?: 'WaypointTemplateImageConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<WaypointTemplateImage>;
};

export enum WaypointTemplateImageUploadStatus {
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED'
}

export enum WaypointTemplateStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Sample = 'SAMPLE'
}

export enum WaypointTemplateType {
  Layout = 'LAYOUT',
  Template = 'TEMPLATE'
}

export type WebhookEndpoint = {
  __typename?: 'WebhookEndpoint';
  createdAt: Scalars['Date']['output'];
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

export type WebhookEndpointConnection = {
  __typename?: 'WebhookEndpointConnection';
  count: Scalars['Int']['output'];
  nodes: Array<WebhookEndpoint>;
};

export type WebhookProperties = {
  __typename?: 'WebhookProperties';
  key?: Maybe<Scalars['String']['output']>;
};

export type WebhookWorkflowTriggerInput = {
  key?: InputMaybe<Scalars['String']['input']>;
};

export type Workflow = {
  __typename?: 'Workflow';
  archivedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  lastRunAt?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  runsCount: Scalars['Int']['output'];
  stepDefinitions: Array<WorkflowStepDefinition>;
  triggers: Array<WorkflowTrigger>;
  updatedAt: Scalars['Date']['output'];
};

export type WorkflowConnection = {
  __typename?: 'WorkflowConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<Workflow>;
};

export type WorkflowEvent = {
  __typename?: 'WorkflowEvent';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  metaId?: Maybe<Scalars['ID']['output']>;
  source: WorkflowEventSource;
  status: WorkflowEventStatus;
  steps: Array<WorkflowStep>;
  updatedAt: Scalars['Date']['output'];
  variables?: Maybe<Scalars['JSONObject']['output']>;
  workflowId?: Maybe<Scalars['ID']['output']>;
  workflowKey?: Maybe<Scalars['String']['output']>;
};

export type WorkflowEventConnection = {
  __typename?: 'WorkflowEventConnection';
  count: Scalars['Int']['output'];
  meta: ConnectionMeta;
  nodes: Array<WorkflowEvent>;
};

export enum WorkflowEventSource {
  Api = 'API',
  Preview = 'PREVIEW',
  SandboxApi = 'SANDBOX_API',
  Trigger = 'TRIGGER'
}

export enum WorkflowEventStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED'
}

export type WorkflowEventsFilterInput = {
  workflowId?: InputMaybe<Scalars['ID']['input']>;
};

export type WorkflowRunCommand = {
  __typename?: 'WorkflowRunCommand';
  commandName: WorkflowRunCommandName;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum WorkflowRunCommandName {
  Cancel = 'CANCEL',
  WakeUp = 'WAKE_UP'
}

export type WorkflowStep = {
  __typename?: 'WorkflowStep';
  canceledAt?: Maybe<Scalars['Date']['output']>;
  definition: WorkflowStepDefinition;
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['Date']['output']>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  result?: Maybe<WorkflowStepResult>;
  skippedAt?: Maybe<Scalars['Date']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: WorkflowStepStatus;
};

export type WorkflowStepDefinition = {
  __typename?: 'WorkflowStepDefinition';
  disabled: Scalars['Boolean']['output'];
  sendEmailTemplateMessage?: Maybe<SendEmailTemplateMessageProperties>;
  sendMarkdownEmailMessage?: Maybe<SendMarkdownEmailMessageProperties>;
  sleep?: Maybe<SleepProperties>;
};

export type WorkflowStepDefinitionInput = {
  disabled: Scalars['Boolean']['input'];
  sendEmailTemplateMessage?: InputMaybe<SendEmailTemplateMessagePropertiesInput>;
  sendMarkdownEmailMessage?: InputMaybe<SendMarkdownEmailMessagePropertiesInput>;
  sleep?: InputMaybe<SleepPropertiesInput>;
};

export type WorkflowStepResult = {
  __typename?: 'WorkflowStepResult';
  sendEmailTemplateMessage?: Maybe<SendEmailTemplateMessageResult>;
  sendMarkdownEmailMessage?: Maybe<SendMarkdownEmailMessageResult>;
  sleep?: Maybe<SleepResult>;
};

export enum WorkflowStepStatus {
  Canceled = 'CANCELED',
  Disabled = 'DISABLED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED'
}

export type WorkflowTrigger = {
  __typename?: 'WorkflowTrigger';
  httpPost?: Maybe<HttpPostTriggerProperties>;
  workflowKey?: Maybe<WebhookProperties>;
};

export type WorkflowTriggerInput = {
  httpPost?: InputMaybe<HttpPostTriggerPropertiesInput>;
  workflowKey?: InputMaybe<WebhookWorkflowTriggerInput>;
};

export type FContactFragment = { __typename?: 'Contact', id: string, createdAt: any, updatedAt: any, emailAddress: string, name?: string | null, lastEmailMessageAt?: any | null, emailMessagesCount: number };

export type FContactsGroupFragment = { __typename?: 'ContactsGroup', id: string, createdAt: any, updatedAt: any, name: string, key?: string | null, optPolicy: ContactListOptPolicy, unsubscribeLinkTemplate: string, unsubscribePageTitleTemplate: string, unsubscribePageSubtitleTemplate: string, unsubscribePageEmailInputLabelTemplate: string, unsubscribePageSubmitButtonLabelTemplate: string, unsubscribePageConfirmationMessageTemplate: string, unsubscribePageInvalidEmailAddressMessageTemplate: string };

export type FContactsGroupContactFragment = { __typename?: 'ContactsGroupContact', id: string, createdAt: any, updatedAt: any, contactEmailAddress: string, contactId: string, contactsGroupId: string };

export type FCssStyleFragment = { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null };

export type FDomainNameVerificationFragment = { __typename?: 'DomainNameVerification', id: string, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, verificationDnsRecords: Array<{ __typename?: 'DomainNameVerificationDnsRecord', name: string, type: string, value: string }> };

export type FDomainNameVerificationRecordsFragment = { __typename?: 'DomainNameVerification', verificationDnsRecords: Array<{ __typename?: 'DomainNameVerificationDnsRecord', name: string, value: string, type: string, isPresent: boolean }>, mailFromConfiguration?: { __typename?: 'DomainNameMailFromConfiguration', subdomain: string, domain: string, status: string, records: Array<{ __typename?: 'DomainNameVerificationDnsRecord', type: string, name: string, value: string, isPresent: boolean }> } | null };

export type FEmailMessageLightFragment = { __typename?: 'EmailMessage', id: string, createdAt: any, updatedAt: any, metaId?: string | null, metadata: any, status: EmailMessageStatus, source: EmailMessageSource, processedAt?: any | null, waypointTemplateId?: string | null, sourceWorkflowRunId?: string | null, sourceEmailMessagesBatchId?: string | null, contactsGroupId?: string | null, logExpirationStatus?: EmailMessageLogExpirationStatus | null, renderError?: { __typename?: 'EmailMessageRenderError', message: string, template: string, variables?: any | null } | null, message: { __typename?: 'WaypointMessage', from?: string | null, to?: string | null } };

export type FEmailMessageFragment = { __typename?: 'EmailMessage', variables?: any | null, id: string, createdAt: any, updatedAt: any, metaId?: string | null, metadata: any, status: EmailMessageStatus, source: EmailMessageSource, processedAt?: any | null, waypointTemplateId?: string | null, sourceWorkflowRunId?: string | null, sourceEmailMessagesBatchId?: string | null, contactsGroupId?: string | null, logExpirationStatus?: EmailMessageLogExpirationStatus | null, message: { __typename?: 'WaypointMessage', from?: string | null, to?: string | null, cc?: string | null, bcc?: string | null, replyTo?: string | null, subject?: string | null, bodyHtml?: string | null, bodyText?: string | null, preheader?: string | null }, attachments: Array<{ __typename?: 'EmailMessageAttachment', name: string, contentBytesSize: number, contentType: string }>, renderError?: { __typename?: 'EmailMessageRenderError', message: string, template: string, variables?: any | null } | null };

export type FPlatformBillingInformationFragment = { __typename?: 'PlatformBillingInformation', id: string, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier, billingPaymentInstrumentsCount: number };

export type FPlatformSesConfigurationFragment = { __typename?: 'PlatformSesConfiguration', id: string, events: Array<SesEventName> };

export type FRequestLogFragment = { __typename?: 'RequestLog', id: string, createdAt: any, updatedAt: any, apiKeyId?: string | null, url: string, method: string, elapsed: number, statusCode: number, requestHeaders: any, requestBody?: string | null, responseBody: string };

export type FTemplateSectionFragment = { __typename?: 'TemplateSection', id: string, name: string, orderIndex: number };

export type FTimelineLogItemFragment = { __typename?: 'TimelineLogItem', id: string, createdAt: any, level: TimelineLogLevel, messageKey: TimelineLogMessageKey, message: string };

export type FVerifiedEmailAddressFragment = { __typename?: 'VerifiedEmailAddress', id: string, createdAt: any, value: string, name?: string | null, emailAddress: string, domainNameVerificationId?: string | null, username: string };

export type FWaypointMessageFragment = { __typename?: 'WaypointMessage', to?: string | null, cc?: string | null, bcc?: string | null, replyTo?: string | null, from?: string | null, subject?: string | null, bodyHtml?: string | null, bodyText?: string | null, preheader?: string | null };

export type FWaypointTemplateFragment = { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } };

export type FWaypointTemplateConfigurationFragment = { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } };

export type FWaypointTemplateCountsFragment = { __typename?: 'WaypointTemplate', id: string, lastEventAt?: any | null, eventsCount: number, nonPreviewEventsCount: number };

export type FWaypointTemplateImageFragment = { __typename?: 'WaypointTemplateImage', id: string, createdAt: any, updatedAt: any, uploadStatus: WaypointTemplateImageUploadStatus, url: string, signedS3UploadUrl?: string | null };

export type FWebhookEndpointFragment = { __typename?: 'WebhookEndpoint', id: string, createdAt: any, updatedAt: any, name: string, url: string, disabled: boolean };

export type FWorkflowTriggerFragment = { __typename?: 'WorkflowTrigger', workflowKey?: { __typename?: 'WebhookProperties', key?: string | null } | null, httpPost?: { __typename?: 'HttpPostTriggerProperties', token: string } | null };

export type FWorkflowFragment = { __typename?: 'Workflow', id: string, createdAt: any, updatedAt: any, archivedAt?: any | null, name: string, triggers: Array<{ __typename?: 'WorkflowTrigger', workflowKey?: { __typename?: 'WebhookProperties', key?: string | null } | null, httpPost?: { __typename?: 'HttpPostTriggerProperties', token: string } | null }>, stepDefinitions: Array<{ __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }> };

export type FWorkflowStatisticsFragment = { __typename?: 'Workflow', lastRunAt?: any | null, runsCount: number };

export type FWorkflowEventFragment = { __typename?: 'WorkflowEvent', id: string, createdAt: any, updatedAt: any, status: WorkflowEventStatus, source: WorkflowEventSource, metaId?: string | null, workflowId?: string | null, workflowKey?: string | null, variables?: any | null, steps: Array<{ __typename?: 'WorkflowStep', startedAt?: any | null, skippedAt?: any | null, finishedAt?: any | null, canceledAt?: any | null, failedAt?: any | null, status: WorkflowStepStatus, errorMessage?: string | null, definition: { __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }, result?: { __typename?: 'WorkflowStepResult', sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageResult', emailMessageId: string, templateId: string, templateVariables: any } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageResult', emailMessageId: string } | null, sleep?: { __typename?: 'SleepResult', wakeupScheduledAt: any, wakeupCommandAt?: any | null, wokeupAt?: any | null } | null } | null }> };

export type FWorkflowRunCommandFragment = { __typename?: 'WorkflowRunCommand', id: string, createdAt: any, updatedAt: any, commandName: WorkflowRunCommandName };

export type FWorkflowStepFragment = { __typename?: 'WorkflowStep', startedAt?: any | null, skippedAt?: any | null, finishedAt?: any | null, canceledAt?: any | null, failedAt?: any | null, status: WorkflowStepStatus, errorMessage?: string | null, definition: { __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }, result?: { __typename?: 'WorkflowStepResult', sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageResult', emailMessageId: string, templateId: string, templateVariables: any } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageResult', emailMessageId: string } | null, sleep?: { __typename?: 'SleepResult', wakeupScheduledAt: any, wakeupCommandAt?: any | null, wokeupAt?: any | null } | null } | null };

export type FWorkflowStepDefinitionFragment = { __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null };

export type ArchiveWaypointTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveWaypointTemplateMutation = { __typename?: 'Mutation', archiveWaypointTemplate: { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } } };

export type ArchiveWorkflowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveWorkflowMutation = { __typename?: 'Mutation', archiveWorkflow: { __typename?: 'Workflow', id: string, createdAt: any, updatedAt: any, archivedAt?: any | null, name: string, triggers: Array<{ __typename?: 'WorkflowTrigger', workflowKey?: { __typename?: 'WebhookProperties', key?: string | null } | null, httpPost?: { __typename?: 'HttpPostTriggerProperties', token: string } | null }>, stepDefinitions: Array<{ __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }> } };

export type CreateApiKeyMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'CreatedApiKey', id: string, name: string, password: string } };

export type CreateContactsGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  unsubscribeLinkTemplate: Scalars['String']['input'];
  unsubscribePageTitleTemplate: Scalars['String']['input'];
  unsubscribePageSubtitleTemplate: Scalars['String']['input'];
  unsubscribePageEmailInputLabelTemplate: Scalars['String']['input'];
  unsubscribePageSubmitButtonLabelTemplate: Scalars['String']['input'];
  unsubscribePageConfirmationMessageTemplate: Scalars['String']['input'];
  unsubscribePageInvalidEmailAddressMessageTemplate: Scalars['String']['input'];
}>;


export type CreateContactsGroupMutation = { __typename?: 'Mutation', createContactsGroup: { __typename?: 'ContactsGroup', id: string, createdAt: any, updatedAt: any, name: string, key?: string | null, optPolicy: ContactListOptPolicy, unsubscribeLinkTemplate: string, unsubscribePageTitleTemplate: string, unsubscribePageSubtitleTemplate: string, unsubscribePageEmailInputLabelTemplate: string, unsubscribePageSubmitButtonLabelTemplate: string, unsubscribePageConfirmationMessageTemplate: string, unsubscribePageInvalidEmailAddressMessageTemplate: string } };

export type CreateContactsGroupContactMutationVariables = Exact<{
  contactsGroupId: Scalars['ID']['input'];
  contactEmailAddress: Scalars['String']['input'];
}>;


export type CreateContactsGroupContactMutation = { __typename?: 'Mutation', createContactsGroupContact: { __typename?: 'ContactsGroupContact', id: string, createdAt: any, updatedAt: any, contactEmailAddress: string, contactId: string, contactsGroupId: string } };

export type CreateDomainNameVerificationMutationVariables = Exact<{
  domainName: Scalars['String']['input'];
}>;


export type CreateDomainNameVerificationMutation = { __typename?: 'Mutation', createDomainNameVerification: { __typename?: 'DomainNameVerification', id: string, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, verificationDnsRecords: Array<{ __typename?: 'DomainNameVerificationDnsRecord', name: string, type: string, value: string }> } };

export type CreateSenderEmailAddressMutationVariables = Exact<{
  domainNameVerificationId: Scalars['ID']['input'];
  username: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateSenderEmailAddressMutation = { __typename?: 'Mutation', createSenderEmailAddress: { __typename?: 'VerifiedEmailAddress', id: string, createdAt: any, value: string, name?: string | null, emailAddress: string, domainNameVerificationId?: string | null, username: string } };

export type CreateStripeCustomerPortalUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateStripeCustomerPortalUrlMutation = { __typename?: 'Mutation', createStripeCustomerPortalUrl?: string | null };

export type CreateSvixCustomerPortalUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateSvixCustomerPortalUrlMutation = { __typename?: 'Mutation', createSvixCustomerPortalUrl: string };

export type CreateTemplateSectionMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type CreateTemplateSectionMutation = { __typename?: 'Mutation', createTemplateSection: { __typename?: 'TemplateSection', id: string, name: string, orderIndex: number } };

export type CreateTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createTemplate: { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } } };

export type CreateLayoutTemplateMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateLayoutTemplateMutation = { __typename?: 'Mutation', createTemplate: { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } } };

export type CreateDuplicateTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreateDuplicateTemplateMutation = { __typename?: 'Mutation', createDuplicateTemplate: { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } } };

export type CreateTemplateFromSampleMutationVariables = Exact<{
  sampleTemplateId: Scalars['ID']['input'];
}>;


export type CreateTemplateFromSampleMutation = { __typename?: 'Mutation', createTemplateFromSample: { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } } };

export type CreateTemplateFromExistingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreateTemplateFromExistingMutation = { __typename?: 'Mutation', createTemplateFromExisting: { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } } };

export type CreateLayoutFromExistingMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreateLayoutFromExistingMutation = { __typename?: 'Mutation', createLayoutFromExisting: { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } } };

export type CreateWaypointTemplatePreviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  variables: Scalars['JSONObject']['input'];
  configuration: WaypointTemplateConfigurationInput;
}>;


export type CreateWaypointTemplatePreviewMutation = { __typename?: 'Mutation', createWaypointTemplatePreview: { __typename?: 'EmailMessage', variables?: any | null, id: string, createdAt: any, updatedAt: any, metaId?: string | null, metadata: any, status: EmailMessageStatus, source: EmailMessageSource, processedAt?: any | null, waypointTemplateId?: string | null, sourceWorkflowRunId?: string | null, sourceEmailMessagesBatchId?: string | null, contactsGroupId?: string | null, logExpirationStatus?: EmailMessageLogExpirationStatus | null, message: { __typename?: 'WaypointMessage', from?: string | null, to?: string | null, cc?: string | null, bcc?: string | null, replyTo?: string | null, subject?: string | null, bodyHtml?: string | null, bodyText?: string | null, preheader?: string | null }, attachments: Array<{ __typename?: 'EmailMessageAttachment', name: string, contentBytesSize: number, contentType: string }>, renderError?: { __typename?: 'EmailMessageRenderError', message: string, template: string, variables?: any | null } | null } };

export type CreateWaypointTemplateUploadImageUrlMutationVariables = Exact<{
  name: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  contentLength: Scalars['Int']['input'];
}>;


export type CreateWaypointTemplateUploadImageUrlMutation = { __typename?: 'Mutation', createWaypointTemplateUploadImageUrl: { __typename?: 'WaypointTemplateImage', id: string, createdAt: any, updatedAt: any, uploadStatus: WaypointTemplateImageUploadStatus, url: string, signedS3UploadUrl?: string | null } };

export type CreateWorkflowMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateWorkflowMutation = { __typename?: 'Mutation', createWorkflow: { __typename?: 'Workflow', id: string, createdAt: any, updatedAt: any, archivedAt?: any | null, name: string, triggers: Array<{ __typename?: 'WorkflowTrigger', workflowKey?: { __typename?: 'WebhookProperties', key?: string | null } | null, httpPost?: { __typename?: 'HttpPostTriggerProperties', token: string } | null }>, stepDefinitions: Array<{ __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }> } };

export type CreateWorkflowPreviewMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  variables: Scalars['JSONObject']['input'];
  stepDefinitions: Array<WorkflowStepDefinitionInput> | WorkflowStepDefinitionInput;
}>;


export type CreateWorkflowPreviewMutation = { __typename?: 'Mutation', createWorkflowPreview: { __typename?: 'WorkflowEvent', id: string, createdAt: any, updatedAt: any, status: WorkflowEventStatus, source: WorkflowEventSource, metaId?: string | null, workflowId?: string | null, workflowKey?: string | null, variables?: any | null, steps: Array<{ __typename?: 'WorkflowStep', startedAt?: any | null, skippedAt?: any | null, finishedAt?: any | null, canceledAt?: any | null, failedAt?: any | null, status: WorkflowStepStatus, errorMessage?: string | null, definition: { __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }, result?: { __typename?: 'WorkflowStepResult', sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageResult', emailMessageId: string, templateId: string, templateVariables: any } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageResult', emailMessageId: string } | null, sleep?: { __typename?: 'SleepResult', wakeupScheduledAt: any, wakeupCommandAt?: any | null, wokeupAt?: any | null } | null } | null }> } };

export type CreateWorkflowRunCommandMutationVariables = Exact<{
  workflowRunId: Scalars['ID']['input'];
  commandName: WorkflowRunCommandName;
}>;


export type CreateWorkflowRunCommandMutation = { __typename?: 'Mutation', createWorkflowRunCommand: { __typename?: 'WorkflowRunCommand', id: string, createdAt: any, updatedAt: any, commandName: WorkflowRunCommandName } };

export type DeleteContactsGroupContactMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteContactsGroupContactMutation = { __typename?: 'Mutation', deleteContactsGroupContact: boolean };

export type DeleteTemplateSectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTemplateSectionMutation = { __typename?: 'Mutation', deleteTemplateSection: boolean };

export type PreviewWaypointTemplateMutationVariables = Exact<{
  variables: Scalars['JSONObject']['input'];
  configuration: WaypointTemplateConfigurationInput;
}>;


export type PreviewWaypointTemplateMutation = { __typename?: 'Mutation', previewWaypointTemplate: { __typename?: 'WaypointMessage', to?: string | null, cc?: string | null, bcc?: string | null, replyTo?: string | null, from?: string | null, subject?: string | null, bodyHtml?: string | null, bodyText?: string | null, preheader?: string | null } };

export type RefreshWaypointTemplateImageStatusMutationVariables = Exact<{
  waypointTemplateImageId: Scalars['ID']['input'];
}>;


export type RefreshWaypointTemplateImageStatusMutation = { __typename?: 'Mutation', refreshWaypointTemplateImageStatus: { __typename?: 'WaypointTemplateImage', id: string, createdAt: any, updatedAt: any, uploadStatus: WaypointTemplateImageUploadStatus, url: string, signedS3UploadUrl?: string | null } };

export type RequestDomainNameVerificationApprovalMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RequestDomainNameVerificationApprovalMutation = { __typename?: 'Mutation', requestDomainNameVerificationApproval: { __typename?: 'DomainNameVerification', id: string, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, verificationDnsRecords: Array<{ __typename?: 'DomainNameVerificationDnsRecord', name: string, type: string, value: string }> } };

export type RequestPlatformDeleteMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestPlatformDeleteMutation = { __typename?: 'Mutation', requestPlatformDelete: boolean };

export type SendDnsInformationEmailMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  toEmailAddress: Scalars['String']['input'];
}>;


export type SendDnsInformationEmailMessageMutation = { __typename?: 'Mutation', sendDnsInformationEmailMessage: { __typename?: 'DomainNameVerification', id: string, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, verificationDnsRecords: Array<{ __typename?: 'DomainNameVerificationDnsRecord', name: string, type: string, value: string }> } };

export type UpdateContactsGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  key?: InputMaybe<Scalars['String']['input']>;
  unsubscribeLinkTemplate: Scalars['String']['input'];
  unsubscribePageTitleTemplate: Scalars['String']['input'];
  unsubscribePageSubtitleTemplate: Scalars['String']['input'];
  unsubscribePageEmailInputLabelTemplate: Scalars['String']['input'];
  unsubscribePageSubmitButtonLabelTemplate: Scalars['String']['input'];
  unsubscribePageConfirmationMessageTemplate: Scalars['String']['input'];
  unsubscribePageInvalidEmailAddressMessageTemplate: Scalars['String']['input'];
}>;


export type UpdateContactsGroupMutation = { __typename?: 'Mutation', updateContactsGroup: { __typename?: 'ContactsGroup', id: string, createdAt: any, updatedAt: any, name: string, key?: string | null, optPolicy: ContactListOptPolicy, unsubscribeLinkTemplate: string, unsubscribePageTitleTemplate: string, unsubscribePageSubtitleTemplate: string, unsubscribePageEmailInputLabelTemplate: string, unsubscribePageSubmitButtonLabelTemplate: string, unsubscribePageConfirmationMessageTemplate: string, unsubscribePageInvalidEmailAddressMessageTemplate: string } };

export type UpdateEmailTemplateNameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateEmailTemplateNameMutation = { __typename?: 'Mutation', updateEmailTemplateName: { __typename?: 'WaypointTemplate', id: string, name: string } };

export type UpdatePlatformBillingInformationMutationVariables = Exact<{
  billingEmailAddress: Scalars['String']['input'];
}>;


export type UpdatePlatformBillingInformationMutation = { __typename?: 'Mutation', updatePlatformBillingInformation: { __typename?: 'PlatformBillingInformation', id: string, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier, billingPaymentInstrumentsCount: number } };

export type UpdatePlatformBillingPlanMutationVariables = Exact<{
  tier: WaypointFeatureTier;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdatePlatformBillingPlanMutation = { __typename?: 'Mutation', updatePlatformBillingPlan: { __typename?: 'PlatformBillingInformation', id: string, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier, billingPaymentInstrumentsCount: number } };

export type UpdatePlatformSesEventTrackingMutationVariables = Exact<{
  events: Array<SesEventName> | SesEventName;
}>;


export type UpdatePlatformSesEventTrackingMutation = { __typename?: 'Mutation', updatePlatformSesEventTracking: { __typename?: 'PlatformSesConfiguration', id: string, events: Array<SesEventName> } };

export type UpdateTemplateSectionsOrderMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateTemplateSectionsOrderMutation = { __typename?: 'Mutation', updateTemplateSectionsOrder: Array<{ __typename?: 'TemplateSection', id: string, name: string, orderIndex: number }> };

export type UpdateTemplateSectionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateTemplateSectionMutation = { __typename?: 'Mutation', updateTemplateSection: { __typename?: 'TemplateSection', id: string, name: string, orderIndex: number } };

export type UpdateVerifiedEmailAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  domainNameVerificationId: Scalars['ID']['input'];
}>;


export type UpdateVerifiedEmailAddressMutation = { __typename?: 'Mutation', updateVerifiedEmailAddress: { __typename?: 'VerifiedEmailAddress', id: string, createdAt: any, value: string, name?: string | null, emailAddress: string, domainNameVerificationId?: string | null, username: string } };

export type UpdateWaypointTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  testScenarios: Array<TestScenarioInput> | TestScenarioInput;
  defaultPreviewVariables: Scalars['JSONObject']['input'];
  configuration: WaypointTemplateConfigurationInput;
}>;


export type UpdateWaypointTemplateMutation = { __typename?: 'Mutation', updateWaypointTemplate: { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } } };

export type UpdateWaypointTemplateSectionMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
  templateSectionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpdateWaypointTemplateSectionMutation = { __typename?: 'Mutation', updateWaypointTemplateSection: { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } } };

export type UpdateWorkflowMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  triggers: Array<WorkflowTriggerInput> | WorkflowTriggerInput;
  stepDefinitions: Array<WorkflowStepDefinitionInput> | WorkflowStepDefinitionInput;
}>;


export type UpdateWorkflowMutation = { __typename?: 'Mutation', updateWorkflow: { __typename?: 'Workflow', id: string, createdAt: any, updatedAt: any, archivedAt?: any | null, name: string, triggers: Array<{ __typename?: 'WorkflowTrigger', workflowKey?: { __typename?: 'WebhookProperties', key?: string | null } | null, httpPost?: { __typename?: 'HttpPostTriggerProperties', token: string } | null }>, stepDefinitions: Array<{ __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }> } };

export type UpdateWorkflowNameMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type UpdateWorkflowNameMutation = { __typename?: 'Mutation', updateWorkflowName: { __typename?: 'Workflow', id: string, name: string } };

export type ApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeysQuery = { __typename?: 'Query', ApiKeys: { __typename?: 'ApiKeyConnection', count: number, nodes: Array<{ __typename?: 'ApiKey', id: string, name: string }> } };

export type ContactQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactQuery = { __typename?: 'Query', Contact: { __typename?: 'Contact', id: string, createdAt: any, updatedAt: any, emailAddress: string, name?: string | null, lastEmailMessageAt?: any | null, emailMessagesCount: number } };

export type ContactByEmailAddressQueryVariables = Exact<{
  emailAddress: Scalars['String']['input'];
}>;


export type ContactByEmailAddressQuery = { __typename?: 'Query', findOneContact: { __typename?: 'Contact', id: string, createdAt: any, updatedAt: any, emailAddress: string, name?: string | null, lastEmailMessageAt?: any | null, emailMessagesCount: number } };

export type ContactsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactsQuery = { __typename?: 'Query', Contacts: { __typename?: 'ContactConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'Contact', id: string, createdAt: any, updatedAt: any, emailAddress: string, name?: string | null, lastEmailMessageAt?: any | null, emailMessagesCount: number }> } };

export type ContactsGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContactsGroupQuery = { __typename?: 'Query', ContactsGroup: { __typename?: 'ContactsGroup', id: string, createdAt: any, updatedAt: any, name: string, key?: string | null, optPolicy: ContactListOptPolicy, unsubscribeLinkTemplate: string, unsubscribePageTitleTemplate: string, unsubscribePageSubtitleTemplate: string, unsubscribePageEmailInputLabelTemplate: string, unsubscribePageSubmitButtonLabelTemplate: string, unsubscribePageConfirmationMessageTemplate: string, unsubscribePageInvalidEmailAddressMessageTemplate: string } };

export type ContactsGroupContactsQueryVariables = Exact<{
  contactsGroupId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactsGroupContactsQuery = { __typename?: 'Query', ContactsGroupContacts: { __typename?: 'ContactsGroupContactConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'ContactsGroupContact', id: string, createdAt: any, updatedAt: any, contactEmailAddress: string, contactId: string, contactsGroupId: string }> } };

export type ContactsGroupsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContactsGroupsQuery = { __typename?: 'Query', ContactsGroups: { __typename?: 'ContactsGroupConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'ContactsGroup', id: string, createdAt: any, updatedAt: any, name: string, key?: string | null, optPolicy: ContactListOptPolicy, unsubscribeLinkTemplate: string, unsubscribePageTitleTemplate: string, unsubscribePageSubtitleTemplate: string, unsubscribePageEmailInputLabelTemplate: string, unsubscribePageSubmitButtonLabelTemplate: string, unsubscribePageConfirmationMessageTemplate: string, unsubscribePageInvalidEmailAddressMessageTemplate: string }> } };

export type CurrentPlatformUsageInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentPlatformUsageInformationQuery = { __typename?: 'Query', currentPlatformUsageInformation?: { __typename?: 'PlatformUsageInformation', totalUsage: number, baseTierLimit: number, overage: number, overageCostPerThousand: number, periodStart: any, periodEnd: any } | null };

export type DomainNameVerificationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DomainNameVerificationQuery = { __typename?: 'Query', DomainNameVerification: { __typename?: 'DomainNameVerification', id: string, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, verificationDnsRecords: Array<{ __typename?: 'DomainNameVerificationDnsRecord', name: string, type: string, value: string, isPresent: boolean }>, mailFromConfiguration?: { __typename?: 'DomainNameMailFromConfiguration', subdomain: string, domain: string, status: string, records: Array<{ __typename?: 'DomainNameVerificationDnsRecord', type: string, name: string, value: string, isPresent: boolean }> } | null } };

export type DomainNameVerificationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DomainNameVerificationsQuery = { __typename?: 'Query', DomainNameVerifications: { __typename?: 'DomainNameVerificationConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'DomainNameVerification', id: string, domainName: string, status: DomainNameVerificationStatus, approvalStatus: DomainNameApprovalStatus, verificationDnsRecords: Array<{ __typename?: 'DomainNameVerificationDnsRecord', name: string, type: string, value: string }> }> } };

export type EmailMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmailMessageQuery = { __typename?: 'Query', EmailMessage: { __typename?: 'EmailMessage', id: string, variables?: any | null, createdAt: any, updatedAt: any, metaId?: string | null, metadata: any, status: EmailMessageStatus, source: EmailMessageSource, processedAt?: any | null, waypointTemplateId?: string | null, sourceWorkflowRunId?: string | null, sourceEmailMessagesBatchId?: string | null, contactsGroupId?: string | null, logExpirationStatus?: EmailMessageLogExpirationStatus | null, message: { __typename?: 'WaypointMessage', from?: string | null, to?: string | null, cc?: string | null, bcc?: string | null, replyTo?: string | null, subject?: string | null, bodyHtml?: string | null, bodyText?: string | null, preheader?: string | null }, attachments: Array<{ __typename?: 'EmailMessageAttachment', name: string, contentBytesSize: number, contentType: string }>, renderError?: { __typename?: 'EmailMessageRenderError', message: string, template: string, variables?: any | null } | null } };

export type EmailMessageLastEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmailMessageLastEventQuery = { __typename?: 'Query', EmailMessage: { __typename?: 'EmailMessage', id: string, createdAt: any, lastEvent?: { __typename?: 'TimelineLogItem', id: string, createdAt: any, level: TimelineLogLevel, messageKey: TimelineLogMessageKey, message: string } | null } };

export type EmailMessageTimelineLogItemsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
}>;


export type EmailMessageTimelineLogItemsQuery = { __typename?: 'Query', TimelineLogItems: { __typename?: 'TimelineLogItemConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'TimelineLogItem', id: string, createdAt: any, level: TimelineLogLevel, messageKey: TimelineLogMessageKey, message: string }> } };

export type EmailMessagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<EmailMessagesFilterInput>;
}>;


export type EmailMessagesQuery = { __typename?: 'Query', EmailMessages: { __typename?: 'EmailMessageConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'EmailMessage', id: string, createdAt: any, updatedAt: any, metaId?: string | null, metadata: any, status: EmailMessageStatus, source: EmailMessageSource, processedAt?: any | null, waypointTemplateId?: string | null, sourceWorkflowRunId?: string | null, sourceEmailMessagesBatchId?: string | null, contactsGroupId?: string | null, logExpirationStatus?: EmailMessageLogExpirationStatus | null, renderError?: { __typename?: 'EmailMessageRenderError', message: string, template: string, variables?: any | null } | null, message: { __typename?: 'WaypointMessage', from?: string | null, to?: string | null } }> } };

export type EmailMessagesExportQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<EmailMessagesFilterInput>;
}>;


export type EmailMessagesExportQuery = { __typename?: 'Query', EmailMessages: { __typename?: 'EmailMessageConnection', count: number, nodes: Array<{ __typename?: 'EmailMessage', id: string, createdAt: any, updatedAt: any, processedAt?: any | null, status: EmailMessageStatus, source: EmailMessageSource, metaId?: string | null, metadata: any, waypointTemplateId?: string | null, sourceWorkflowRunId?: string | null, sourceEmailMessagesBatchId?: string | null, contactsGroupId?: string | null, message: { __typename?: 'WaypointMessage', from?: string | null, to?: string | null, cc?: string | null, bcc?: string | null, replyTo?: string | null, subject?: string | null } }> } };

export type EmailMessagesReportQueryVariables = Exact<{
  filter?: InputMaybe<EmailMessagesFilterInput>;
}>;


export type EmailMessagesReportQuery = { __typename?: 'Query', EmailMessages: { __typename?: 'EmailMessageConnection', count: number, report: { __typename?: 'EmailMessageConnectionReport', bouncedCount: number, clickedCount: number, complainedCount: number, deliveredCount: number, openedCount: number, erroredCount: number, suppressedCount: number, unsubscribedCount: number } } };

export type EmailTemplateHtmlPreviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  type: EmailTemplateHtmlPreviewType;
}>;


export type EmailTemplateHtmlPreviewQuery = { __typename?: 'Query', EmailTemplateHtmlPreview?: string | null };

export type PlatformBillingInformationQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformBillingInformationQuery = { __typename?: 'Query', PlatformBillingInformation: { __typename?: 'PlatformBillingInformation', id: string, billingEmailAddress?: string | null, activeWaypointTier: WaypointFeatureTier, billingPaymentInstrumentsCount: number } };

export type PlatformSesConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type PlatformSesConfigurationQuery = { __typename?: 'Query', PlatformSesConfiguration: { __typename?: 'PlatformSesConfiguration', id: string, events: Array<SesEventName> } };

export type RequestLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type RequestLogQuery = { __typename?: 'Query', RequestLog: { __typename?: 'RequestLog', id: string, createdAt: any, updatedAt: any, apiKeyId?: string | null, url: string, method: string, elapsed: number, statusCode: number, requestHeaders: any, requestBody?: string | null, responseBody: string } };

export type RequestLogsQueryVariables = Exact<{
  page: Scalars['Int']['input'];
}>;


export type RequestLogsQuery = { __typename?: 'Query', RequestLogs: { __typename?: 'RequestLogConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'RequestLog', id: string, createdAt: any, updatedAt: any, apiKeyId?: string | null, url: string, method: string, elapsed: number, statusCode: number, requestHeaders: any, requestBody?: string | null, responseBody: string }> } };

export type SampleWaypointTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type SampleWaypointTemplatesQuery = { __typename?: 'Query', SampleWaypointTemplates: { __typename?: 'WaypointTemplateConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } }> } };

export type SampleWaypointLayoutsQueryVariables = Exact<{ [key: string]: never; }>;


export type SampleWaypointLayoutsQuery = { __typename?: 'Query', SampleWaypointTemplates: { __typename?: 'WaypointTemplateConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } }> } };

export type TemplateSectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TemplateSectionsQuery = { __typename?: 'Query', TemplateSections: Array<{ __typename?: 'TemplateSection', id: string, name: string, orderIndex: number }> };

export type VerifiedEmailAddressesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type VerifiedEmailAddressesQuery = { __typename?: 'Query', VerifiedEmailAddresses: { __typename?: 'VerifiedEmailAddressConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'VerifiedEmailAddress', id: string, createdAt: any, value: string, name?: string | null, emailAddress: string, domainNameVerificationId?: string | null, username: string }> } };

export type WaypointTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WaypointTemplateQuery = { __typename?: 'Query', WaypointTemplate: { __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } } };

export type WaypointTemplateCountsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WaypointTemplateCountsQuery = { __typename?: 'Query', WaypointTemplate: { __typename?: 'WaypointTemplate', id: string, lastEventAt?: any | null, eventsCount: number, nonPreviewEventsCount: number } };

export type WaypointTemplateRawQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WaypointTemplateRawQuery = { __typename?: 'Query', WaypointTemplate: { __typename?: 'WaypointTemplate', activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', rawSubject?: string | null, rawHtml?: string | null } } };

export type WaypointTemplateImageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WaypointTemplateImageQuery = { __typename?: 'Query', WaypointTemplateImage: { __typename?: 'WaypointTemplateImage', id: string, createdAt: any, updatedAt: any, uploadStatus: WaypointTemplateImageUploadStatus, url: string, signedS3UploadUrl?: string | null } };

export type WaypointTemplateImagesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type WaypointTemplateImagesQuery = { __typename?: 'Query', WaypointTemplateImages: { __typename?: 'WaypointTemplateImageConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'WaypointTemplateImage', id: string, createdAt: any, updatedAt: any, uploadStatus: WaypointTemplateImageUploadStatus, url: string, signedS3UploadUrl?: string | null }> } };

export type FWaypointTemplateListResultFragment = { __typename?: 'WaypointTemplateConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } }> };

export type FilteredTemplatesListQueryVariables = Exact<{
  type?: InputMaybe<WaypointTemplateType>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FilteredTemplatesListQuery = { __typename?: 'Query', WaypointTemplates: { __typename?: 'WaypointTemplateConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } }> } };

export type StandardTemplatesListQueryVariables = Exact<{ [key: string]: never; }>;


export type StandardTemplatesListQuery = { __typename?: 'Query', WaypointTemplates: { __typename?: 'WaypointTemplateConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } }> } };

export type LayoutTemplatesListQueryVariables = Exact<{ [key: string]: never; }>;


export type LayoutTemplatesListQuery = { __typename?: 'Query', WaypointTemplates: { __typename?: 'WaypointTemplateConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'WaypointTemplate', id: string, name: string, createdAt: any, updatedAt: any, lastPublishedAt?: any | null, status: WaypointTemplateStatus, type: WaypointTemplateType, sectionId?: string | null, defaultPreviewVariables: any, testScenarios?: Array<{ __typename?: 'TestScenario', name: string, variables: any }> | null, activeConfiguration: { __typename?: 'WaypointTemplateConfiguration', layoutId?: string | null, subjectTemplate: string, preheaderTemplate?: string | null, senderVerifiedEmailAddressId?: string | null, strictVariablesRendering: boolean, legacyTemplatesEnabled: boolean, blocks: Array<{ __typename?: 'TemplateBlock', id: string, type: TemplateBlockType, props: any, style: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, sectionProps: { __typename?: 'BlockSectionProps', hiddenCondition?: string | null } }>, linkStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, backdropStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null }, canvasStyle: { __typename?: 'CssStyle', backgroundColor?: string | null, backgroundColorTemplate?: string | null, border?: string | null, borderRadius?: string | null, color?: string | null, colorTemplate?: string | null, fontFamily?: string | null, fontSize?: string | null, fontWeight?: string | null, height?: string | null, margin?: string | null, maxHeight?: string | null, maxWidth?: string | null, minHeight?: string | null, minWidth?: string | null, padding?: string | null, textAlign?: string | null, textTransform?: string | null, width?: string | null } } }> } };

export type WebhookEndpointsQueryVariables = Exact<{ [key: string]: never; }>;


export type WebhookEndpointsQuery = { __typename?: 'Query', WebhookEndpoints: { __typename?: 'WebhookEndpointConnection', count: number, nodes: Array<{ __typename?: 'WebhookEndpoint', id: string, createdAt: any, updatedAt: any, name: string, url: string, disabled: boolean }> } };

export type WorkflowQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WorkflowQuery = { __typename?: 'Query', Workflow: { __typename?: 'Workflow', id: string, createdAt: any, updatedAt: any, archivedAt?: any | null, name: string, lastRunAt?: any | null, runsCount: number, triggers: Array<{ __typename?: 'WorkflowTrigger', workflowKey?: { __typename?: 'WebhookProperties', key?: string | null } | null, httpPost?: { __typename?: 'HttpPostTriggerProperties', token: string } | null }>, stepDefinitions: Array<{ __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }> } };

export type WorkflowEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WorkflowEventQuery = { __typename?: 'Query', WorkflowEvent: { __typename?: 'WorkflowEvent', id: string, createdAt: any, updatedAt: any, status: WorkflowEventStatus, source: WorkflowEventSource, metaId?: string | null, workflowId?: string | null, workflowKey?: string | null, variables?: any | null, steps: Array<{ __typename?: 'WorkflowStep', startedAt?: any | null, skippedAt?: any | null, finishedAt?: any | null, canceledAt?: any | null, failedAt?: any | null, status: WorkflowStepStatus, errorMessage?: string | null, definition: { __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }, result?: { __typename?: 'WorkflowStepResult', sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageResult', emailMessageId: string, templateId: string, templateVariables: any } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageResult', emailMessageId: string } | null, sleep?: { __typename?: 'SleepResult', wakeupScheduledAt: any, wakeupCommandAt?: any | null, wokeupAt?: any | null } | null } | null }> } };

export type WorkflowEventsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<WorkflowEventsFilterInput>;
}>;


export type WorkflowEventsQuery = { __typename?: 'Query', WorkflowEvents: { __typename?: 'WorkflowEventConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'WorkflowEvent', id: string, createdAt: any, updatedAt: any, status: WorkflowEventStatus, source: WorkflowEventSource, metaId?: string | null, workflowId?: string | null, workflowKey?: string | null, variables?: any | null, steps: Array<{ __typename?: 'WorkflowStep', startedAt?: any | null, skippedAt?: any | null, finishedAt?: any | null, canceledAt?: any | null, failedAt?: any | null, status: WorkflowStepStatus, errorMessage?: string | null, definition: { __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }, result?: { __typename?: 'WorkflowStepResult', sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageResult', emailMessageId: string, templateId: string, templateVariables: any } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageResult', emailMessageId: string } | null, sleep?: { __typename?: 'SleepResult', wakeupScheduledAt: any, wakeupCommandAt?: any | null, wokeupAt?: any | null } | null } | null }> }> } };

export type WorkflowRunTimelineLogItemsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
}>;


export type WorkflowRunTimelineLogItemsQuery = { __typename?: 'Query', TimelineLogItems: { __typename?: 'TimelineLogItemConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'TimelineLogItem', id: string, createdAt: any, level: TimelineLogLevel, messageKey: TimelineLogMessageKey, message: string }> } };

export type WorkflowsQueryVariables = Exact<{ [key: string]: never; }>;


export type WorkflowsQuery = { __typename?: 'Query', Workflows: { __typename?: 'WorkflowConnection', count: number, meta: { __typename?: 'ConnectionMeta', page: number, limit: number }, nodes: Array<{ __typename?: 'Workflow', id: string, createdAt: any, updatedAt: any, archivedAt?: any | null, name: string, triggers: Array<{ __typename?: 'WorkflowTrigger', workflowKey?: { __typename?: 'WebhookProperties', key?: string | null } | null, httpPost?: { __typename?: 'HttpPostTriggerProperties', token: string } | null }>, stepDefinitions: Array<{ __typename?: 'WorkflowStepDefinition', disabled: boolean, sendEmailTemplateMessage?: { __typename?: 'SendEmailTemplateMessageProperties', templateId: string, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null } | null, sendMarkdownEmailMessage?: { __typename?: 'SendMarkdownEmailMessageProperties', senderType: SendMarkdownEmailSenderType, senderVerifiedEmailAddressId?: string | null, fromTemplate?: string | null, toTemplate: string, ccTemplate?: string | null, bccTemplate?: string | null, subjectTemplate: string, messageTemplate: string } | null, sleep?: { __typename?: 'SleepProperties', timeUnit: SleepTimeUnits, timeAmount: number } | null }> }> } };

export const FContactFragmentDoc = gql`
    fragment FContact on Contact {
  id
  createdAt
  updatedAt
  emailAddress
  name
  lastEmailMessageAt
  emailMessagesCount
}
    `;
export const FContactsGroupFragmentDoc = gql`
    fragment FContactsGroup on ContactsGroup {
  id
  createdAt
  updatedAt
  name
  key
  optPolicy
  unsubscribeLinkTemplate
  unsubscribePageTitleTemplate
  unsubscribePageSubtitleTemplate
  unsubscribePageEmailInputLabelTemplate
  unsubscribePageSubmitButtonLabelTemplate
  unsubscribePageConfirmationMessageTemplate
  unsubscribePageInvalidEmailAddressMessageTemplate
}
    `;
export const FContactsGroupContactFragmentDoc = gql`
    fragment FContactsGroupContact on ContactsGroupContact {
  id
  createdAt
  updatedAt
  contactEmailAddress
  contactId
  contactsGroupId
}
    `;
export const FDomainNameVerificationFragmentDoc = gql`
    fragment FDomainNameVerification on DomainNameVerification {
  id
  domainName
  status
  approvalStatus
  verificationDnsRecords {
    name
    type
    value
  }
}
    `;
export const FDomainNameVerificationRecordsFragmentDoc = gql`
    fragment FDomainNameVerificationRecords on DomainNameVerification {
  verificationDnsRecords {
    name
    value
    type
    isPresent
  }
  mailFromConfiguration {
    subdomain
    domain
    status
    records {
      type
      name
      value
      isPresent
    }
  }
}
    `;
export const FEmailMessageLightFragmentDoc = gql`
    fragment FEmailMessageLight on EmailMessage {
  id
  createdAt
  updatedAt
  metaId
  metadata
  status
  source
  processedAt
  waypointTemplateId
  sourceWorkflowRunId
  sourceEmailMessagesBatchId
  contactsGroupId
  logExpirationStatus
  renderError {
    message
    template
    variables
  }
  message {
    from
    to
  }
}
    `;
export const FWaypointMessageFragmentDoc = gql`
    fragment FWaypointMessage on WaypointMessage {
  to
  cc
  bcc
  replyTo
  from
  subject
  bodyHtml
  bodyText
  preheader
}
    `;
export const FEmailMessageFragmentDoc = gql`
    fragment FEmailMessage on EmailMessage {
  ...FEmailMessageLight
  variables
  message {
    ...FWaypointMessage
  }
  attachments {
    name
    contentBytesSize
    contentType
  }
}
    ${FEmailMessageLightFragmentDoc}
${FWaypointMessageFragmentDoc}`;
export const FPlatformBillingInformationFragmentDoc = gql`
    fragment FPlatformBillingInformation on PlatformBillingInformation {
  id
  billingEmailAddress
  activeWaypointTier
  billingPaymentInstrumentsCount
}
    `;
export const FPlatformSesConfigurationFragmentDoc = gql`
    fragment FPlatformSesConfiguration on PlatformSesConfiguration {
  id
  events
}
    `;
export const FRequestLogFragmentDoc = gql`
    fragment FRequestLog on RequestLog {
  id
  createdAt
  updatedAt
  apiKeyId
  url
  method
  elapsed
  statusCode
  requestHeaders
  requestBody
  responseBody
}
    `;
export const FTemplateSectionFragmentDoc = gql`
    fragment FTemplateSection on TemplateSection {
  id
  name
  orderIndex
}
    `;
export const FTimelineLogItemFragmentDoc = gql`
    fragment FTimelineLogItem on TimelineLogItem {
  id
  createdAt
  level
  messageKey
  message
}
    `;
export const FVerifiedEmailAddressFragmentDoc = gql`
    fragment FVerifiedEmailAddress on VerifiedEmailAddress {
  id
  createdAt
  value
  name
  emailAddress
  domainNameVerificationId
  username
}
    `;
export const FWaypointTemplateCountsFragmentDoc = gql`
    fragment FWaypointTemplateCounts on WaypointTemplate {
  id
  lastEventAt
  eventsCount
  nonPreviewEventsCount
}
    `;
export const FWaypointTemplateImageFragmentDoc = gql`
    fragment FWaypointTemplateImage on WaypointTemplateImage {
  id
  createdAt
  updatedAt
  uploadStatus
  url
  signedS3UploadUrl
}
    `;
export const FWebhookEndpointFragmentDoc = gql`
    fragment FWebhookEndpoint on WebhookEndpoint {
  id
  createdAt
  updatedAt
  name
  url
  disabled
}
    `;
export const FWorkflowTriggerFragmentDoc = gql`
    fragment FWorkflowTrigger on WorkflowTrigger {
  workflowKey {
    key
  }
  httpPost {
    token
  }
}
    `;
export const FWorkflowStepDefinitionFragmentDoc = gql`
    fragment FWorkflowStepDefinition on WorkflowStepDefinition {
  disabled
  sendEmailTemplateMessage {
    templateId
    toTemplate
    ccTemplate
    bccTemplate
  }
  sendMarkdownEmailMessage {
    senderType
    senderVerifiedEmailAddressId
    fromTemplate
    toTemplate
    ccTemplate
    bccTemplate
    subjectTemplate
    messageTemplate
  }
  sleep {
    timeUnit
    timeAmount
  }
}
    `;
export const FWorkflowFragmentDoc = gql`
    fragment FWorkflow on Workflow {
  id
  createdAt
  updatedAt
  archivedAt
  name
  triggers {
    ...FWorkflowTrigger
  }
  stepDefinitions {
    ...FWorkflowStepDefinition
  }
}
    ${FWorkflowTriggerFragmentDoc}
${FWorkflowStepDefinitionFragmentDoc}`;
export const FWorkflowStatisticsFragmentDoc = gql`
    fragment FWorkflowStatistics on Workflow {
  lastRunAt
  runsCount
}
    `;
export const FWorkflowStepFragmentDoc = gql`
    fragment FWorkflowStep on WorkflowStep {
  definition {
    ...FWorkflowStepDefinition
  }
  result {
    sendEmailTemplateMessage {
      emailMessageId
      templateId
      templateVariables
    }
    sendMarkdownEmailMessage {
      emailMessageId
    }
    sleep {
      wakeupScheduledAt
      wakeupCommandAt
      wokeupAt
    }
  }
  startedAt
  skippedAt
  finishedAt
  canceledAt
  failedAt
  status
  errorMessage
}
    ${FWorkflowStepDefinitionFragmentDoc}`;
export const FWorkflowEventFragmentDoc = gql`
    fragment FWorkflowEvent on WorkflowEvent {
  id
  createdAt
  updatedAt
  status
  source
  metaId
  workflowId
  workflowKey
  variables
  steps {
    ...FWorkflowStep
  }
}
    ${FWorkflowStepFragmentDoc}`;
export const FWorkflowRunCommandFragmentDoc = gql`
    fragment FWorkflowRunCommand on WorkflowRunCommand {
  id
  createdAt
  updatedAt
  commandName
}
    `;
export const FCssStyleFragmentDoc = gql`
    fragment FCssStyle on CssStyle {
  backgroundColor
  backgroundColorTemplate
  border
  borderRadius
  color
  colorTemplate
  fontFamily
  fontSize
  fontWeight
  height
  margin
  maxHeight
  maxWidth
  minHeight
  minWidth
  padding
  textAlign
  textTransform
  width
}
    `;
export const FWaypointTemplateConfigurationFragmentDoc = gql`
    fragment FWaypointTemplateConfiguration on WaypointTemplateConfiguration {
  layoutId
  subjectTemplate
  preheaderTemplate
  senderVerifiedEmailAddressId
  strictVariablesRendering
  legacyTemplatesEnabled
  blocks {
    id
    type
    props
    style {
      ...FCssStyle
    }
    sectionProps {
      hiddenCondition
    }
  }
  linkStyle {
    ...FCssStyle
  }
  backdropStyle {
    ...FCssStyle
  }
  canvasStyle {
    ...FCssStyle
  }
}
    ${FCssStyleFragmentDoc}`;
export const FWaypointTemplateFragmentDoc = gql`
    fragment FWaypointTemplate on WaypointTemplate {
  id
  name
  createdAt
  updatedAt
  lastPublishedAt
  status
  type
  sectionId
  defaultPreviewVariables
  testScenarios {
    name
    variables
  }
  activeConfiguration {
    ...FWaypointTemplateConfiguration
  }
}
    ${FWaypointTemplateConfigurationFragmentDoc}`;
export const FWaypointTemplateListResultFragmentDoc = gql`
    fragment FWaypointTemplateListResult on WaypointTemplateConnection {
  count
  meta {
    page
    limit
  }
  nodes {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;
export const ArchiveWaypointTemplateDocument = gql`
    mutation ArchiveWaypointTemplate($id: ID!) {
  archiveWaypointTemplate(id: $id) {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;
export type ArchiveWaypointTemplateMutationFn = Apollo.MutationFunction<ArchiveWaypointTemplateMutation, ArchiveWaypointTemplateMutationVariables>;

/**
 * __useArchiveWaypointTemplateMutation_raw__
 *
 * To run a mutation, you first call `useArchiveWaypointTemplateMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWaypointTemplateMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWaypointTemplateMutationRaw, { data, loading, error }] = useArchiveWaypointTemplateMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveWaypointTemplateMutation_raw(baseOptions?: Apollo.MutationHookOptions<ArchiveWaypointTemplateMutation, ArchiveWaypointTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveWaypointTemplateMutation, ArchiveWaypointTemplateMutationVariables>(ArchiveWaypointTemplateDocument, options);
      }
export type ArchiveWaypointTemplateMutation_rawHookResult = ReturnType<typeof useArchiveWaypointTemplateMutation_raw>;
export type ArchiveWaypointTemplateMutationResult = Apollo.MutationResult<ArchiveWaypointTemplateMutation>;
export type ArchiveWaypointTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveWaypointTemplateMutation, ArchiveWaypointTemplateMutationVariables>;
export const ArchiveWorkflowDocument = gql`
    mutation ArchiveWorkflow($id: ID!) {
  archiveWorkflow(id: $id) {
    ...FWorkflow
  }
}
    ${FWorkflowFragmentDoc}`;
export type ArchiveWorkflowMutationFn = Apollo.MutationFunction<ArchiveWorkflowMutation, ArchiveWorkflowMutationVariables>;

/**
 * __useArchiveWorkflowMutation_raw__
 *
 * To run a mutation, you first call `useArchiveWorkflowMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveWorkflowMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveWorkflowMutationRaw, { data, loading, error }] = useArchiveWorkflowMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveWorkflowMutation_raw(baseOptions?: Apollo.MutationHookOptions<ArchiveWorkflowMutation, ArchiveWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveWorkflowMutation, ArchiveWorkflowMutationVariables>(ArchiveWorkflowDocument, options);
      }
export type ArchiveWorkflowMutation_rawHookResult = ReturnType<typeof useArchiveWorkflowMutation_raw>;
export type ArchiveWorkflowMutationResult = Apollo.MutationResult<ArchiveWorkflowMutation>;
export type ArchiveWorkflowMutationOptions = Apollo.BaseMutationOptions<ArchiveWorkflowMutation, ArchiveWorkflowMutationVariables>;
export const CreateApiKeyDocument = gql`
    mutation CreateApiKey($name: String!) {
  createApiKey(name: $name) {
    id
    name
    password
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation_raw__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutationRaw, { data, loading, error }] = useCreateApiKeyMutation_raw({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateApiKeyMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutation_rawHookResult = ReturnType<typeof useCreateApiKeyMutation_raw>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const CreateContactsGroupDocument = gql`
    mutation CreateContactsGroup($name: String!, $key: String, $unsubscribeLinkTemplate: String!, $unsubscribePageTitleTemplate: String!, $unsubscribePageSubtitleTemplate: String!, $unsubscribePageEmailInputLabelTemplate: String!, $unsubscribePageSubmitButtonLabelTemplate: String!, $unsubscribePageConfirmationMessageTemplate: String!, $unsubscribePageInvalidEmailAddressMessageTemplate: String!) {
  createContactsGroup(
    name: $name
    key: $key
    unsubscribeLinkTemplate: $unsubscribeLinkTemplate
    unsubscribePageTitleTemplate: $unsubscribePageTitleTemplate
    unsubscribePageSubtitleTemplate: $unsubscribePageSubtitleTemplate
    unsubscribePageEmailInputLabelTemplate: $unsubscribePageEmailInputLabelTemplate
    unsubscribePageSubmitButtonLabelTemplate: $unsubscribePageSubmitButtonLabelTemplate
    unsubscribePageConfirmationMessageTemplate: $unsubscribePageConfirmationMessageTemplate
    unsubscribePageInvalidEmailAddressMessageTemplate: $unsubscribePageInvalidEmailAddressMessageTemplate
  ) {
    ...FContactsGroup
  }
}
    ${FContactsGroupFragmentDoc}`;
export type CreateContactsGroupMutationFn = Apollo.MutationFunction<CreateContactsGroupMutation, CreateContactsGroupMutationVariables>;

/**
 * __useCreateContactsGroupMutation_raw__
 *
 * To run a mutation, you first call `useCreateContactsGroupMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactsGroupMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactsGroupMutationRaw, { data, loading, error }] = useCreateContactsGroupMutation_raw({
 *   variables: {
 *      name: // value for 'name'
 *      key: // value for 'key'
 *      unsubscribeLinkTemplate: // value for 'unsubscribeLinkTemplate'
 *      unsubscribePageTitleTemplate: // value for 'unsubscribePageTitleTemplate'
 *      unsubscribePageSubtitleTemplate: // value for 'unsubscribePageSubtitleTemplate'
 *      unsubscribePageEmailInputLabelTemplate: // value for 'unsubscribePageEmailInputLabelTemplate'
 *      unsubscribePageSubmitButtonLabelTemplate: // value for 'unsubscribePageSubmitButtonLabelTemplate'
 *      unsubscribePageConfirmationMessageTemplate: // value for 'unsubscribePageConfirmationMessageTemplate'
 *      unsubscribePageInvalidEmailAddressMessageTemplate: // value for 'unsubscribePageInvalidEmailAddressMessageTemplate'
 *   },
 * });
 */
export function useCreateContactsGroupMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateContactsGroupMutation, CreateContactsGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactsGroupMutation, CreateContactsGroupMutationVariables>(CreateContactsGroupDocument, options);
      }
export type CreateContactsGroupMutation_rawHookResult = ReturnType<typeof useCreateContactsGroupMutation_raw>;
export type CreateContactsGroupMutationResult = Apollo.MutationResult<CreateContactsGroupMutation>;
export type CreateContactsGroupMutationOptions = Apollo.BaseMutationOptions<CreateContactsGroupMutation, CreateContactsGroupMutationVariables>;
export const CreateContactsGroupContactDocument = gql`
    mutation CreateContactsGroupContact($contactsGroupId: ID!, $contactEmailAddress: String!) {
  createContactsGroupContact(
    contactsGroupId: $contactsGroupId
    contactEmailAddress: $contactEmailAddress
  ) {
    ...FContactsGroupContact
  }
}
    ${FContactsGroupContactFragmentDoc}`;
export type CreateContactsGroupContactMutationFn = Apollo.MutationFunction<CreateContactsGroupContactMutation, CreateContactsGroupContactMutationVariables>;

/**
 * __useCreateContactsGroupContactMutation_raw__
 *
 * To run a mutation, you first call `useCreateContactsGroupContactMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContactsGroupContactMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContactsGroupContactMutationRaw, { data, loading, error }] = useCreateContactsGroupContactMutation_raw({
 *   variables: {
 *      contactsGroupId: // value for 'contactsGroupId'
 *      contactEmailAddress: // value for 'contactEmailAddress'
 *   },
 * });
 */
export function useCreateContactsGroupContactMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateContactsGroupContactMutation, CreateContactsGroupContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContactsGroupContactMutation, CreateContactsGroupContactMutationVariables>(CreateContactsGroupContactDocument, options);
      }
export type CreateContactsGroupContactMutation_rawHookResult = ReturnType<typeof useCreateContactsGroupContactMutation_raw>;
export type CreateContactsGroupContactMutationResult = Apollo.MutationResult<CreateContactsGroupContactMutation>;
export type CreateContactsGroupContactMutationOptions = Apollo.BaseMutationOptions<CreateContactsGroupContactMutation, CreateContactsGroupContactMutationVariables>;
export const CreateDomainNameVerificationDocument = gql`
    mutation CreateDomainNameVerification($domainName: String!) {
  createDomainNameVerification(domainName: $domainName) {
    ...FDomainNameVerification
  }
}
    ${FDomainNameVerificationFragmentDoc}`;
export type CreateDomainNameVerificationMutationFn = Apollo.MutationFunction<CreateDomainNameVerificationMutation, CreateDomainNameVerificationMutationVariables>;

/**
 * __useCreateDomainNameVerificationMutation_raw__
 *
 * To run a mutation, you first call `useCreateDomainNameVerificationMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDomainNameVerificationMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDomainNameVerificationMutationRaw, { data, loading, error }] = useCreateDomainNameVerificationMutation_raw({
 *   variables: {
 *      domainName: // value for 'domainName'
 *   },
 * });
 */
export function useCreateDomainNameVerificationMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateDomainNameVerificationMutation, CreateDomainNameVerificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDomainNameVerificationMutation, CreateDomainNameVerificationMutationVariables>(CreateDomainNameVerificationDocument, options);
      }
export type CreateDomainNameVerificationMutation_rawHookResult = ReturnType<typeof useCreateDomainNameVerificationMutation_raw>;
export type CreateDomainNameVerificationMutationResult = Apollo.MutationResult<CreateDomainNameVerificationMutation>;
export type CreateDomainNameVerificationMutationOptions = Apollo.BaseMutationOptions<CreateDomainNameVerificationMutation, CreateDomainNameVerificationMutationVariables>;
export const CreateSenderEmailAddressDocument = gql`
    mutation CreateSenderEmailAddress($domainNameVerificationId: ID!, $username: String!, $name: String) {
  createSenderEmailAddress(
    domainNameVerificationId: $domainNameVerificationId
    username: $username
    name: $name
  ) {
    ...FVerifiedEmailAddress
  }
}
    ${FVerifiedEmailAddressFragmentDoc}`;
export type CreateSenderEmailAddressMutationFn = Apollo.MutationFunction<CreateSenderEmailAddressMutation, CreateSenderEmailAddressMutationVariables>;

/**
 * __useCreateSenderEmailAddressMutation_raw__
 *
 * To run a mutation, you first call `useCreateSenderEmailAddressMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSenderEmailAddressMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSenderEmailAddressMutationRaw, { data, loading, error }] = useCreateSenderEmailAddressMutation_raw({
 *   variables: {
 *      domainNameVerificationId: // value for 'domainNameVerificationId'
 *      username: // value for 'username'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateSenderEmailAddressMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateSenderEmailAddressMutation, CreateSenderEmailAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSenderEmailAddressMutation, CreateSenderEmailAddressMutationVariables>(CreateSenderEmailAddressDocument, options);
      }
export type CreateSenderEmailAddressMutation_rawHookResult = ReturnType<typeof useCreateSenderEmailAddressMutation_raw>;
export type CreateSenderEmailAddressMutationResult = Apollo.MutationResult<CreateSenderEmailAddressMutation>;
export type CreateSenderEmailAddressMutationOptions = Apollo.BaseMutationOptions<CreateSenderEmailAddressMutation, CreateSenderEmailAddressMutationVariables>;
export const CreateStripeCustomerPortalUrlDocument = gql`
    mutation CreateStripeCustomerPortalUrl {
  createStripeCustomerPortalUrl
}
    `;
export type CreateStripeCustomerPortalUrlMutationFn = Apollo.MutationFunction<CreateStripeCustomerPortalUrlMutation, CreateStripeCustomerPortalUrlMutationVariables>;

/**
 * __useCreateStripeCustomerPortalUrlMutation_raw__
 *
 * To run a mutation, you first call `useCreateStripeCustomerPortalUrlMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateStripeCustomerPortalUrlMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createStripeCustomerPortalUrlMutationRaw, { data, loading, error }] = useCreateStripeCustomerPortalUrlMutation_raw({
 *   variables: {
 *   },
 * });
 */
export function useCreateStripeCustomerPortalUrlMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateStripeCustomerPortalUrlMutation, CreateStripeCustomerPortalUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateStripeCustomerPortalUrlMutation, CreateStripeCustomerPortalUrlMutationVariables>(CreateStripeCustomerPortalUrlDocument, options);
      }
export type CreateStripeCustomerPortalUrlMutation_rawHookResult = ReturnType<typeof useCreateStripeCustomerPortalUrlMutation_raw>;
export type CreateStripeCustomerPortalUrlMutationResult = Apollo.MutationResult<CreateStripeCustomerPortalUrlMutation>;
export type CreateStripeCustomerPortalUrlMutationOptions = Apollo.BaseMutationOptions<CreateStripeCustomerPortalUrlMutation, CreateStripeCustomerPortalUrlMutationVariables>;
export const CreateSvixCustomerPortalUrlDocument = gql`
    mutation CreateSvixCustomerPortalUrl {
  createSvixCustomerPortalUrl
}
    `;
export type CreateSvixCustomerPortalUrlMutationFn = Apollo.MutationFunction<CreateSvixCustomerPortalUrlMutation, CreateSvixCustomerPortalUrlMutationVariables>;

/**
 * __useCreateSvixCustomerPortalUrlMutation_raw__
 *
 * To run a mutation, you first call `useCreateSvixCustomerPortalUrlMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSvixCustomerPortalUrlMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSvixCustomerPortalUrlMutationRaw, { data, loading, error }] = useCreateSvixCustomerPortalUrlMutation_raw({
 *   variables: {
 *   },
 * });
 */
export function useCreateSvixCustomerPortalUrlMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateSvixCustomerPortalUrlMutation, CreateSvixCustomerPortalUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSvixCustomerPortalUrlMutation, CreateSvixCustomerPortalUrlMutationVariables>(CreateSvixCustomerPortalUrlDocument, options);
      }
export type CreateSvixCustomerPortalUrlMutation_rawHookResult = ReturnType<typeof useCreateSvixCustomerPortalUrlMutation_raw>;
export type CreateSvixCustomerPortalUrlMutationResult = Apollo.MutationResult<CreateSvixCustomerPortalUrlMutation>;
export type CreateSvixCustomerPortalUrlMutationOptions = Apollo.BaseMutationOptions<CreateSvixCustomerPortalUrlMutation, CreateSvixCustomerPortalUrlMutationVariables>;
export const CreateTemplateSectionDocument = gql`
    mutation CreateTemplateSection($name: String!) {
  createTemplateSection(name: $name) {
    ...FTemplateSection
  }
}
    ${FTemplateSectionFragmentDoc}`;
export type CreateTemplateSectionMutationFn = Apollo.MutationFunction<CreateTemplateSectionMutation, CreateTemplateSectionMutationVariables>;

/**
 * __useCreateTemplateSectionMutation_raw__
 *
 * To run a mutation, you first call `useCreateTemplateSectionMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateSectionMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateSectionMutationRaw, { data, loading, error }] = useCreateTemplateSectionMutation_raw({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateTemplateSectionMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateTemplateSectionMutation, CreateTemplateSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateSectionMutation, CreateTemplateSectionMutationVariables>(CreateTemplateSectionDocument, options);
      }
export type CreateTemplateSectionMutation_rawHookResult = ReturnType<typeof useCreateTemplateSectionMutation_raw>;
export type CreateTemplateSectionMutationResult = Apollo.MutationResult<CreateTemplateSectionMutation>;
export type CreateTemplateSectionMutationOptions = Apollo.BaseMutationOptions<CreateTemplateSectionMutation, CreateTemplateSectionMutationVariables>;
export const CreateTemplateDocument = gql`
    mutation CreateTemplate {
  createTemplate(type: TEMPLATE) {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;
export type CreateTemplateMutationFn = Apollo.MutationFunction<CreateTemplateMutation, CreateTemplateMutationVariables>;

/**
 * __useCreateTemplateMutation_raw__
 *
 * To run a mutation, you first call `useCreateTemplateMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateMutationRaw, { data, loading, error }] = useCreateTemplateMutation_raw({
 *   variables: {
 *   },
 * });
 */
export function useCreateTemplateMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateTemplateMutation, CreateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateMutation, CreateTemplateMutationVariables>(CreateTemplateDocument, options);
      }
export type CreateTemplateMutation_rawHookResult = ReturnType<typeof useCreateTemplateMutation_raw>;
export type CreateTemplateMutationResult = Apollo.MutationResult<CreateTemplateMutation>;
export type CreateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTemplateMutation, CreateTemplateMutationVariables>;
export const CreateLayoutTemplateDocument = gql`
    mutation CreateLayoutTemplate {
  createTemplate(type: LAYOUT) {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;
export type CreateLayoutTemplateMutationFn = Apollo.MutationFunction<CreateLayoutTemplateMutation, CreateLayoutTemplateMutationVariables>;

/**
 * __useCreateLayoutTemplateMutation_raw__
 *
 * To run a mutation, you first call `useCreateLayoutTemplateMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLayoutTemplateMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLayoutTemplateMutationRaw, { data, loading, error }] = useCreateLayoutTemplateMutation_raw({
 *   variables: {
 *   },
 * });
 */
export function useCreateLayoutTemplateMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateLayoutTemplateMutation, CreateLayoutTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLayoutTemplateMutation, CreateLayoutTemplateMutationVariables>(CreateLayoutTemplateDocument, options);
      }
export type CreateLayoutTemplateMutation_rawHookResult = ReturnType<typeof useCreateLayoutTemplateMutation_raw>;
export type CreateLayoutTemplateMutationResult = Apollo.MutationResult<CreateLayoutTemplateMutation>;
export type CreateLayoutTemplateMutationOptions = Apollo.BaseMutationOptions<CreateLayoutTemplateMutation, CreateLayoutTemplateMutationVariables>;
export const CreateDuplicateTemplateDocument = gql`
    mutation CreateDuplicateTemplate($id: ID!) {
  createDuplicateTemplate(id: $id) {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;
export type CreateDuplicateTemplateMutationFn = Apollo.MutationFunction<CreateDuplicateTemplateMutation, CreateDuplicateTemplateMutationVariables>;

/**
 * __useCreateDuplicateTemplateMutation_raw__
 *
 * To run a mutation, you first call `useCreateDuplicateTemplateMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDuplicateTemplateMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDuplicateTemplateMutationRaw, { data, loading, error }] = useCreateDuplicateTemplateMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateDuplicateTemplateMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateDuplicateTemplateMutation, CreateDuplicateTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDuplicateTemplateMutation, CreateDuplicateTemplateMutationVariables>(CreateDuplicateTemplateDocument, options);
      }
export type CreateDuplicateTemplateMutation_rawHookResult = ReturnType<typeof useCreateDuplicateTemplateMutation_raw>;
export type CreateDuplicateTemplateMutationResult = Apollo.MutationResult<CreateDuplicateTemplateMutation>;
export type CreateDuplicateTemplateMutationOptions = Apollo.BaseMutationOptions<CreateDuplicateTemplateMutation, CreateDuplicateTemplateMutationVariables>;
export const CreateTemplateFromSampleDocument = gql`
    mutation CreateTemplateFromSample($sampleTemplateId: ID!) {
  createTemplateFromSample(sampleTemplateId: $sampleTemplateId) {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;
export type CreateTemplateFromSampleMutationFn = Apollo.MutationFunction<CreateTemplateFromSampleMutation, CreateTemplateFromSampleMutationVariables>;

/**
 * __useCreateTemplateFromSampleMutation_raw__
 *
 * To run a mutation, you first call `useCreateTemplateFromSampleMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateFromSampleMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateFromSampleMutationRaw, { data, loading, error }] = useCreateTemplateFromSampleMutation_raw({
 *   variables: {
 *      sampleTemplateId: // value for 'sampleTemplateId'
 *   },
 * });
 */
export function useCreateTemplateFromSampleMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateTemplateFromSampleMutation, CreateTemplateFromSampleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateFromSampleMutation, CreateTemplateFromSampleMutationVariables>(CreateTemplateFromSampleDocument, options);
      }
export type CreateTemplateFromSampleMutation_rawHookResult = ReturnType<typeof useCreateTemplateFromSampleMutation_raw>;
export type CreateTemplateFromSampleMutationResult = Apollo.MutationResult<CreateTemplateFromSampleMutation>;
export type CreateTemplateFromSampleMutationOptions = Apollo.BaseMutationOptions<CreateTemplateFromSampleMutation, CreateTemplateFromSampleMutationVariables>;
export const CreateTemplateFromExistingDocument = gql`
    mutation CreateTemplateFromExisting($id: ID!) {
  createTemplateFromExisting(id: $id) {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;
export type CreateTemplateFromExistingMutationFn = Apollo.MutationFunction<CreateTemplateFromExistingMutation, CreateTemplateFromExistingMutationVariables>;

/**
 * __useCreateTemplateFromExistingMutation_raw__
 *
 * To run a mutation, you first call `useCreateTemplateFromExistingMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateFromExistingMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateFromExistingMutationRaw, { data, loading, error }] = useCreateTemplateFromExistingMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateTemplateFromExistingMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateTemplateFromExistingMutation, CreateTemplateFromExistingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateFromExistingMutation, CreateTemplateFromExistingMutationVariables>(CreateTemplateFromExistingDocument, options);
      }
export type CreateTemplateFromExistingMutation_rawHookResult = ReturnType<typeof useCreateTemplateFromExistingMutation_raw>;
export type CreateTemplateFromExistingMutationResult = Apollo.MutationResult<CreateTemplateFromExistingMutation>;
export type CreateTemplateFromExistingMutationOptions = Apollo.BaseMutationOptions<CreateTemplateFromExistingMutation, CreateTemplateFromExistingMutationVariables>;
export const CreateLayoutFromExistingDocument = gql`
    mutation CreateLayoutFromExisting($id: ID!) {
  createLayoutFromExisting(id: $id) {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;
export type CreateLayoutFromExistingMutationFn = Apollo.MutationFunction<CreateLayoutFromExistingMutation, CreateLayoutFromExistingMutationVariables>;

/**
 * __useCreateLayoutFromExistingMutation_raw__
 *
 * To run a mutation, you first call `useCreateLayoutFromExistingMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLayoutFromExistingMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLayoutFromExistingMutationRaw, { data, loading, error }] = useCreateLayoutFromExistingMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateLayoutFromExistingMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateLayoutFromExistingMutation, CreateLayoutFromExistingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLayoutFromExistingMutation, CreateLayoutFromExistingMutationVariables>(CreateLayoutFromExistingDocument, options);
      }
export type CreateLayoutFromExistingMutation_rawHookResult = ReturnType<typeof useCreateLayoutFromExistingMutation_raw>;
export type CreateLayoutFromExistingMutationResult = Apollo.MutationResult<CreateLayoutFromExistingMutation>;
export type CreateLayoutFromExistingMutationOptions = Apollo.BaseMutationOptions<CreateLayoutFromExistingMutation, CreateLayoutFromExistingMutationVariables>;
export const CreateWaypointTemplatePreviewDocument = gql`
    mutation CreateWaypointTemplatePreview($id: ID!, $variables: JSONObject!, $configuration: WaypointTemplateConfigurationInput!) {
  createWaypointTemplatePreview(
    id: $id
    configuration: $configuration
    variables: $variables
  ) {
    ...FEmailMessage
  }
}
    ${FEmailMessageFragmentDoc}`;
export type CreateWaypointTemplatePreviewMutationFn = Apollo.MutationFunction<CreateWaypointTemplatePreviewMutation, CreateWaypointTemplatePreviewMutationVariables>;

/**
 * __useCreateWaypointTemplatePreviewMutation_raw__
 *
 * To run a mutation, you first call `useCreateWaypointTemplatePreviewMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWaypointTemplatePreviewMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWaypointTemplatePreviewMutationRaw, { data, loading, error }] = useCreateWaypointTemplatePreviewMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      variables: // value for 'variables'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useCreateWaypointTemplatePreviewMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateWaypointTemplatePreviewMutation, CreateWaypointTemplatePreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWaypointTemplatePreviewMutation, CreateWaypointTemplatePreviewMutationVariables>(CreateWaypointTemplatePreviewDocument, options);
      }
export type CreateWaypointTemplatePreviewMutation_rawHookResult = ReturnType<typeof useCreateWaypointTemplatePreviewMutation_raw>;
export type CreateWaypointTemplatePreviewMutationResult = Apollo.MutationResult<CreateWaypointTemplatePreviewMutation>;
export type CreateWaypointTemplatePreviewMutationOptions = Apollo.BaseMutationOptions<CreateWaypointTemplatePreviewMutation, CreateWaypointTemplatePreviewMutationVariables>;
export const CreateWaypointTemplateUploadImageUrlDocument = gql`
    mutation CreateWaypointTemplateUploadImageUrl($name: String!, $mimeType: String!, $contentLength: Int!) {
  createWaypointTemplateUploadImageUrl(
    name: $name
    mimeType: $mimeType
    contentLength: $contentLength
  ) {
    ...FWaypointTemplateImage
  }
}
    ${FWaypointTemplateImageFragmentDoc}`;
export type CreateWaypointTemplateUploadImageUrlMutationFn = Apollo.MutationFunction<CreateWaypointTemplateUploadImageUrlMutation, CreateWaypointTemplateUploadImageUrlMutationVariables>;

/**
 * __useCreateWaypointTemplateUploadImageUrlMutation_raw__
 *
 * To run a mutation, you first call `useCreateWaypointTemplateUploadImageUrlMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWaypointTemplateUploadImageUrlMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWaypointTemplateUploadImageUrlMutationRaw, { data, loading, error }] = useCreateWaypointTemplateUploadImageUrlMutation_raw({
 *   variables: {
 *      name: // value for 'name'
 *      mimeType: // value for 'mimeType'
 *      contentLength: // value for 'contentLength'
 *   },
 * });
 */
export function useCreateWaypointTemplateUploadImageUrlMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateWaypointTemplateUploadImageUrlMutation, CreateWaypointTemplateUploadImageUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWaypointTemplateUploadImageUrlMutation, CreateWaypointTemplateUploadImageUrlMutationVariables>(CreateWaypointTemplateUploadImageUrlDocument, options);
      }
export type CreateWaypointTemplateUploadImageUrlMutation_rawHookResult = ReturnType<typeof useCreateWaypointTemplateUploadImageUrlMutation_raw>;
export type CreateWaypointTemplateUploadImageUrlMutationResult = Apollo.MutationResult<CreateWaypointTemplateUploadImageUrlMutation>;
export type CreateWaypointTemplateUploadImageUrlMutationOptions = Apollo.BaseMutationOptions<CreateWaypointTemplateUploadImageUrlMutation, CreateWaypointTemplateUploadImageUrlMutationVariables>;
export const CreateWorkflowDocument = gql`
    mutation CreateWorkflow {
  createWorkflow {
    ...FWorkflow
  }
}
    ${FWorkflowFragmentDoc}`;
export type CreateWorkflowMutationFn = Apollo.MutationFunction<CreateWorkflowMutation, CreateWorkflowMutationVariables>;

/**
 * __useCreateWorkflowMutation_raw__
 *
 * To run a mutation, you first call `useCreateWorkflowMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowMutationRaw, { data, loading, error }] = useCreateWorkflowMutation_raw({
 *   variables: {
 *   },
 * });
 */
export function useCreateWorkflowMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowMutation, CreateWorkflowMutationVariables>(CreateWorkflowDocument, options);
      }
export type CreateWorkflowMutation_rawHookResult = ReturnType<typeof useCreateWorkflowMutation_raw>;
export type CreateWorkflowMutationResult = Apollo.MutationResult<CreateWorkflowMutation>;
export type CreateWorkflowMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowMutation, CreateWorkflowMutationVariables>;
export const CreateWorkflowPreviewDocument = gql`
    mutation CreateWorkflowPreview($id: ID!, $variables: JSONObject!, $stepDefinitions: [WorkflowStepDefinitionInput!]!) {
  createWorkflowPreview(
    id: $id
    variables: $variables
    stepDefinitions: $stepDefinitions
  ) {
    ...FWorkflowEvent
  }
}
    ${FWorkflowEventFragmentDoc}`;
export type CreateWorkflowPreviewMutationFn = Apollo.MutationFunction<CreateWorkflowPreviewMutation, CreateWorkflowPreviewMutationVariables>;

/**
 * __useCreateWorkflowPreviewMutation_raw__
 *
 * To run a mutation, you first call `useCreateWorkflowPreviewMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowPreviewMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowPreviewMutationRaw, { data, loading, error }] = useCreateWorkflowPreviewMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      variables: // value for 'variables'
 *      stepDefinitions: // value for 'stepDefinitions'
 *   },
 * });
 */
export function useCreateWorkflowPreviewMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowPreviewMutation, CreateWorkflowPreviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowPreviewMutation, CreateWorkflowPreviewMutationVariables>(CreateWorkflowPreviewDocument, options);
      }
export type CreateWorkflowPreviewMutation_rawHookResult = ReturnType<typeof useCreateWorkflowPreviewMutation_raw>;
export type CreateWorkflowPreviewMutationResult = Apollo.MutationResult<CreateWorkflowPreviewMutation>;
export type CreateWorkflowPreviewMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowPreviewMutation, CreateWorkflowPreviewMutationVariables>;
export const CreateWorkflowRunCommandDocument = gql`
    mutation CreateWorkflowRunCommand($workflowRunId: ID!, $commandName: WorkflowRunCommandName!) {
  createWorkflowRunCommand(
    workflowRunId: $workflowRunId
    commandName: $commandName
  ) {
    ...FWorkflowRunCommand
  }
}
    ${FWorkflowRunCommandFragmentDoc}`;
export type CreateWorkflowRunCommandMutationFn = Apollo.MutationFunction<CreateWorkflowRunCommandMutation, CreateWorkflowRunCommandMutationVariables>;

/**
 * __useCreateWorkflowRunCommandMutation_raw__
 *
 * To run a mutation, you first call `useCreateWorkflowRunCommandMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowRunCommandMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowRunCommandMutationRaw, { data, loading, error }] = useCreateWorkflowRunCommandMutation_raw({
 *   variables: {
 *      workflowRunId: // value for 'workflowRunId'
 *      commandName: // value for 'commandName'
 *   },
 * });
 */
export function useCreateWorkflowRunCommandMutation_raw(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowRunCommandMutation, CreateWorkflowRunCommandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowRunCommandMutation, CreateWorkflowRunCommandMutationVariables>(CreateWorkflowRunCommandDocument, options);
      }
export type CreateWorkflowRunCommandMutation_rawHookResult = ReturnType<typeof useCreateWorkflowRunCommandMutation_raw>;
export type CreateWorkflowRunCommandMutationResult = Apollo.MutationResult<CreateWorkflowRunCommandMutation>;
export type CreateWorkflowRunCommandMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowRunCommandMutation, CreateWorkflowRunCommandMutationVariables>;
export const DeleteContactsGroupContactDocument = gql`
    mutation DeleteContactsGroupContact($id: ID!) {
  deleteContactsGroupContact(id: $id)
}
    `;
export type DeleteContactsGroupContactMutationFn = Apollo.MutationFunction<DeleteContactsGroupContactMutation, DeleteContactsGroupContactMutationVariables>;

/**
 * __useDeleteContactsGroupContactMutation_raw__
 *
 * To run a mutation, you first call `useDeleteContactsGroupContactMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContactsGroupContactMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContactsGroupContactMutationRaw, { data, loading, error }] = useDeleteContactsGroupContactMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteContactsGroupContactMutation_raw(baseOptions?: Apollo.MutationHookOptions<DeleteContactsGroupContactMutation, DeleteContactsGroupContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteContactsGroupContactMutation, DeleteContactsGroupContactMutationVariables>(DeleteContactsGroupContactDocument, options);
      }
export type DeleteContactsGroupContactMutation_rawHookResult = ReturnType<typeof useDeleteContactsGroupContactMutation_raw>;
export type DeleteContactsGroupContactMutationResult = Apollo.MutationResult<DeleteContactsGroupContactMutation>;
export type DeleteContactsGroupContactMutationOptions = Apollo.BaseMutationOptions<DeleteContactsGroupContactMutation, DeleteContactsGroupContactMutationVariables>;
export const DeleteTemplateSectionDocument = gql`
    mutation DeleteTemplateSection($id: ID!) {
  deleteTemplateSection(id: $id)
}
    `;
export type DeleteTemplateSectionMutationFn = Apollo.MutationFunction<DeleteTemplateSectionMutation, DeleteTemplateSectionMutationVariables>;

/**
 * __useDeleteTemplateSectionMutation_raw__
 *
 * To run a mutation, you first call `useDeleteTemplateSectionMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTemplateSectionMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTemplateSectionMutationRaw, { data, loading, error }] = useDeleteTemplateSectionMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTemplateSectionMutation_raw(baseOptions?: Apollo.MutationHookOptions<DeleteTemplateSectionMutation, DeleteTemplateSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTemplateSectionMutation, DeleteTemplateSectionMutationVariables>(DeleteTemplateSectionDocument, options);
      }
export type DeleteTemplateSectionMutation_rawHookResult = ReturnType<typeof useDeleteTemplateSectionMutation_raw>;
export type DeleteTemplateSectionMutationResult = Apollo.MutationResult<DeleteTemplateSectionMutation>;
export type DeleteTemplateSectionMutationOptions = Apollo.BaseMutationOptions<DeleteTemplateSectionMutation, DeleteTemplateSectionMutationVariables>;
export const PreviewWaypointTemplateDocument = gql`
    mutation PreviewWaypointTemplate($variables: JSONObject!, $configuration: WaypointTemplateConfigurationInput!) {
  previewWaypointTemplate(configuration: $configuration, variables: $variables) {
    ...FWaypointMessage
  }
}
    ${FWaypointMessageFragmentDoc}`;
export type PreviewWaypointTemplateMutationFn = Apollo.MutationFunction<PreviewWaypointTemplateMutation, PreviewWaypointTemplateMutationVariables>;

/**
 * __usePreviewWaypointTemplateMutation_raw__
 *
 * To run a mutation, you first call `usePreviewWaypointTemplateMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePreviewWaypointTemplateMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [previewWaypointTemplateMutationRaw, { data, loading, error }] = usePreviewWaypointTemplateMutation_raw({
 *   variables: {
 *      variables: // value for 'variables'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function usePreviewWaypointTemplateMutation_raw(baseOptions?: Apollo.MutationHookOptions<PreviewWaypointTemplateMutation, PreviewWaypointTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PreviewWaypointTemplateMutation, PreviewWaypointTemplateMutationVariables>(PreviewWaypointTemplateDocument, options);
      }
export type PreviewWaypointTemplateMutation_rawHookResult = ReturnType<typeof usePreviewWaypointTemplateMutation_raw>;
export type PreviewWaypointTemplateMutationResult = Apollo.MutationResult<PreviewWaypointTemplateMutation>;
export type PreviewWaypointTemplateMutationOptions = Apollo.BaseMutationOptions<PreviewWaypointTemplateMutation, PreviewWaypointTemplateMutationVariables>;
export const RefreshWaypointTemplateImageStatusDocument = gql`
    mutation RefreshWaypointTemplateImageStatus($waypointTemplateImageId: ID!) {
  refreshWaypointTemplateImageStatus(
    waypointTemplateImageId: $waypointTemplateImageId
  ) {
    ...FWaypointTemplateImage
  }
}
    ${FWaypointTemplateImageFragmentDoc}`;
export type RefreshWaypointTemplateImageStatusMutationFn = Apollo.MutationFunction<RefreshWaypointTemplateImageStatusMutation, RefreshWaypointTemplateImageStatusMutationVariables>;

/**
 * __useRefreshWaypointTemplateImageStatusMutation_raw__
 *
 * To run a mutation, you first call `useRefreshWaypointTemplateImageStatusMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshWaypointTemplateImageStatusMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshWaypointTemplateImageStatusMutationRaw, { data, loading, error }] = useRefreshWaypointTemplateImageStatusMutation_raw({
 *   variables: {
 *      waypointTemplateImageId: // value for 'waypointTemplateImageId'
 *   },
 * });
 */
export function useRefreshWaypointTemplateImageStatusMutation_raw(baseOptions?: Apollo.MutationHookOptions<RefreshWaypointTemplateImageStatusMutation, RefreshWaypointTemplateImageStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshWaypointTemplateImageStatusMutation, RefreshWaypointTemplateImageStatusMutationVariables>(RefreshWaypointTemplateImageStatusDocument, options);
      }
export type RefreshWaypointTemplateImageStatusMutation_rawHookResult = ReturnType<typeof useRefreshWaypointTemplateImageStatusMutation_raw>;
export type RefreshWaypointTemplateImageStatusMutationResult = Apollo.MutationResult<RefreshWaypointTemplateImageStatusMutation>;
export type RefreshWaypointTemplateImageStatusMutationOptions = Apollo.BaseMutationOptions<RefreshWaypointTemplateImageStatusMutation, RefreshWaypointTemplateImageStatusMutationVariables>;
export const RequestDomainNameVerificationApprovalDocument = gql`
    mutation RequestDomainNameVerificationApproval($id: ID!) {
  requestDomainNameVerificationApproval(id: $id) {
    ...FDomainNameVerification
  }
}
    ${FDomainNameVerificationFragmentDoc}`;
export type RequestDomainNameVerificationApprovalMutationFn = Apollo.MutationFunction<RequestDomainNameVerificationApprovalMutation, RequestDomainNameVerificationApprovalMutationVariables>;

/**
 * __useRequestDomainNameVerificationApprovalMutation_raw__
 *
 * To run a mutation, you first call `useRequestDomainNameVerificationApprovalMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestDomainNameVerificationApprovalMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestDomainNameVerificationApprovalMutationRaw, { data, loading, error }] = useRequestDomainNameVerificationApprovalMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequestDomainNameVerificationApprovalMutation_raw(baseOptions?: Apollo.MutationHookOptions<RequestDomainNameVerificationApprovalMutation, RequestDomainNameVerificationApprovalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestDomainNameVerificationApprovalMutation, RequestDomainNameVerificationApprovalMutationVariables>(RequestDomainNameVerificationApprovalDocument, options);
      }
export type RequestDomainNameVerificationApprovalMutation_rawHookResult = ReturnType<typeof useRequestDomainNameVerificationApprovalMutation_raw>;
export type RequestDomainNameVerificationApprovalMutationResult = Apollo.MutationResult<RequestDomainNameVerificationApprovalMutation>;
export type RequestDomainNameVerificationApprovalMutationOptions = Apollo.BaseMutationOptions<RequestDomainNameVerificationApprovalMutation, RequestDomainNameVerificationApprovalMutationVariables>;
export const RequestPlatformDeleteDocument = gql`
    mutation RequestPlatformDelete {
  requestPlatformDelete
}
    `;
export type RequestPlatformDeleteMutationFn = Apollo.MutationFunction<RequestPlatformDeleteMutation, RequestPlatformDeleteMutationVariables>;

/**
 * __useRequestPlatformDeleteMutation_raw__
 *
 * To run a mutation, you first call `useRequestPlatformDeleteMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPlatformDeleteMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPlatformDeleteMutationRaw, { data, loading, error }] = useRequestPlatformDeleteMutation_raw({
 *   variables: {
 *   },
 * });
 */
export function useRequestPlatformDeleteMutation_raw(baseOptions?: Apollo.MutationHookOptions<RequestPlatformDeleteMutation, RequestPlatformDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPlatformDeleteMutation, RequestPlatformDeleteMutationVariables>(RequestPlatformDeleteDocument, options);
      }
export type RequestPlatformDeleteMutation_rawHookResult = ReturnType<typeof useRequestPlatformDeleteMutation_raw>;
export type RequestPlatformDeleteMutationResult = Apollo.MutationResult<RequestPlatformDeleteMutation>;
export type RequestPlatformDeleteMutationOptions = Apollo.BaseMutationOptions<RequestPlatformDeleteMutation, RequestPlatformDeleteMutationVariables>;
export const SendDnsInformationEmailMessageDocument = gql`
    mutation SendDnsInformationEmailMessage($id: ID!, $toEmailAddress: String!) {
  sendDnsInformationEmailMessage(id: $id, toEmailAddress: $toEmailAddress) {
    ...FDomainNameVerification
  }
}
    ${FDomainNameVerificationFragmentDoc}`;
export type SendDnsInformationEmailMessageMutationFn = Apollo.MutationFunction<SendDnsInformationEmailMessageMutation, SendDnsInformationEmailMessageMutationVariables>;

/**
 * __useSendDnsInformationEmailMessageMutation_raw__
 *
 * To run a mutation, you first call `useSendDnsInformationEmailMessageMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendDnsInformationEmailMessageMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendDnsInformationEmailMessageMutationRaw, { data, loading, error }] = useSendDnsInformationEmailMessageMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      toEmailAddress: // value for 'toEmailAddress'
 *   },
 * });
 */
export function useSendDnsInformationEmailMessageMutation_raw(baseOptions?: Apollo.MutationHookOptions<SendDnsInformationEmailMessageMutation, SendDnsInformationEmailMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendDnsInformationEmailMessageMutation, SendDnsInformationEmailMessageMutationVariables>(SendDnsInformationEmailMessageDocument, options);
      }
export type SendDnsInformationEmailMessageMutation_rawHookResult = ReturnType<typeof useSendDnsInformationEmailMessageMutation_raw>;
export type SendDnsInformationEmailMessageMutationResult = Apollo.MutationResult<SendDnsInformationEmailMessageMutation>;
export type SendDnsInformationEmailMessageMutationOptions = Apollo.BaseMutationOptions<SendDnsInformationEmailMessageMutation, SendDnsInformationEmailMessageMutationVariables>;
export const UpdateContactsGroupDocument = gql`
    mutation UpdateContactsGroup($id: ID!, $name: String!, $key: String, $unsubscribeLinkTemplate: String!, $unsubscribePageTitleTemplate: String!, $unsubscribePageSubtitleTemplate: String!, $unsubscribePageEmailInputLabelTemplate: String!, $unsubscribePageSubmitButtonLabelTemplate: String!, $unsubscribePageConfirmationMessageTemplate: String!, $unsubscribePageInvalidEmailAddressMessageTemplate: String!) {
  updateContactsGroup(
    id: $id
    name: $name
    key: $key
    unsubscribeLinkTemplate: $unsubscribeLinkTemplate
    unsubscribePageTitleTemplate: $unsubscribePageTitleTemplate
    unsubscribePageSubtitleTemplate: $unsubscribePageSubtitleTemplate
    unsubscribePageEmailInputLabelTemplate: $unsubscribePageEmailInputLabelTemplate
    unsubscribePageSubmitButtonLabelTemplate: $unsubscribePageSubmitButtonLabelTemplate
    unsubscribePageConfirmationMessageTemplate: $unsubscribePageConfirmationMessageTemplate
    unsubscribePageInvalidEmailAddressMessageTemplate: $unsubscribePageInvalidEmailAddressMessageTemplate
  ) {
    ...FContactsGroup
  }
}
    ${FContactsGroupFragmentDoc}`;
export type UpdateContactsGroupMutationFn = Apollo.MutationFunction<UpdateContactsGroupMutation, UpdateContactsGroupMutationVariables>;

/**
 * __useUpdateContactsGroupMutation_raw__
 *
 * To run a mutation, you first call `useUpdateContactsGroupMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactsGroupMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactsGroupMutationRaw, { data, loading, error }] = useUpdateContactsGroupMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      key: // value for 'key'
 *      unsubscribeLinkTemplate: // value for 'unsubscribeLinkTemplate'
 *      unsubscribePageTitleTemplate: // value for 'unsubscribePageTitleTemplate'
 *      unsubscribePageSubtitleTemplate: // value for 'unsubscribePageSubtitleTemplate'
 *      unsubscribePageEmailInputLabelTemplate: // value for 'unsubscribePageEmailInputLabelTemplate'
 *      unsubscribePageSubmitButtonLabelTemplate: // value for 'unsubscribePageSubmitButtonLabelTemplate'
 *      unsubscribePageConfirmationMessageTemplate: // value for 'unsubscribePageConfirmationMessageTemplate'
 *      unsubscribePageInvalidEmailAddressMessageTemplate: // value for 'unsubscribePageInvalidEmailAddressMessageTemplate'
 *   },
 * });
 */
export function useUpdateContactsGroupMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateContactsGroupMutation, UpdateContactsGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactsGroupMutation, UpdateContactsGroupMutationVariables>(UpdateContactsGroupDocument, options);
      }
export type UpdateContactsGroupMutation_rawHookResult = ReturnType<typeof useUpdateContactsGroupMutation_raw>;
export type UpdateContactsGroupMutationResult = Apollo.MutationResult<UpdateContactsGroupMutation>;
export type UpdateContactsGroupMutationOptions = Apollo.BaseMutationOptions<UpdateContactsGroupMutation, UpdateContactsGroupMutationVariables>;
export const UpdateEmailTemplateNameDocument = gql`
    mutation UpdateEmailTemplateName($id: ID!, $name: String!) {
  updateEmailTemplateName(id: $id, name: $name) {
    id
    name
  }
}
    `;
export type UpdateEmailTemplateNameMutationFn = Apollo.MutationFunction<UpdateEmailTemplateNameMutation, UpdateEmailTemplateNameMutationVariables>;

/**
 * __useUpdateEmailTemplateNameMutation_raw__
 *
 * To run a mutation, you first call `useUpdateEmailTemplateNameMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailTemplateNameMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailTemplateNameMutationRaw, { data, loading, error }] = useUpdateEmailTemplateNameMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateEmailTemplateNameMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateEmailTemplateNameMutation, UpdateEmailTemplateNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailTemplateNameMutation, UpdateEmailTemplateNameMutationVariables>(UpdateEmailTemplateNameDocument, options);
      }
export type UpdateEmailTemplateNameMutation_rawHookResult = ReturnType<typeof useUpdateEmailTemplateNameMutation_raw>;
export type UpdateEmailTemplateNameMutationResult = Apollo.MutationResult<UpdateEmailTemplateNameMutation>;
export type UpdateEmailTemplateNameMutationOptions = Apollo.BaseMutationOptions<UpdateEmailTemplateNameMutation, UpdateEmailTemplateNameMutationVariables>;
export const UpdatePlatformBillingInformationDocument = gql`
    mutation UpdatePlatformBillingInformation($billingEmailAddress: String!) {
  updatePlatformBillingInformation(billingEmailAddress: $billingEmailAddress) {
    ...FPlatformBillingInformation
  }
}
    ${FPlatformBillingInformationFragmentDoc}`;
export type UpdatePlatformBillingInformationMutationFn = Apollo.MutationFunction<UpdatePlatformBillingInformationMutation, UpdatePlatformBillingInformationMutationVariables>;

/**
 * __useUpdatePlatformBillingInformationMutation_raw__
 *
 * To run a mutation, you first call `useUpdatePlatformBillingInformationMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformBillingInformationMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformBillingInformationMutationRaw, { data, loading, error }] = useUpdatePlatformBillingInformationMutation_raw({
 *   variables: {
 *      billingEmailAddress: // value for 'billingEmailAddress'
 *   },
 * });
 */
export function useUpdatePlatformBillingInformationMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformBillingInformationMutation, UpdatePlatformBillingInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformBillingInformationMutation, UpdatePlatformBillingInformationMutationVariables>(UpdatePlatformBillingInformationDocument, options);
      }
export type UpdatePlatformBillingInformationMutation_rawHookResult = ReturnType<typeof useUpdatePlatformBillingInformationMutation_raw>;
export type UpdatePlatformBillingInformationMutationResult = Apollo.MutationResult<UpdatePlatformBillingInformationMutation>;
export type UpdatePlatformBillingInformationMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformBillingInformationMutation, UpdatePlatformBillingInformationMutationVariables>;
export const UpdatePlatformBillingPlanDocument = gql`
    mutation UpdatePlatformBillingPlan($tier: WaypointFeatureTier!, $paymentMethodId: ID) {
  updatePlatformBillingPlan(tier: $tier, paymentMethodId: $paymentMethodId) {
    ...FPlatformBillingInformation
  }
}
    ${FPlatformBillingInformationFragmentDoc}`;
export type UpdatePlatformBillingPlanMutationFn = Apollo.MutationFunction<UpdatePlatformBillingPlanMutation, UpdatePlatformBillingPlanMutationVariables>;

/**
 * __useUpdatePlatformBillingPlanMutation_raw__
 *
 * To run a mutation, you first call `useUpdatePlatformBillingPlanMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformBillingPlanMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformBillingPlanMutationRaw, { data, loading, error }] = useUpdatePlatformBillingPlanMutation_raw({
 *   variables: {
 *      tier: // value for 'tier'
 *      paymentMethodId: // value for 'paymentMethodId'
 *   },
 * });
 */
export function useUpdatePlatformBillingPlanMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformBillingPlanMutation, UpdatePlatformBillingPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformBillingPlanMutation, UpdatePlatformBillingPlanMutationVariables>(UpdatePlatformBillingPlanDocument, options);
      }
export type UpdatePlatformBillingPlanMutation_rawHookResult = ReturnType<typeof useUpdatePlatformBillingPlanMutation_raw>;
export type UpdatePlatformBillingPlanMutationResult = Apollo.MutationResult<UpdatePlatformBillingPlanMutation>;
export type UpdatePlatformBillingPlanMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformBillingPlanMutation, UpdatePlatformBillingPlanMutationVariables>;
export const UpdatePlatformSesEventTrackingDocument = gql`
    mutation UpdatePlatformSesEventTracking($events: [SesEventName!]!) {
  updatePlatformSesEventTracking(events: $events) {
    ...FPlatformSesConfiguration
  }
}
    ${FPlatformSesConfigurationFragmentDoc}`;
export type UpdatePlatformSesEventTrackingMutationFn = Apollo.MutationFunction<UpdatePlatformSesEventTrackingMutation, UpdatePlatformSesEventTrackingMutationVariables>;

/**
 * __useUpdatePlatformSesEventTrackingMutation_raw__
 *
 * To run a mutation, you first call `useUpdatePlatformSesEventTrackingMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformSesEventTrackingMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformSesEventTrackingMutationRaw, { data, loading, error }] = useUpdatePlatformSesEventTrackingMutation_raw({
 *   variables: {
 *      events: // value for 'events'
 *   },
 * });
 */
export function useUpdatePlatformSesEventTrackingMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformSesEventTrackingMutation, UpdatePlatformSesEventTrackingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformSesEventTrackingMutation, UpdatePlatformSesEventTrackingMutationVariables>(UpdatePlatformSesEventTrackingDocument, options);
      }
export type UpdatePlatformSesEventTrackingMutation_rawHookResult = ReturnType<typeof useUpdatePlatformSesEventTrackingMutation_raw>;
export type UpdatePlatformSesEventTrackingMutationResult = Apollo.MutationResult<UpdatePlatformSesEventTrackingMutation>;
export type UpdatePlatformSesEventTrackingMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformSesEventTrackingMutation, UpdatePlatformSesEventTrackingMutationVariables>;
export const UpdateTemplateSectionsOrderDocument = gql`
    mutation UpdateTemplateSectionsOrder($ids: [ID!]!) {
  updateTemplateSectionsOrder(ids: $ids) {
    ...FTemplateSection
  }
}
    ${FTemplateSectionFragmentDoc}`;
export type UpdateTemplateSectionsOrderMutationFn = Apollo.MutationFunction<UpdateTemplateSectionsOrderMutation, UpdateTemplateSectionsOrderMutationVariables>;

/**
 * __useUpdateTemplateSectionsOrderMutation_raw__
 *
 * To run a mutation, you first call `useUpdateTemplateSectionsOrderMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateSectionsOrderMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateSectionsOrderMutationRaw, { data, loading, error }] = useUpdateTemplateSectionsOrderMutation_raw({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useUpdateTemplateSectionsOrderMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateSectionsOrderMutation, UpdateTemplateSectionsOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateSectionsOrderMutation, UpdateTemplateSectionsOrderMutationVariables>(UpdateTemplateSectionsOrderDocument, options);
      }
export type UpdateTemplateSectionsOrderMutation_rawHookResult = ReturnType<typeof useUpdateTemplateSectionsOrderMutation_raw>;
export type UpdateTemplateSectionsOrderMutationResult = Apollo.MutationResult<UpdateTemplateSectionsOrderMutation>;
export type UpdateTemplateSectionsOrderMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateSectionsOrderMutation, UpdateTemplateSectionsOrderMutationVariables>;
export const UpdateTemplateSectionDocument = gql`
    mutation UpdateTemplateSection($id: ID!, $name: String!) {
  updateTemplateSection(id: $id, name: $name) {
    ...FTemplateSection
  }
}
    ${FTemplateSectionFragmentDoc}`;
export type UpdateTemplateSectionMutationFn = Apollo.MutationFunction<UpdateTemplateSectionMutation, UpdateTemplateSectionMutationVariables>;

/**
 * __useUpdateTemplateSectionMutation_raw__
 *
 * To run a mutation, you first call `useUpdateTemplateSectionMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTemplateSectionMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTemplateSectionMutationRaw, { data, loading, error }] = useUpdateTemplateSectionMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateTemplateSectionMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateTemplateSectionMutation, UpdateTemplateSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTemplateSectionMutation, UpdateTemplateSectionMutationVariables>(UpdateTemplateSectionDocument, options);
      }
export type UpdateTemplateSectionMutation_rawHookResult = ReturnType<typeof useUpdateTemplateSectionMutation_raw>;
export type UpdateTemplateSectionMutationResult = Apollo.MutationResult<UpdateTemplateSectionMutation>;
export type UpdateTemplateSectionMutationOptions = Apollo.BaseMutationOptions<UpdateTemplateSectionMutation, UpdateTemplateSectionMutationVariables>;
export const UpdateVerifiedEmailAddressDocument = gql`
    mutation UpdateVerifiedEmailAddress($id: ID!, $name: String, $username: String!, $domainNameVerificationId: ID!) {
  updateVerifiedEmailAddress(
    id: $id
    name: $name
    username: $username
    domainNameVerificationId: $domainNameVerificationId
  ) {
    ...FVerifiedEmailAddress
  }
}
    ${FVerifiedEmailAddressFragmentDoc}`;
export type UpdateVerifiedEmailAddressMutationFn = Apollo.MutationFunction<UpdateVerifiedEmailAddressMutation, UpdateVerifiedEmailAddressMutationVariables>;

/**
 * __useUpdateVerifiedEmailAddressMutation_raw__
 *
 * To run a mutation, you first call `useUpdateVerifiedEmailAddressMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVerifiedEmailAddressMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVerifiedEmailAddressMutationRaw, { data, loading, error }] = useUpdateVerifiedEmailAddressMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      username: // value for 'username'
 *      domainNameVerificationId: // value for 'domainNameVerificationId'
 *   },
 * });
 */
export function useUpdateVerifiedEmailAddressMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateVerifiedEmailAddressMutation, UpdateVerifiedEmailAddressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVerifiedEmailAddressMutation, UpdateVerifiedEmailAddressMutationVariables>(UpdateVerifiedEmailAddressDocument, options);
      }
export type UpdateVerifiedEmailAddressMutation_rawHookResult = ReturnType<typeof useUpdateVerifiedEmailAddressMutation_raw>;
export type UpdateVerifiedEmailAddressMutationResult = Apollo.MutationResult<UpdateVerifiedEmailAddressMutation>;
export type UpdateVerifiedEmailAddressMutationOptions = Apollo.BaseMutationOptions<UpdateVerifiedEmailAddressMutation, UpdateVerifiedEmailAddressMutationVariables>;
export const UpdateWaypointTemplateDocument = gql`
    mutation UpdateWaypointTemplate($id: ID!, $testScenarios: [TestScenarioInput!]!, $defaultPreviewVariables: JSONObject!, $configuration: WaypointTemplateConfigurationInput!) {
  updateWaypointTemplate(
    id: $id
    testScenarios: $testScenarios
    defaultPreviewVariables: $defaultPreviewVariables
    configuration: $configuration
  ) {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;
export type UpdateWaypointTemplateMutationFn = Apollo.MutationFunction<UpdateWaypointTemplateMutation, UpdateWaypointTemplateMutationVariables>;

/**
 * __useUpdateWaypointTemplateMutation_raw__
 *
 * To run a mutation, you first call `useUpdateWaypointTemplateMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWaypointTemplateMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWaypointTemplateMutationRaw, { data, loading, error }] = useUpdateWaypointTemplateMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      testScenarios: // value for 'testScenarios'
 *      defaultPreviewVariables: // value for 'defaultPreviewVariables'
 *      configuration: // value for 'configuration'
 *   },
 * });
 */
export function useUpdateWaypointTemplateMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateWaypointTemplateMutation, UpdateWaypointTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWaypointTemplateMutation, UpdateWaypointTemplateMutationVariables>(UpdateWaypointTemplateDocument, options);
      }
export type UpdateWaypointTemplateMutation_rawHookResult = ReturnType<typeof useUpdateWaypointTemplateMutation_raw>;
export type UpdateWaypointTemplateMutationResult = Apollo.MutationResult<UpdateWaypointTemplateMutation>;
export type UpdateWaypointTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateWaypointTemplateMutation, UpdateWaypointTemplateMutationVariables>;
export const UpdateWaypointTemplateSectionDocument = gql`
    mutation UpdateWaypointTemplateSection($templateId: ID!, $templateSectionId: ID) {
  updateWaypointTemplateSection(
    templateId: $templateId
    templateSectionId: $templateSectionId
  ) {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;
export type UpdateWaypointTemplateSectionMutationFn = Apollo.MutationFunction<UpdateWaypointTemplateSectionMutation, UpdateWaypointTemplateSectionMutationVariables>;

/**
 * __useUpdateWaypointTemplateSectionMutation_raw__
 *
 * To run a mutation, you first call `useUpdateWaypointTemplateSectionMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWaypointTemplateSectionMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWaypointTemplateSectionMutationRaw, { data, loading, error }] = useUpdateWaypointTemplateSectionMutation_raw({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      templateSectionId: // value for 'templateSectionId'
 *   },
 * });
 */
export function useUpdateWaypointTemplateSectionMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateWaypointTemplateSectionMutation, UpdateWaypointTemplateSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWaypointTemplateSectionMutation, UpdateWaypointTemplateSectionMutationVariables>(UpdateWaypointTemplateSectionDocument, options);
      }
export type UpdateWaypointTemplateSectionMutation_rawHookResult = ReturnType<typeof useUpdateWaypointTemplateSectionMutation_raw>;
export type UpdateWaypointTemplateSectionMutationResult = Apollo.MutationResult<UpdateWaypointTemplateSectionMutation>;
export type UpdateWaypointTemplateSectionMutationOptions = Apollo.BaseMutationOptions<UpdateWaypointTemplateSectionMutation, UpdateWaypointTemplateSectionMutationVariables>;
export const UpdateWorkflowDocument = gql`
    mutation UpdateWorkflow($id: ID!, $triggers: [WorkflowTriggerInput!]!, $stepDefinitions: [WorkflowStepDefinitionInput!]!) {
  updateWorkflow(id: $id, triggers: $triggers, stepDefinitions: $stepDefinitions) {
    ...FWorkflow
  }
}
    ${FWorkflowFragmentDoc}`;
export type UpdateWorkflowMutationFn = Apollo.MutationFunction<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;

/**
 * __useUpdateWorkflowMutation_raw__
 *
 * To run a mutation, you first call `useUpdateWorkflowMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowMutationRaw, { data, loading, error }] = useUpdateWorkflowMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      triggers: // value for 'triggers'
 *      stepDefinitions: // value for 'stepDefinitions'
 *   },
 * });
 */
export function useUpdateWorkflowMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>(UpdateWorkflowDocument, options);
      }
export type UpdateWorkflowMutation_rawHookResult = ReturnType<typeof useUpdateWorkflowMutation_raw>;
export type UpdateWorkflowMutationResult = Apollo.MutationResult<UpdateWorkflowMutation>;
export type UpdateWorkflowMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowMutation, UpdateWorkflowMutationVariables>;
export const UpdateWorkflowNameDocument = gql`
    mutation UpdateWorkflowName($id: ID!, $name: String!) {
  updateWorkflowName(id: $id, name: $name) {
    id
    name
  }
}
    `;
export type UpdateWorkflowNameMutationFn = Apollo.MutationFunction<UpdateWorkflowNameMutation, UpdateWorkflowNameMutationVariables>;

/**
 * __useUpdateWorkflowNameMutation_raw__
 *
 * To run a mutation, you first call `useUpdateWorkflowNameMutation_raw` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWorkflowNameMutation_raw` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWorkflowNameMutationRaw, { data, loading, error }] = useUpdateWorkflowNameMutation_raw({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useUpdateWorkflowNameMutation_raw(baseOptions?: Apollo.MutationHookOptions<UpdateWorkflowNameMutation, UpdateWorkflowNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWorkflowNameMutation, UpdateWorkflowNameMutationVariables>(UpdateWorkflowNameDocument, options);
      }
export type UpdateWorkflowNameMutation_rawHookResult = ReturnType<typeof useUpdateWorkflowNameMutation_raw>;
export type UpdateWorkflowNameMutationResult = Apollo.MutationResult<UpdateWorkflowNameMutation>;
export type UpdateWorkflowNameMutationOptions = Apollo.BaseMutationOptions<UpdateWorkflowNameMutation, UpdateWorkflowNameMutationVariables>;
export const ApiKeysDocument = gql`
    query ApiKeys {
  ApiKeys {
    count
    nodes {
      id
      name
    }
  }
}
    `;

/**
 * __useApiKeysQuery_raw__
 *
 * To run a query within a React component, call `useApiKeysQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useApiKeysQuery_raw(baseOptions?: Apollo.QueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
      }
export function useApiKeysLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
// @ts-ignore
export function useApiKeysSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>): Apollo.UseSuspenseQueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export function useApiKeysSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>): Apollo.UseSuspenseQueryResult<ApiKeysQuery | undefined, ApiKeysQueryVariables>;
export function useApiKeysSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export type ApiKeysQuery_rawHookResult = ReturnType<typeof useApiKeysQuery_raw>;
export type ApiKeysLazyQuery_rawHookResult = ReturnType<typeof useApiKeysLazyQuery_raw>;
export type ApiKeysSuspenseQuery_rawHookResult = ReturnType<typeof useApiKeysSuspenseQuery_raw>;
export type ApiKeysQueryResult = Apollo.QueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export const ContactDocument = gql`
    query Contact($id: ID!) {
  Contact(id: $id) {
    ...FContact
  }
}
    ${FContactFragmentDoc}`;

/**
 * __useContactQuery_raw__
 *
 * To run a query within a React component, call `useContactQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useContactQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactQuery_raw(baseOptions: Apollo.QueryHookOptions<ContactQuery, ContactQueryVariables> & ({ variables: ContactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
      }
export function useContactLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
// @ts-ignore
export function useContactSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactQuery, ContactQueryVariables>): Apollo.UseSuspenseQueryResult<ContactQuery, ContactQueryVariables>;
export function useContactSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactQuery, ContactQueryVariables>): Apollo.UseSuspenseQueryResult<ContactQuery | undefined, ContactQueryVariables>;
export function useContactSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactQuery, ContactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactQuery, ContactQueryVariables>(ContactDocument, options);
        }
export type ContactQuery_rawHookResult = ReturnType<typeof useContactQuery_raw>;
export type ContactLazyQuery_rawHookResult = ReturnType<typeof useContactLazyQuery_raw>;
export type ContactSuspenseQuery_rawHookResult = ReturnType<typeof useContactSuspenseQuery_raw>;
export type ContactQueryResult = Apollo.QueryResult<ContactQuery, ContactQueryVariables>;
export const ContactByEmailAddressDocument = gql`
    query ContactByEmailAddress($emailAddress: String!) {
  findOneContact(emailAddress: $emailAddress) {
    ...FContact
  }
}
    ${FContactFragmentDoc}`;

/**
 * __useContactByEmailAddressQuery_raw__
 *
 * To run a query within a React component, call `useContactByEmailAddressQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useContactByEmailAddressQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactByEmailAddressQuery_raw({
 *   variables: {
 *      emailAddress: // value for 'emailAddress'
 *   },
 * });
 */
export function useContactByEmailAddressQuery_raw(baseOptions: Apollo.QueryHookOptions<ContactByEmailAddressQuery, ContactByEmailAddressQueryVariables> & ({ variables: ContactByEmailAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactByEmailAddressQuery, ContactByEmailAddressQueryVariables>(ContactByEmailAddressDocument, options);
      }
export function useContactByEmailAddressLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<ContactByEmailAddressQuery, ContactByEmailAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactByEmailAddressQuery, ContactByEmailAddressQueryVariables>(ContactByEmailAddressDocument, options);
        }
// @ts-ignore
export function useContactByEmailAddressSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactByEmailAddressQuery, ContactByEmailAddressQueryVariables>): Apollo.UseSuspenseQueryResult<ContactByEmailAddressQuery, ContactByEmailAddressQueryVariables>;
export function useContactByEmailAddressSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactByEmailAddressQuery, ContactByEmailAddressQueryVariables>): Apollo.UseSuspenseQueryResult<ContactByEmailAddressQuery | undefined, ContactByEmailAddressQueryVariables>;
export function useContactByEmailAddressSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactByEmailAddressQuery, ContactByEmailAddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactByEmailAddressQuery, ContactByEmailAddressQueryVariables>(ContactByEmailAddressDocument, options);
        }
export type ContactByEmailAddressQuery_rawHookResult = ReturnType<typeof useContactByEmailAddressQuery_raw>;
export type ContactByEmailAddressLazyQuery_rawHookResult = ReturnType<typeof useContactByEmailAddressLazyQuery_raw>;
export type ContactByEmailAddressSuspenseQuery_rawHookResult = ReturnType<typeof useContactByEmailAddressSuspenseQuery_raw>;
export type ContactByEmailAddressQueryResult = Apollo.QueryResult<ContactByEmailAddressQuery, ContactByEmailAddressQueryVariables>;
export const ContactsDocument = gql`
    query Contacts($page: Int) {
  Contacts(page: $page) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FContact
    }
  }
}
    ${FContactFragmentDoc}`;

/**
 * __useContactsQuery_raw__
 *
 * To run a query within a React component, call `useContactsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useContactsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useContactsQuery_raw(baseOptions?: Apollo.QueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
      }
export function useContactsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
// @ts-ignore
export function useContactsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactsQuery, ContactsQueryVariables>): Apollo.UseSuspenseQueryResult<ContactsQuery, ContactsQueryVariables>;
export function useContactsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsQuery, ContactsQueryVariables>): Apollo.UseSuspenseQueryResult<ContactsQuery | undefined, ContactsQueryVariables>;
export function useContactsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsQuery, ContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsQuery, ContactsQueryVariables>(ContactsDocument, options);
        }
export type ContactsQuery_rawHookResult = ReturnType<typeof useContactsQuery_raw>;
export type ContactsLazyQuery_rawHookResult = ReturnType<typeof useContactsLazyQuery_raw>;
export type ContactsSuspenseQuery_rawHookResult = ReturnType<typeof useContactsSuspenseQuery_raw>;
export type ContactsQueryResult = Apollo.QueryResult<ContactsQuery, ContactsQueryVariables>;
export const ContactsGroupDocument = gql`
    query ContactsGroup($id: ID!) {
  ContactsGroup(id: $id) {
    ...FContactsGroup
  }
}
    ${FContactsGroupFragmentDoc}`;

/**
 * __useContactsGroupQuery_raw__
 *
 * To run a query within a React component, call `useContactsGroupQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useContactsGroupQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsGroupQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactsGroupQuery_raw(baseOptions: Apollo.QueryHookOptions<ContactsGroupQuery, ContactsGroupQueryVariables> & ({ variables: ContactsGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsGroupQuery, ContactsGroupQueryVariables>(ContactsGroupDocument, options);
      }
export function useContactsGroupLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<ContactsGroupQuery, ContactsGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsGroupQuery, ContactsGroupQueryVariables>(ContactsGroupDocument, options);
        }
// @ts-ignore
export function useContactsGroupSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactsGroupQuery, ContactsGroupQueryVariables>): Apollo.UseSuspenseQueryResult<ContactsGroupQuery, ContactsGroupQueryVariables>;
export function useContactsGroupSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsGroupQuery, ContactsGroupQueryVariables>): Apollo.UseSuspenseQueryResult<ContactsGroupQuery | undefined, ContactsGroupQueryVariables>;
export function useContactsGroupSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsGroupQuery, ContactsGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsGroupQuery, ContactsGroupQueryVariables>(ContactsGroupDocument, options);
        }
export type ContactsGroupQuery_rawHookResult = ReturnType<typeof useContactsGroupQuery_raw>;
export type ContactsGroupLazyQuery_rawHookResult = ReturnType<typeof useContactsGroupLazyQuery_raw>;
export type ContactsGroupSuspenseQuery_rawHookResult = ReturnType<typeof useContactsGroupSuspenseQuery_raw>;
export type ContactsGroupQueryResult = Apollo.QueryResult<ContactsGroupQuery, ContactsGroupQueryVariables>;
export const ContactsGroupContactsDocument = gql`
    query ContactsGroupContacts($contactsGroupId: ID!, $page: Int) {
  ContactsGroupContacts(contactsGroupId: $contactsGroupId, page: $page) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FContactsGroupContact
    }
  }
}
    ${FContactsGroupContactFragmentDoc}`;

/**
 * __useContactsGroupContactsQuery_raw__
 *
 * To run a query within a React component, call `useContactsGroupContactsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useContactsGroupContactsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsGroupContactsQuery_raw({
 *   variables: {
 *      contactsGroupId: // value for 'contactsGroupId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useContactsGroupContactsQuery_raw(baseOptions: Apollo.QueryHookOptions<ContactsGroupContactsQuery, ContactsGroupContactsQueryVariables> & ({ variables: ContactsGroupContactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsGroupContactsQuery, ContactsGroupContactsQueryVariables>(ContactsGroupContactsDocument, options);
      }
export function useContactsGroupContactsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<ContactsGroupContactsQuery, ContactsGroupContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsGroupContactsQuery, ContactsGroupContactsQueryVariables>(ContactsGroupContactsDocument, options);
        }
// @ts-ignore
export function useContactsGroupContactsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactsGroupContactsQuery, ContactsGroupContactsQueryVariables>): Apollo.UseSuspenseQueryResult<ContactsGroupContactsQuery, ContactsGroupContactsQueryVariables>;
export function useContactsGroupContactsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsGroupContactsQuery, ContactsGroupContactsQueryVariables>): Apollo.UseSuspenseQueryResult<ContactsGroupContactsQuery | undefined, ContactsGroupContactsQueryVariables>;
export function useContactsGroupContactsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsGroupContactsQuery, ContactsGroupContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsGroupContactsQuery, ContactsGroupContactsQueryVariables>(ContactsGroupContactsDocument, options);
        }
export type ContactsGroupContactsQuery_rawHookResult = ReturnType<typeof useContactsGroupContactsQuery_raw>;
export type ContactsGroupContactsLazyQuery_rawHookResult = ReturnType<typeof useContactsGroupContactsLazyQuery_raw>;
export type ContactsGroupContactsSuspenseQuery_rawHookResult = ReturnType<typeof useContactsGroupContactsSuspenseQuery_raw>;
export type ContactsGroupContactsQueryResult = Apollo.QueryResult<ContactsGroupContactsQuery, ContactsGroupContactsQueryVariables>;
export const ContactsGroupsDocument = gql`
    query ContactsGroups($page: Int) {
  ContactsGroups(page: $page) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FContactsGroup
    }
  }
}
    ${FContactsGroupFragmentDoc}`;

/**
 * __useContactsGroupsQuery_raw__
 *
 * To run a query within a React component, call `useContactsGroupsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useContactsGroupsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsGroupsQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useContactsGroupsQuery_raw(baseOptions?: Apollo.QueryHookOptions<ContactsGroupsQuery, ContactsGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsGroupsQuery, ContactsGroupsQueryVariables>(ContactsGroupsDocument, options);
      }
export function useContactsGroupsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<ContactsGroupsQuery, ContactsGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsGroupsQuery, ContactsGroupsQueryVariables>(ContactsGroupsDocument, options);
        }
// @ts-ignore
export function useContactsGroupsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<ContactsGroupsQuery, ContactsGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ContactsGroupsQuery, ContactsGroupsQueryVariables>;
export function useContactsGroupsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsGroupsQuery, ContactsGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<ContactsGroupsQuery | undefined, ContactsGroupsQueryVariables>;
export function useContactsGroupsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContactsGroupsQuery, ContactsGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContactsGroupsQuery, ContactsGroupsQueryVariables>(ContactsGroupsDocument, options);
        }
export type ContactsGroupsQuery_rawHookResult = ReturnType<typeof useContactsGroupsQuery_raw>;
export type ContactsGroupsLazyQuery_rawHookResult = ReturnType<typeof useContactsGroupsLazyQuery_raw>;
export type ContactsGroupsSuspenseQuery_rawHookResult = ReturnType<typeof useContactsGroupsSuspenseQuery_raw>;
export type ContactsGroupsQueryResult = Apollo.QueryResult<ContactsGroupsQuery, ContactsGroupsQueryVariables>;
export const CurrentPlatformUsageInformationDocument = gql`
    query CurrentPlatformUsageInformation {
  currentPlatformUsageInformation {
    totalUsage
    baseTierLimit
    overage
    overageCostPerThousand
    periodStart
    periodEnd
  }
}
    `;

/**
 * __useCurrentPlatformUsageInformationQuery_raw__
 *
 * To run a query within a React component, call `useCurrentPlatformUsageInformationQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useCurrentPlatformUsageInformationQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentPlatformUsageInformationQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useCurrentPlatformUsageInformationQuery_raw(baseOptions?: Apollo.QueryHookOptions<CurrentPlatformUsageInformationQuery, CurrentPlatformUsageInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentPlatformUsageInformationQuery, CurrentPlatformUsageInformationQueryVariables>(CurrentPlatformUsageInformationDocument, options);
      }
export function useCurrentPlatformUsageInformationLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<CurrentPlatformUsageInformationQuery, CurrentPlatformUsageInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentPlatformUsageInformationQuery, CurrentPlatformUsageInformationQueryVariables>(CurrentPlatformUsageInformationDocument, options);
        }
// @ts-ignore
export function useCurrentPlatformUsageInformationSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<CurrentPlatformUsageInformationQuery, CurrentPlatformUsageInformationQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentPlatformUsageInformationQuery, CurrentPlatformUsageInformationQueryVariables>;
export function useCurrentPlatformUsageInformationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPlatformUsageInformationQuery, CurrentPlatformUsageInformationQueryVariables>): Apollo.UseSuspenseQueryResult<CurrentPlatformUsageInformationQuery | undefined, CurrentPlatformUsageInformationQueryVariables>;
export function useCurrentPlatformUsageInformationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentPlatformUsageInformationQuery, CurrentPlatformUsageInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentPlatformUsageInformationQuery, CurrentPlatformUsageInformationQueryVariables>(CurrentPlatformUsageInformationDocument, options);
        }
export type CurrentPlatformUsageInformationQuery_rawHookResult = ReturnType<typeof useCurrentPlatformUsageInformationQuery_raw>;
export type CurrentPlatformUsageInformationLazyQuery_rawHookResult = ReturnType<typeof useCurrentPlatformUsageInformationLazyQuery_raw>;
export type CurrentPlatformUsageInformationSuspenseQuery_rawHookResult = ReturnType<typeof useCurrentPlatformUsageInformationSuspenseQuery_raw>;
export type CurrentPlatformUsageInformationQueryResult = Apollo.QueryResult<CurrentPlatformUsageInformationQuery, CurrentPlatformUsageInformationQueryVariables>;
export const DomainNameVerificationDocument = gql`
    query DomainNameVerification($id: ID!) {
  DomainNameVerification(id: $id) {
    ...FDomainNameVerification
    ...FDomainNameVerificationRecords
  }
}
    ${FDomainNameVerificationFragmentDoc}
${FDomainNameVerificationRecordsFragmentDoc}`;

/**
 * __useDomainNameVerificationQuery_raw__
 *
 * To run a query within a React component, call `useDomainNameVerificationQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useDomainNameVerificationQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainNameVerificationQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDomainNameVerificationQuery_raw(baseOptions: Apollo.QueryHookOptions<DomainNameVerificationQuery, DomainNameVerificationQueryVariables> & ({ variables: DomainNameVerificationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>(DomainNameVerificationDocument, options);
      }
export function useDomainNameVerificationLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>(DomainNameVerificationDocument, options);
        }
// @ts-ignore
export function useDomainNameVerificationSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>;
export function useDomainNameVerificationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>): Apollo.UseSuspenseQueryResult<DomainNameVerificationQuery | undefined, DomainNameVerificationQueryVariables>;
export function useDomainNameVerificationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>(DomainNameVerificationDocument, options);
        }
export type DomainNameVerificationQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationQuery_raw>;
export type DomainNameVerificationLazyQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationLazyQuery_raw>;
export type DomainNameVerificationSuspenseQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationSuspenseQuery_raw>;
export type DomainNameVerificationQueryResult = Apollo.QueryResult<DomainNameVerificationQuery, DomainNameVerificationQueryVariables>;
export const DomainNameVerificationsDocument = gql`
    query DomainNameVerifications($page: Int) {
  DomainNameVerifications(page: $page) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FDomainNameVerification
    }
  }
}
    ${FDomainNameVerificationFragmentDoc}`;

/**
 * __useDomainNameVerificationsQuery_raw__
 *
 * To run a query within a React component, call `useDomainNameVerificationsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useDomainNameVerificationsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainNameVerificationsQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDomainNameVerificationsQuery_raw(baseOptions?: Apollo.QueryHookOptions<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>(DomainNameVerificationsDocument, options);
      }
export function useDomainNameVerificationsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>(DomainNameVerificationsDocument, options);
        }
// @ts-ignore
export function useDomainNameVerificationsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>;
export function useDomainNameVerificationsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>): Apollo.UseSuspenseQueryResult<DomainNameVerificationsQuery | undefined, DomainNameVerificationsQueryVariables>;
export function useDomainNameVerificationsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>(DomainNameVerificationsDocument, options);
        }
export type DomainNameVerificationsQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationsQuery_raw>;
export type DomainNameVerificationsLazyQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationsLazyQuery_raw>;
export type DomainNameVerificationsSuspenseQuery_rawHookResult = ReturnType<typeof useDomainNameVerificationsSuspenseQuery_raw>;
export type DomainNameVerificationsQueryResult = Apollo.QueryResult<DomainNameVerificationsQuery, DomainNameVerificationsQueryVariables>;
export const EmailMessageDocument = gql`
    query EmailMessage($id: ID!) {
  EmailMessage(id: $id) {
    id
    ...FEmailMessage
  }
}
    ${FEmailMessageFragmentDoc}`;

/**
 * __useEmailMessageQuery_raw__
 *
 * To run a query within a React component, call `useEmailMessageQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useEmailMessageQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMessageQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailMessageQuery_raw(baseOptions: Apollo.QueryHookOptions<EmailMessageQuery, EmailMessageQueryVariables> & ({ variables: EmailMessageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMessageQuery, EmailMessageQueryVariables>(EmailMessageDocument, options);
      }
export function useEmailMessageLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<EmailMessageQuery, EmailMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMessageQuery, EmailMessageQueryVariables>(EmailMessageDocument, options);
        }
// @ts-ignore
export function useEmailMessageSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailMessageQuery, EmailMessageQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessageQuery, EmailMessageQueryVariables>;
export function useEmailMessageSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessageQuery, EmailMessageQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessageQuery | undefined, EmailMessageQueryVariables>;
export function useEmailMessageSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessageQuery, EmailMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailMessageQuery, EmailMessageQueryVariables>(EmailMessageDocument, options);
        }
export type EmailMessageQuery_rawHookResult = ReturnType<typeof useEmailMessageQuery_raw>;
export type EmailMessageLazyQuery_rawHookResult = ReturnType<typeof useEmailMessageLazyQuery_raw>;
export type EmailMessageSuspenseQuery_rawHookResult = ReturnType<typeof useEmailMessageSuspenseQuery_raw>;
export type EmailMessageQueryResult = Apollo.QueryResult<EmailMessageQuery, EmailMessageQueryVariables>;
export const EmailMessageLastEventDocument = gql`
    query EmailMessageLastEvent($id: ID!) {
  EmailMessage(id: $id) {
    id
    createdAt
    lastEvent {
      ...FTimelineLogItem
    }
  }
}
    ${FTimelineLogItemFragmentDoc}`;

/**
 * __useEmailMessageLastEventQuery_raw__
 *
 * To run a query within a React component, call `useEmailMessageLastEventQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useEmailMessageLastEventQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMessageLastEventQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailMessageLastEventQuery_raw(baseOptions: Apollo.QueryHookOptions<EmailMessageLastEventQuery, EmailMessageLastEventQueryVariables> & ({ variables: EmailMessageLastEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMessageLastEventQuery, EmailMessageLastEventQueryVariables>(EmailMessageLastEventDocument, options);
      }
export function useEmailMessageLastEventLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<EmailMessageLastEventQuery, EmailMessageLastEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMessageLastEventQuery, EmailMessageLastEventQueryVariables>(EmailMessageLastEventDocument, options);
        }
// @ts-ignore
export function useEmailMessageLastEventSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailMessageLastEventQuery, EmailMessageLastEventQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessageLastEventQuery, EmailMessageLastEventQueryVariables>;
export function useEmailMessageLastEventSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessageLastEventQuery, EmailMessageLastEventQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessageLastEventQuery | undefined, EmailMessageLastEventQueryVariables>;
export function useEmailMessageLastEventSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessageLastEventQuery, EmailMessageLastEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailMessageLastEventQuery, EmailMessageLastEventQueryVariables>(EmailMessageLastEventDocument, options);
        }
export type EmailMessageLastEventQuery_rawHookResult = ReturnType<typeof useEmailMessageLastEventQuery_raw>;
export type EmailMessageLastEventLazyQuery_rawHookResult = ReturnType<typeof useEmailMessageLastEventLazyQuery_raw>;
export type EmailMessageLastEventSuspenseQuery_rawHookResult = ReturnType<typeof useEmailMessageLastEventSuspenseQuery_raw>;
export type EmailMessageLastEventQueryResult = Apollo.QueryResult<EmailMessageLastEventQuery, EmailMessageLastEventQueryVariables>;
export const EmailMessageTimelineLogItemsDocument = gql`
    query EmailMessageTimelineLogItems($page: Int, $id: ID!) {
  TimelineLogItems: EmailMessageTimelineLogItems(page: $page, id: $id) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FTimelineLogItem
    }
  }
}
    ${FTimelineLogItemFragmentDoc}`;

/**
 * __useEmailMessageTimelineLogItemsQuery_raw__
 *
 * To run a query within a React component, call `useEmailMessageTimelineLogItemsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useEmailMessageTimelineLogItemsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMessageTimelineLogItemsQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailMessageTimelineLogItemsQuery_raw(baseOptions: Apollo.QueryHookOptions<EmailMessageTimelineLogItemsQuery, EmailMessageTimelineLogItemsQueryVariables> & ({ variables: EmailMessageTimelineLogItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMessageTimelineLogItemsQuery, EmailMessageTimelineLogItemsQueryVariables>(EmailMessageTimelineLogItemsDocument, options);
      }
export function useEmailMessageTimelineLogItemsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<EmailMessageTimelineLogItemsQuery, EmailMessageTimelineLogItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMessageTimelineLogItemsQuery, EmailMessageTimelineLogItemsQueryVariables>(EmailMessageTimelineLogItemsDocument, options);
        }
// @ts-ignore
export function useEmailMessageTimelineLogItemsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailMessageTimelineLogItemsQuery, EmailMessageTimelineLogItemsQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessageTimelineLogItemsQuery, EmailMessageTimelineLogItemsQueryVariables>;
export function useEmailMessageTimelineLogItemsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessageTimelineLogItemsQuery, EmailMessageTimelineLogItemsQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessageTimelineLogItemsQuery | undefined, EmailMessageTimelineLogItemsQueryVariables>;
export function useEmailMessageTimelineLogItemsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessageTimelineLogItemsQuery, EmailMessageTimelineLogItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailMessageTimelineLogItemsQuery, EmailMessageTimelineLogItemsQueryVariables>(EmailMessageTimelineLogItemsDocument, options);
        }
export type EmailMessageTimelineLogItemsQuery_rawHookResult = ReturnType<typeof useEmailMessageTimelineLogItemsQuery_raw>;
export type EmailMessageTimelineLogItemsLazyQuery_rawHookResult = ReturnType<typeof useEmailMessageTimelineLogItemsLazyQuery_raw>;
export type EmailMessageTimelineLogItemsSuspenseQuery_rawHookResult = ReturnType<typeof useEmailMessageTimelineLogItemsSuspenseQuery_raw>;
export type EmailMessageTimelineLogItemsQueryResult = Apollo.QueryResult<EmailMessageTimelineLogItemsQuery, EmailMessageTimelineLogItemsQueryVariables>;
export const EmailMessagesDocument = gql`
    query EmailMessages($page: Int, $filter: EmailMessagesFilterInput) {
  EmailMessages(page: $page, filter: $filter) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FEmailMessageLight
    }
  }
}
    ${FEmailMessageLightFragmentDoc}`;

/**
 * __useEmailMessagesQuery_raw__
 *
 * To run a query within a React component, call `useEmailMessagesQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useEmailMessagesQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMessagesQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmailMessagesQuery_raw(baseOptions?: Apollo.QueryHookOptions<EmailMessagesQuery, EmailMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMessagesQuery, EmailMessagesQueryVariables>(EmailMessagesDocument, options);
      }
export function useEmailMessagesLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<EmailMessagesQuery, EmailMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMessagesQuery, EmailMessagesQueryVariables>(EmailMessagesDocument, options);
        }
// @ts-ignore
export function useEmailMessagesSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailMessagesQuery, EmailMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessagesQuery, EmailMessagesQueryVariables>;
export function useEmailMessagesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessagesQuery, EmailMessagesQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessagesQuery | undefined, EmailMessagesQueryVariables>;
export function useEmailMessagesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessagesQuery, EmailMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailMessagesQuery, EmailMessagesQueryVariables>(EmailMessagesDocument, options);
        }
export type EmailMessagesQuery_rawHookResult = ReturnType<typeof useEmailMessagesQuery_raw>;
export type EmailMessagesLazyQuery_rawHookResult = ReturnType<typeof useEmailMessagesLazyQuery_raw>;
export type EmailMessagesSuspenseQuery_rawHookResult = ReturnType<typeof useEmailMessagesSuspenseQuery_raw>;
export type EmailMessagesQueryResult = Apollo.QueryResult<EmailMessagesQuery, EmailMessagesQueryVariables>;
export const EmailMessagesExportDocument = gql`
    query EmailMessagesExport($page: Int, $limit: Int, $filter: EmailMessagesFilterInput) {
  EmailMessages(page: $page, limit: $limit, filter: $filter) {
    count
    nodes {
      id
      createdAt
      updatedAt
      processedAt
      status
      source
      metaId
      metadata
      waypointTemplateId
      sourceWorkflowRunId
      sourceEmailMessagesBatchId
      contactsGroupId
      message {
        from
        to
        cc
        bcc
        replyTo
        subject
      }
    }
  }
}
    `;

/**
 * __useEmailMessagesExportQuery_raw__
 *
 * To run a query within a React component, call `useEmailMessagesExportQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useEmailMessagesExportQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMessagesExportQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmailMessagesExportQuery_raw(baseOptions?: Apollo.QueryHookOptions<EmailMessagesExportQuery, EmailMessagesExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMessagesExportQuery, EmailMessagesExportQueryVariables>(EmailMessagesExportDocument, options);
      }
export function useEmailMessagesExportLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<EmailMessagesExportQuery, EmailMessagesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMessagesExportQuery, EmailMessagesExportQueryVariables>(EmailMessagesExportDocument, options);
        }
// @ts-ignore
export function useEmailMessagesExportSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailMessagesExportQuery, EmailMessagesExportQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessagesExportQuery, EmailMessagesExportQueryVariables>;
export function useEmailMessagesExportSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessagesExportQuery, EmailMessagesExportQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessagesExportQuery | undefined, EmailMessagesExportQueryVariables>;
export function useEmailMessagesExportSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessagesExportQuery, EmailMessagesExportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailMessagesExportQuery, EmailMessagesExportQueryVariables>(EmailMessagesExportDocument, options);
        }
export type EmailMessagesExportQuery_rawHookResult = ReturnType<typeof useEmailMessagesExportQuery_raw>;
export type EmailMessagesExportLazyQuery_rawHookResult = ReturnType<typeof useEmailMessagesExportLazyQuery_raw>;
export type EmailMessagesExportSuspenseQuery_rawHookResult = ReturnType<typeof useEmailMessagesExportSuspenseQuery_raw>;
export type EmailMessagesExportQueryResult = Apollo.QueryResult<EmailMessagesExportQuery, EmailMessagesExportQueryVariables>;
export const EmailMessagesReportDocument = gql`
    query EmailMessagesReport($filter: EmailMessagesFilterInput) {
  EmailMessages(filter: $filter) {
    count
    report {
      bouncedCount
      clickedCount
      complainedCount
      deliveredCount
      openedCount
      erroredCount
      suppressedCount
      unsubscribedCount
    }
  }
}
    `;

/**
 * __useEmailMessagesReportQuery_raw__
 *
 * To run a query within a React component, call `useEmailMessagesReportQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useEmailMessagesReportQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailMessagesReportQuery_raw({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useEmailMessagesReportQuery_raw(baseOptions?: Apollo.QueryHookOptions<EmailMessagesReportQuery, EmailMessagesReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailMessagesReportQuery, EmailMessagesReportQueryVariables>(EmailMessagesReportDocument, options);
      }
export function useEmailMessagesReportLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<EmailMessagesReportQuery, EmailMessagesReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailMessagesReportQuery, EmailMessagesReportQueryVariables>(EmailMessagesReportDocument, options);
        }
// @ts-ignore
export function useEmailMessagesReportSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailMessagesReportQuery, EmailMessagesReportQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessagesReportQuery, EmailMessagesReportQueryVariables>;
export function useEmailMessagesReportSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessagesReportQuery, EmailMessagesReportQueryVariables>): Apollo.UseSuspenseQueryResult<EmailMessagesReportQuery | undefined, EmailMessagesReportQueryVariables>;
export function useEmailMessagesReportSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailMessagesReportQuery, EmailMessagesReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailMessagesReportQuery, EmailMessagesReportQueryVariables>(EmailMessagesReportDocument, options);
        }
export type EmailMessagesReportQuery_rawHookResult = ReturnType<typeof useEmailMessagesReportQuery_raw>;
export type EmailMessagesReportLazyQuery_rawHookResult = ReturnType<typeof useEmailMessagesReportLazyQuery_raw>;
export type EmailMessagesReportSuspenseQuery_rawHookResult = ReturnType<typeof useEmailMessagesReportSuspenseQuery_raw>;
export type EmailMessagesReportQueryResult = Apollo.QueryResult<EmailMessagesReportQuery, EmailMessagesReportQueryVariables>;
export const EmailTemplateHtmlPreviewDocument = gql`
    query EmailTemplateHtmlPreview($id: ID!, $type: EmailTemplateHtmlPreviewType!) {
  EmailTemplateHtmlPreview(id: $id, type: $type)
}
    `;

/**
 * __useEmailTemplateHtmlPreviewQuery_raw__
 *
 * To run a query within a React component, call `useEmailTemplateHtmlPreviewQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useEmailTemplateHtmlPreviewQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailTemplateHtmlPreviewQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useEmailTemplateHtmlPreviewQuery_raw(baseOptions: Apollo.QueryHookOptions<EmailTemplateHtmlPreviewQuery, EmailTemplateHtmlPreviewQueryVariables> & ({ variables: EmailTemplateHtmlPreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailTemplateHtmlPreviewQuery, EmailTemplateHtmlPreviewQueryVariables>(EmailTemplateHtmlPreviewDocument, options);
      }
export function useEmailTemplateHtmlPreviewLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<EmailTemplateHtmlPreviewQuery, EmailTemplateHtmlPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailTemplateHtmlPreviewQuery, EmailTemplateHtmlPreviewQueryVariables>(EmailTemplateHtmlPreviewDocument, options);
        }
// @ts-ignore
export function useEmailTemplateHtmlPreviewSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailTemplateHtmlPreviewQuery, EmailTemplateHtmlPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<EmailTemplateHtmlPreviewQuery, EmailTemplateHtmlPreviewQueryVariables>;
export function useEmailTemplateHtmlPreviewSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailTemplateHtmlPreviewQuery, EmailTemplateHtmlPreviewQueryVariables>): Apollo.UseSuspenseQueryResult<EmailTemplateHtmlPreviewQuery | undefined, EmailTemplateHtmlPreviewQueryVariables>;
export function useEmailTemplateHtmlPreviewSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailTemplateHtmlPreviewQuery, EmailTemplateHtmlPreviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailTemplateHtmlPreviewQuery, EmailTemplateHtmlPreviewQueryVariables>(EmailTemplateHtmlPreviewDocument, options);
        }
export type EmailTemplateHtmlPreviewQuery_rawHookResult = ReturnType<typeof useEmailTemplateHtmlPreviewQuery_raw>;
export type EmailTemplateHtmlPreviewLazyQuery_rawHookResult = ReturnType<typeof useEmailTemplateHtmlPreviewLazyQuery_raw>;
export type EmailTemplateHtmlPreviewSuspenseQuery_rawHookResult = ReturnType<typeof useEmailTemplateHtmlPreviewSuspenseQuery_raw>;
export type EmailTemplateHtmlPreviewQueryResult = Apollo.QueryResult<EmailTemplateHtmlPreviewQuery, EmailTemplateHtmlPreviewQueryVariables>;
export const PlatformBillingInformationDocument = gql`
    query PlatformBillingInformation {
  PlatformBillingInformation {
    ...FPlatformBillingInformation
  }
}
    ${FPlatformBillingInformationFragmentDoc}`;

/**
 * __usePlatformBillingInformationQuery_raw__
 *
 * To run a query within a React component, call `usePlatformBillingInformationQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `usePlatformBillingInformationQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformBillingInformationQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function usePlatformBillingInformationQuery_raw(baseOptions?: Apollo.QueryHookOptions<PlatformBillingInformationQuery, PlatformBillingInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformBillingInformationQuery, PlatformBillingInformationQueryVariables>(PlatformBillingInformationDocument, options);
      }
export function usePlatformBillingInformationLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<PlatformBillingInformationQuery, PlatformBillingInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformBillingInformationQuery, PlatformBillingInformationQueryVariables>(PlatformBillingInformationDocument, options);
        }
// @ts-ignore
export function usePlatformBillingInformationSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformBillingInformationQuery, PlatformBillingInformationQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformBillingInformationQuery, PlatformBillingInformationQueryVariables>;
export function usePlatformBillingInformationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformBillingInformationQuery, PlatformBillingInformationQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformBillingInformationQuery | undefined, PlatformBillingInformationQueryVariables>;
export function usePlatformBillingInformationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformBillingInformationQuery, PlatformBillingInformationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformBillingInformationQuery, PlatformBillingInformationQueryVariables>(PlatformBillingInformationDocument, options);
        }
export type PlatformBillingInformationQuery_rawHookResult = ReturnType<typeof usePlatformBillingInformationQuery_raw>;
export type PlatformBillingInformationLazyQuery_rawHookResult = ReturnType<typeof usePlatformBillingInformationLazyQuery_raw>;
export type PlatformBillingInformationSuspenseQuery_rawHookResult = ReturnType<typeof usePlatformBillingInformationSuspenseQuery_raw>;
export type PlatformBillingInformationQueryResult = Apollo.QueryResult<PlatformBillingInformationQuery, PlatformBillingInformationQueryVariables>;
export const PlatformSesConfigurationDocument = gql`
    query PlatformSesConfiguration {
  PlatformSesConfiguration {
    ...FPlatformSesConfiguration
  }
}
    ${FPlatformSesConfigurationFragmentDoc}`;

/**
 * __usePlatformSesConfigurationQuery_raw__
 *
 * To run a query within a React component, call `usePlatformSesConfigurationQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `usePlatformSesConfigurationQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlatformSesConfigurationQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function usePlatformSesConfigurationQuery_raw(baseOptions?: Apollo.QueryHookOptions<PlatformSesConfigurationQuery, PlatformSesConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlatformSesConfigurationQuery, PlatformSesConfigurationQueryVariables>(PlatformSesConfigurationDocument, options);
      }
export function usePlatformSesConfigurationLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<PlatformSesConfigurationQuery, PlatformSesConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlatformSesConfigurationQuery, PlatformSesConfigurationQueryVariables>(PlatformSesConfigurationDocument, options);
        }
// @ts-ignore
export function usePlatformSesConfigurationSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<PlatformSesConfigurationQuery, PlatformSesConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformSesConfigurationQuery, PlatformSesConfigurationQueryVariables>;
export function usePlatformSesConfigurationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformSesConfigurationQuery, PlatformSesConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<PlatformSesConfigurationQuery | undefined, PlatformSesConfigurationQueryVariables>;
export function usePlatformSesConfigurationSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PlatformSesConfigurationQuery, PlatformSesConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PlatformSesConfigurationQuery, PlatformSesConfigurationQueryVariables>(PlatformSesConfigurationDocument, options);
        }
export type PlatformSesConfigurationQuery_rawHookResult = ReturnType<typeof usePlatformSesConfigurationQuery_raw>;
export type PlatformSesConfigurationLazyQuery_rawHookResult = ReturnType<typeof usePlatformSesConfigurationLazyQuery_raw>;
export type PlatformSesConfigurationSuspenseQuery_rawHookResult = ReturnType<typeof usePlatformSesConfigurationSuspenseQuery_raw>;
export type PlatformSesConfigurationQueryResult = Apollo.QueryResult<PlatformSesConfigurationQuery, PlatformSesConfigurationQueryVariables>;
export const RequestLogDocument = gql`
    query RequestLog($id: ID!) {
  RequestLog(id: $id) {
    ...FRequestLog
  }
}
    ${FRequestLogFragmentDoc}`;

/**
 * __useRequestLogQuery_raw__
 *
 * To run a query within a React component, call `useRequestLogQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useRequestLogQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestLogQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRequestLogQuery_raw(baseOptions: Apollo.QueryHookOptions<RequestLogQuery, RequestLogQueryVariables> & ({ variables: RequestLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestLogQuery, RequestLogQueryVariables>(RequestLogDocument, options);
      }
export function useRequestLogLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<RequestLogQuery, RequestLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestLogQuery, RequestLogQueryVariables>(RequestLogDocument, options);
        }
// @ts-ignore
export function useRequestLogSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<RequestLogQuery, RequestLogQueryVariables>): Apollo.UseSuspenseQueryResult<RequestLogQuery, RequestLogQueryVariables>;
export function useRequestLogSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestLogQuery, RequestLogQueryVariables>): Apollo.UseSuspenseQueryResult<RequestLogQuery | undefined, RequestLogQueryVariables>;
export function useRequestLogSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestLogQuery, RequestLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestLogQuery, RequestLogQueryVariables>(RequestLogDocument, options);
        }
export type RequestLogQuery_rawHookResult = ReturnType<typeof useRequestLogQuery_raw>;
export type RequestLogLazyQuery_rawHookResult = ReturnType<typeof useRequestLogLazyQuery_raw>;
export type RequestLogSuspenseQuery_rawHookResult = ReturnType<typeof useRequestLogSuspenseQuery_raw>;
export type RequestLogQueryResult = Apollo.QueryResult<RequestLogQuery, RequestLogQueryVariables>;
export const RequestLogsDocument = gql`
    query RequestLogs($page: Int!) {
  RequestLogs(page: $page) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FRequestLog
    }
  }
}
    ${FRequestLogFragmentDoc}`;

/**
 * __useRequestLogsQuery_raw__
 *
 * To run a query within a React component, call `useRequestLogsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useRequestLogsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequestLogsQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useRequestLogsQuery_raw(baseOptions: Apollo.QueryHookOptions<RequestLogsQuery, RequestLogsQueryVariables> & ({ variables: RequestLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequestLogsQuery, RequestLogsQueryVariables>(RequestLogsDocument, options);
      }
export function useRequestLogsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<RequestLogsQuery, RequestLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequestLogsQuery, RequestLogsQueryVariables>(RequestLogsDocument, options);
        }
// @ts-ignore
export function useRequestLogsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<RequestLogsQuery, RequestLogsQueryVariables>): Apollo.UseSuspenseQueryResult<RequestLogsQuery, RequestLogsQueryVariables>;
export function useRequestLogsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestLogsQuery, RequestLogsQueryVariables>): Apollo.UseSuspenseQueryResult<RequestLogsQuery | undefined, RequestLogsQueryVariables>;
export function useRequestLogsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RequestLogsQuery, RequestLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RequestLogsQuery, RequestLogsQueryVariables>(RequestLogsDocument, options);
        }
export type RequestLogsQuery_rawHookResult = ReturnType<typeof useRequestLogsQuery_raw>;
export type RequestLogsLazyQuery_rawHookResult = ReturnType<typeof useRequestLogsLazyQuery_raw>;
export type RequestLogsSuspenseQuery_rawHookResult = ReturnType<typeof useRequestLogsSuspenseQuery_raw>;
export type RequestLogsQueryResult = Apollo.QueryResult<RequestLogsQuery, RequestLogsQueryVariables>;
export const SampleWaypointTemplatesDocument = gql`
    query SampleWaypointTemplates {
  SampleWaypointTemplates(filter: {type: TEMPLATE}) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FWaypointTemplate
    }
  }
}
    ${FWaypointTemplateFragmentDoc}`;

/**
 * __useSampleWaypointTemplatesQuery_raw__
 *
 * To run a query within a React component, call `useSampleWaypointTemplatesQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useSampleWaypointTemplatesQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleWaypointTemplatesQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useSampleWaypointTemplatesQuery_raw(baseOptions?: Apollo.QueryHookOptions<SampleWaypointTemplatesQuery, SampleWaypointTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleWaypointTemplatesQuery, SampleWaypointTemplatesQueryVariables>(SampleWaypointTemplatesDocument, options);
      }
export function useSampleWaypointTemplatesLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<SampleWaypointTemplatesQuery, SampleWaypointTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleWaypointTemplatesQuery, SampleWaypointTemplatesQueryVariables>(SampleWaypointTemplatesDocument, options);
        }
// @ts-ignore
export function useSampleWaypointTemplatesSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<SampleWaypointTemplatesQuery, SampleWaypointTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<SampleWaypointTemplatesQuery, SampleWaypointTemplatesQueryVariables>;
export function useSampleWaypointTemplatesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SampleWaypointTemplatesQuery, SampleWaypointTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<SampleWaypointTemplatesQuery | undefined, SampleWaypointTemplatesQueryVariables>;
export function useSampleWaypointTemplatesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SampleWaypointTemplatesQuery, SampleWaypointTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SampleWaypointTemplatesQuery, SampleWaypointTemplatesQueryVariables>(SampleWaypointTemplatesDocument, options);
        }
export type SampleWaypointTemplatesQuery_rawHookResult = ReturnType<typeof useSampleWaypointTemplatesQuery_raw>;
export type SampleWaypointTemplatesLazyQuery_rawHookResult = ReturnType<typeof useSampleWaypointTemplatesLazyQuery_raw>;
export type SampleWaypointTemplatesSuspenseQuery_rawHookResult = ReturnType<typeof useSampleWaypointTemplatesSuspenseQuery_raw>;
export type SampleWaypointTemplatesQueryResult = Apollo.QueryResult<SampleWaypointTemplatesQuery, SampleWaypointTemplatesQueryVariables>;
export const SampleWaypointLayoutsDocument = gql`
    query SampleWaypointLayouts {
  SampleWaypointTemplates(filter: {type: LAYOUT}) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FWaypointTemplate
    }
  }
}
    ${FWaypointTemplateFragmentDoc}`;

/**
 * __useSampleWaypointLayoutsQuery_raw__
 *
 * To run a query within a React component, call `useSampleWaypointLayoutsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useSampleWaypointLayoutsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleWaypointLayoutsQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useSampleWaypointLayoutsQuery_raw(baseOptions?: Apollo.QueryHookOptions<SampleWaypointLayoutsQuery, SampleWaypointLayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleWaypointLayoutsQuery, SampleWaypointLayoutsQueryVariables>(SampleWaypointLayoutsDocument, options);
      }
export function useSampleWaypointLayoutsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<SampleWaypointLayoutsQuery, SampleWaypointLayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleWaypointLayoutsQuery, SampleWaypointLayoutsQueryVariables>(SampleWaypointLayoutsDocument, options);
        }
// @ts-ignore
export function useSampleWaypointLayoutsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<SampleWaypointLayoutsQuery, SampleWaypointLayoutsQueryVariables>): Apollo.UseSuspenseQueryResult<SampleWaypointLayoutsQuery, SampleWaypointLayoutsQueryVariables>;
export function useSampleWaypointLayoutsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SampleWaypointLayoutsQuery, SampleWaypointLayoutsQueryVariables>): Apollo.UseSuspenseQueryResult<SampleWaypointLayoutsQuery | undefined, SampleWaypointLayoutsQueryVariables>;
export function useSampleWaypointLayoutsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SampleWaypointLayoutsQuery, SampleWaypointLayoutsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SampleWaypointLayoutsQuery, SampleWaypointLayoutsQueryVariables>(SampleWaypointLayoutsDocument, options);
        }
export type SampleWaypointLayoutsQuery_rawHookResult = ReturnType<typeof useSampleWaypointLayoutsQuery_raw>;
export type SampleWaypointLayoutsLazyQuery_rawHookResult = ReturnType<typeof useSampleWaypointLayoutsLazyQuery_raw>;
export type SampleWaypointLayoutsSuspenseQuery_rawHookResult = ReturnType<typeof useSampleWaypointLayoutsSuspenseQuery_raw>;
export type SampleWaypointLayoutsQueryResult = Apollo.QueryResult<SampleWaypointLayoutsQuery, SampleWaypointLayoutsQueryVariables>;
export const TemplateSectionsDocument = gql`
    query TemplateSections {
  TemplateSections {
    ...FTemplateSection
  }
}
    ${FTemplateSectionFragmentDoc}`;

/**
 * __useTemplateSectionsQuery_raw__
 *
 * To run a query within a React component, call `useTemplateSectionsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useTemplateSectionsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTemplateSectionsQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useTemplateSectionsQuery_raw(baseOptions?: Apollo.QueryHookOptions<TemplateSectionsQuery, TemplateSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TemplateSectionsQuery, TemplateSectionsQueryVariables>(TemplateSectionsDocument, options);
      }
export function useTemplateSectionsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<TemplateSectionsQuery, TemplateSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TemplateSectionsQuery, TemplateSectionsQueryVariables>(TemplateSectionsDocument, options);
        }
// @ts-ignore
export function useTemplateSectionsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<TemplateSectionsQuery, TemplateSectionsQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateSectionsQuery, TemplateSectionsQueryVariables>;
export function useTemplateSectionsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateSectionsQuery, TemplateSectionsQueryVariables>): Apollo.UseSuspenseQueryResult<TemplateSectionsQuery | undefined, TemplateSectionsQueryVariables>;
export function useTemplateSectionsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TemplateSectionsQuery, TemplateSectionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TemplateSectionsQuery, TemplateSectionsQueryVariables>(TemplateSectionsDocument, options);
        }
export type TemplateSectionsQuery_rawHookResult = ReturnType<typeof useTemplateSectionsQuery_raw>;
export type TemplateSectionsLazyQuery_rawHookResult = ReturnType<typeof useTemplateSectionsLazyQuery_raw>;
export type TemplateSectionsSuspenseQuery_rawHookResult = ReturnType<typeof useTemplateSectionsSuspenseQuery_raw>;
export type TemplateSectionsQueryResult = Apollo.QueryResult<TemplateSectionsQuery, TemplateSectionsQueryVariables>;
export const VerifiedEmailAddressesDocument = gql`
    query VerifiedEmailAddresses($page: Int) {
  VerifiedEmailAddresses(page: $page) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FVerifiedEmailAddress
    }
  }
}
    ${FVerifiedEmailAddressFragmentDoc}`;

/**
 * __useVerifiedEmailAddressesQuery_raw__
 *
 * To run a query within a React component, call `useVerifiedEmailAddressesQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useVerifiedEmailAddressesQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVerifiedEmailAddressesQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useVerifiedEmailAddressesQuery_raw(baseOptions?: Apollo.QueryHookOptions<VerifiedEmailAddressesQuery, VerifiedEmailAddressesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VerifiedEmailAddressesQuery, VerifiedEmailAddressesQueryVariables>(VerifiedEmailAddressesDocument, options);
      }
export function useVerifiedEmailAddressesLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<VerifiedEmailAddressesQuery, VerifiedEmailAddressesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VerifiedEmailAddressesQuery, VerifiedEmailAddressesQueryVariables>(VerifiedEmailAddressesDocument, options);
        }
// @ts-ignore
export function useVerifiedEmailAddressesSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<VerifiedEmailAddressesQuery, VerifiedEmailAddressesQueryVariables>): Apollo.UseSuspenseQueryResult<VerifiedEmailAddressesQuery, VerifiedEmailAddressesQueryVariables>;
export function useVerifiedEmailAddressesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerifiedEmailAddressesQuery, VerifiedEmailAddressesQueryVariables>): Apollo.UseSuspenseQueryResult<VerifiedEmailAddressesQuery | undefined, VerifiedEmailAddressesQueryVariables>;
export function useVerifiedEmailAddressesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VerifiedEmailAddressesQuery, VerifiedEmailAddressesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VerifiedEmailAddressesQuery, VerifiedEmailAddressesQueryVariables>(VerifiedEmailAddressesDocument, options);
        }
export type VerifiedEmailAddressesQuery_rawHookResult = ReturnType<typeof useVerifiedEmailAddressesQuery_raw>;
export type VerifiedEmailAddressesLazyQuery_rawHookResult = ReturnType<typeof useVerifiedEmailAddressesLazyQuery_raw>;
export type VerifiedEmailAddressesSuspenseQuery_rawHookResult = ReturnType<typeof useVerifiedEmailAddressesSuspenseQuery_raw>;
export type VerifiedEmailAddressesQueryResult = Apollo.QueryResult<VerifiedEmailAddressesQuery, VerifiedEmailAddressesQueryVariables>;
export const WaypointTemplateDocument = gql`
    query WaypointTemplate($id: ID!) {
  WaypointTemplate(id: $id) {
    ...FWaypointTemplate
  }
}
    ${FWaypointTemplateFragmentDoc}`;

/**
 * __useWaypointTemplateQuery_raw__
 *
 * To run a query within a React component, call `useWaypointTemplateQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWaypointTemplateQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaypointTemplateQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWaypointTemplateQuery_raw(baseOptions: Apollo.QueryHookOptions<WaypointTemplateQuery, WaypointTemplateQueryVariables> & ({ variables: WaypointTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaypointTemplateQuery, WaypointTemplateQueryVariables>(WaypointTemplateDocument, options);
      }
export function useWaypointTemplateLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WaypointTemplateQuery, WaypointTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaypointTemplateQuery, WaypointTemplateQueryVariables>(WaypointTemplateDocument, options);
        }
// @ts-ignore
export function useWaypointTemplateSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WaypointTemplateQuery, WaypointTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<WaypointTemplateQuery, WaypointTemplateQueryVariables>;
export function useWaypointTemplateSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaypointTemplateQuery, WaypointTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<WaypointTemplateQuery | undefined, WaypointTemplateQueryVariables>;
export function useWaypointTemplateSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaypointTemplateQuery, WaypointTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WaypointTemplateQuery, WaypointTemplateQueryVariables>(WaypointTemplateDocument, options);
        }
export type WaypointTemplateQuery_rawHookResult = ReturnType<typeof useWaypointTemplateQuery_raw>;
export type WaypointTemplateLazyQuery_rawHookResult = ReturnType<typeof useWaypointTemplateLazyQuery_raw>;
export type WaypointTemplateSuspenseQuery_rawHookResult = ReturnType<typeof useWaypointTemplateSuspenseQuery_raw>;
export type WaypointTemplateQueryResult = Apollo.QueryResult<WaypointTemplateQuery, WaypointTemplateQueryVariables>;
export const WaypointTemplateCountsDocument = gql`
    query WaypointTemplateCounts($id: ID!) {
  WaypointTemplate(id: $id) {
    ...FWaypointTemplateCounts
  }
}
    ${FWaypointTemplateCountsFragmentDoc}`;

/**
 * __useWaypointTemplateCountsQuery_raw__
 *
 * To run a query within a React component, call `useWaypointTemplateCountsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWaypointTemplateCountsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaypointTemplateCountsQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWaypointTemplateCountsQuery_raw(baseOptions: Apollo.QueryHookOptions<WaypointTemplateCountsQuery, WaypointTemplateCountsQueryVariables> & ({ variables: WaypointTemplateCountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaypointTemplateCountsQuery, WaypointTemplateCountsQueryVariables>(WaypointTemplateCountsDocument, options);
      }
export function useWaypointTemplateCountsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WaypointTemplateCountsQuery, WaypointTemplateCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaypointTemplateCountsQuery, WaypointTemplateCountsQueryVariables>(WaypointTemplateCountsDocument, options);
        }
// @ts-ignore
export function useWaypointTemplateCountsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WaypointTemplateCountsQuery, WaypointTemplateCountsQueryVariables>): Apollo.UseSuspenseQueryResult<WaypointTemplateCountsQuery, WaypointTemplateCountsQueryVariables>;
export function useWaypointTemplateCountsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaypointTemplateCountsQuery, WaypointTemplateCountsQueryVariables>): Apollo.UseSuspenseQueryResult<WaypointTemplateCountsQuery | undefined, WaypointTemplateCountsQueryVariables>;
export function useWaypointTemplateCountsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaypointTemplateCountsQuery, WaypointTemplateCountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WaypointTemplateCountsQuery, WaypointTemplateCountsQueryVariables>(WaypointTemplateCountsDocument, options);
        }
export type WaypointTemplateCountsQuery_rawHookResult = ReturnType<typeof useWaypointTemplateCountsQuery_raw>;
export type WaypointTemplateCountsLazyQuery_rawHookResult = ReturnType<typeof useWaypointTemplateCountsLazyQuery_raw>;
export type WaypointTemplateCountsSuspenseQuery_rawHookResult = ReturnType<typeof useWaypointTemplateCountsSuspenseQuery_raw>;
export type WaypointTemplateCountsQueryResult = Apollo.QueryResult<WaypointTemplateCountsQuery, WaypointTemplateCountsQueryVariables>;
export const WaypointTemplateRawDocument = gql`
    query WaypointTemplateRaw($id: ID!) {
  WaypointTemplate(id: $id) {
    activeConfiguration {
      rawSubject
      rawHtml
    }
  }
}
    `;

/**
 * __useWaypointTemplateRawQuery_raw__
 *
 * To run a query within a React component, call `useWaypointTemplateRawQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWaypointTemplateRawQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaypointTemplateRawQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWaypointTemplateRawQuery_raw(baseOptions: Apollo.QueryHookOptions<WaypointTemplateRawQuery, WaypointTemplateRawQueryVariables> & ({ variables: WaypointTemplateRawQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaypointTemplateRawQuery, WaypointTemplateRawQueryVariables>(WaypointTemplateRawDocument, options);
      }
export function useWaypointTemplateRawLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WaypointTemplateRawQuery, WaypointTemplateRawQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaypointTemplateRawQuery, WaypointTemplateRawQueryVariables>(WaypointTemplateRawDocument, options);
        }
// @ts-ignore
export function useWaypointTemplateRawSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WaypointTemplateRawQuery, WaypointTemplateRawQueryVariables>): Apollo.UseSuspenseQueryResult<WaypointTemplateRawQuery, WaypointTemplateRawQueryVariables>;
export function useWaypointTemplateRawSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaypointTemplateRawQuery, WaypointTemplateRawQueryVariables>): Apollo.UseSuspenseQueryResult<WaypointTemplateRawQuery | undefined, WaypointTemplateRawQueryVariables>;
export function useWaypointTemplateRawSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaypointTemplateRawQuery, WaypointTemplateRawQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WaypointTemplateRawQuery, WaypointTemplateRawQueryVariables>(WaypointTemplateRawDocument, options);
        }
export type WaypointTemplateRawQuery_rawHookResult = ReturnType<typeof useWaypointTemplateRawQuery_raw>;
export type WaypointTemplateRawLazyQuery_rawHookResult = ReturnType<typeof useWaypointTemplateRawLazyQuery_raw>;
export type WaypointTemplateRawSuspenseQuery_rawHookResult = ReturnType<typeof useWaypointTemplateRawSuspenseQuery_raw>;
export type WaypointTemplateRawQueryResult = Apollo.QueryResult<WaypointTemplateRawQuery, WaypointTemplateRawQueryVariables>;
export const WaypointTemplateImageDocument = gql`
    query WaypointTemplateImage($id: ID!) {
  WaypointTemplateImage(id: $id) {
    ...FWaypointTemplateImage
  }
}
    ${FWaypointTemplateImageFragmentDoc}`;

/**
 * __useWaypointTemplateImageQuery_raw__
 *
 * To run a query within a React component, call `useWaypointTemplateImageQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWaypointTemplateImageQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaypointTemplateImageQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWaypointTemplateImageQuery_raw(baseOptions: Apollo.QueryHookOptions<WaypointTemplateImageQuery, WaypointTemplateImageQueryVariables> & ({ variables: WaypointTemplateImageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaypointTemplateImageQuery, WaypointTemplateImageQueryVariables>(WaypointTemplateImageDocument, options);
      }
export function useWaypointTemplateImageLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WaypointTemplateImageQuery, WaypointTemplateImageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaypointTemplateImageQuery, WaypointTemplateImageQueryVariables>(WaypointTemplateImageDocument, options);
        }
// @ts-ignore
export function useWaypointTemplateImageSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WaypointTemplateImageQuery, WaypointTemplateImageQueryVariables>): Apollo.UseSuspenseQueryResult<WaypointTemplateImageQuery, WaypointTemplateImageQueryVariables>;
export function useWaypointTemplateImageSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaypointTemplateImageQuery, WaypointTemplateImageQueryVariables>): Apollo.UseSuspenseQueryResult<WaypointTemplateImageQuery | undefined, WaypointTemplateImageQueryVariables>;
export function useWaypointTemplateImageSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaypointTemplateImageQuery, WaypointTemplateImageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WaypointTemplateImageQuery, WaypointTemplateImageQueryVariables>(WaypointTemplateImageDocument, options);
        }
export type WaypointTemplateImageQuery_rawHookResult = ReturnType<typeof useWaypointTemplateImageQuery_raw>;
export type WaypointTemplateImageLazyQuery_rawHookResult = ReturnType<typeof useWaypointTemplateImageLazyQuery_raw>;
export type WaypointTemplateImageSuspenseQuery_rawHookResult = ReturnType<typeof useWaypointTemplateImageSuspenseQuery_raw>;
export type WaypointTemplateImageQueryResult = Apollo.QueryResult<WaypointTemplateImageQuery, WaypointTemplateImageQueryVariables>;
export const WaypointTemplateImagesDocument = gql`
    query WaypointTemplateImages($page: Int) {
  WaypointTemplateImages(page: $page) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FWaypointTemplateImage
    }
  }
}
    ${FWaypointTemplateImageFragmentDoc}`;

/**
 * __useWaypointTemplateImagesQuery_raw__
 *
 * To run a query within a React component, call `useWaypointTemplateImagesQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWaypointTemplateImagesQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWaypointTemplateImagesQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useWaypointTemplateImagesQuery_raw(baseOptions?: Apollo.QueryHookOptions<WaypointTemplateImagesQuery, WaypointTemplateImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WaypointTemplateImagesQuery, WaypointTemplateImagesQueryVariables>(WaypointTemplateImagesDocument, options);
      }
export function useWaypointTemplateImagesLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WaypointTemplateImagesQuery, WaypointTemplateImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WaypointTemplateImagesQuery, WaypointTemplateImagesQueryVariables>(WaypointTemplateImagesDocument, options);
        }
// @ts-ignore
export function useWaypointTemplateImagesSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WaypointTemplateImagesQuery, WaypointTemplateImagesQueryVariables>): Apollo.UseSuspenseQueryResult<WaypointTemplateImagesQuery, WaypointTemplateImagesQueryVariables>;
export function useWaypointTemplateImagesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaypointTemplateImagesQuery, WaypointTemplateImagesQueryVariables>): Apollo.UseSuspenseQueryResult<WaypointTemplateImagesQuery | undefined, WaypointTemplateImagesQueryVariables>;
export function useWaypointTemplateImagesSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WaypointTemplateImagesQuery, WaypointTemplateImagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WaypointTemplateImagesQuery, WaypointTemplateImagesQueryVariables>(WaypointTemplateImagesDocument, options);
        }
export type WaypointTemplateImagesQuery_rawHookResult = ReturnType<typeof useWaypointTemplateImagesQuery_raw>;
export type WaypointTemplateImagesLazyQuery_rawHookResult = ReturnType<typeof useWaypointTemplateImagesLazyQuery_raw>;
export type WaypointTemplateImagesSuspenseQuery_rawHookResult = ReturnType<typeof useWaypointTemplateImagesSuspenseQuery_raw>;
export type WaypointTemplateImagesQueryResult = Apollo.QueryResult<WaypointTemplateImagesQuery, WaypointTemplateImagesQueryVariables>;
export const FilteredTemplatesListDocument = gql`
    query FilteredTemplatesList($type: WaypointTemplateType, $page: Int) {
  WaypointTemplates(page: $page, filter: {type: $type}) {
    ...FWaypointTemplateListResult
  }
}
    ${FWaypointTemplateListResultFragmentDoc}`;

/**
 * __useFilteredTemplatesListQuery_raw__
 *
 * To run a query within a React component, call `useFilteredTemplatesListQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useFilteredTemplatesListQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredTemplatesListQuery_raw({
 *   variables: {
 *      type: // value for 'type'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useFilteredTemplatesListQuery_raw(baseOptions?: Apollo.QueryHookOptions<FilteredTemplatesListQuery, FilteredTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FilteredTemplatesListQuery, FilteredTemplatesListQueryVariables>(FilteredTemplatesListDocument, options);
      }
export function useFilteredTemplatesListLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<FilteredTemplatesListQuery, FilteredTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FilteredTemplatesListQuery, FilteredTemplatesListQueryVariables>(FilteredTemplatesListDocument, options);
        }
// @ts-ignore
export function useFilteredTemplatesListSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<FilteredTemplatesListQuery, FilteredTemplatesListQueryVariables>): Apollo.UseSuspenseQueryResult<FilteredTemplatesListQuery, FilteredTemplatesListQueryVariables>;
export function useFilteredTemplatesListSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilteredTemplatesListQuery, FilteredTemplatesListQueryVariables>): Apollo.UseSuspenseQueryResult<FilteredTemplatesListQuery | undefined, FilteredTemplatesListQueryVariables>;
export function useFilteredTemplatesListSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FilteredTemplatesListQuery, FilteredTemplatesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FilteredTemplatesListQuery, FilteredTemplatesListQueryVariables>(FilteredTemplatesListDocument, options);
        }
export type FilteredTemplatesListQuery_rawHookResult = ReturnType<typeof useFilteredTemplatesListQuery_raw>;
export type FilteredTemplatesListLazyQuery_rawHookResult = ReturnType<typeof useFilteredTemplatesListLazyQuery_raw>;
export type FilteredTemplatesListSuspenseQuery_rawHookResult = ReturnType<typeof useFilteredTemplatesListSuspenseQuery_raw>;
export type FilteredTemplatesListQueryResult = Apollo.QueryResult<FilteredTemplatesListQuery, FilteredTemplatesListQueryVariables>;
export const StandardTemplatesListDocument = gql`
    query StandardTemplatesList {
  WaypointTemplates(filter: {type: TEMPLATE}) {
    ...FWaypointTemplateListResult
  }
}
    ${FWaypointTemplateListResultFragmentDoc}`;

/**
 * __useStandardTemplatesListQuery_raw__
 *
 * To run a query within a React component, call `useStandardTemplatesListQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useStandardTemplatesListQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStandardTemplatesListQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useStandardTemplatesListQuery_raw(baseOptions?: Apollo.QueryHookOptions<StandardTemplatesListQuery, StandardTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StandardTemplatesListQuery, StandardTemplatesListQueryVariables>(StandardTemplatesListDocument, options);
      }
export function useStandardTemplatesListLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<StandardTemplatesListQuery, StandardTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StandardTemplatesListQuery, StandardTemplatesListQueryVariables>(StandardTemplatesListDocument, options);
        }
// @ts-ignore
export function useStandardTemplatesListSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<StandardTemplatesListQuery, StandardTemplatesListQueryVariables>): Apollo.UseSuspenseQueryResult<StandardTemplatesListQuery, StandardTemplatesListQueryVariables>;
export function useStandardTemplatesListSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StandardTemplatesListQuery, StandardTemplatesListQueryVariables>): Apollo.UseSuspenseQueryResult<StandardTemplatesListQuery | undefined, StandardTemplatesListQueryVariables>;
export function useStandardTemplatesListSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StandardTemplatesListQuery, StandardTemplatesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StandardTemplatesListQuery, StandardTemplatesListQueryVariables>(StandardTemplatesListDocument, options);
        }
export type StandardTemplatesListQuery_rawHookResult = ReturnType<typeof useStandardTemplatesListQuery_raw>;
export type StandardTemplatesListLazyQuery_rawHookResult = ReturnType<typeof useStandardTemplatesListLazyQuery_raw>;
export type StandardTemplatesListSuspenseQuery_rawHookResult = ReturnType<typeof useStandardTemplatesListSuspenseQuery_raw>;
export type StandardTemplatesListQueryResult = Apollo.QueryResult<StandardTemplatesListQuery, StandardTemplatesListQueryVariables>;
export const LayoutTemplatesListDocument = gql`
    query LayoutTemplatesList {
  WaypointTemplates(filter: {type: LAYOUT}) {
    ...FWaypointTemplateListResult
  }
}
    ${FWaypointTemplateListResultFragmentDoc}`;

/**
 * __useLayoutTemplatesListQuery_raw__
 *
 * To run a query within a React component, call `useLayoutTemplatesListQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useLayoutTemplatesListQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLayoutTemplatesListQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useLayoutTemplatesListQuery_raw(baseOptions?: Apollo.QueryHookOptions<LayoutTemplatesListQuery, LayoutTemplatesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LayoutTemplatesListQuery, LayoutTemplatesListQueryVariables>(LayoutTemplatesListDocument, options);
      }
export function useLayoutTemplatesListLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<LayoutTemplatesListQuery, LayoutTemplatesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LayoutTemplatesListQuery, LayoutTemplatesListQueryVariables>(LayoutTemplatesListDocument, options);
        }
// @ts-ignore
export function useLayoutTemplatesListSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<LayoutTemplatesListQuery, LayoutTemplatesListQueryVariables>): Apollo.UseSuspenseQueryResult<LayoutTemplatesListQuery, LayoutTemplatesListQueryVariables>;
export function useLayoutTemplatesListSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LayoutTemplatesListQuery, LayoutTemplatesListQueryVariables>): Apollo.UseSuspenseQueryResult<LayoutTemplatesListQuery | undefined, LayoutTemplatesListQueryVariables>;
export function useLayoutTemplatesListSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LayoutTemplatesListQuery, LayoutTemplatesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LayoutTemplatesListQuery, LayoutTemplatesListQueryVariables>(LayoutTemplatesListDocument, options);
        }
export type LayoutTemplatesListQuery_rawHookResult = ReturnType<typeof useLayoutTemplatesListQuery_raw>;
export type LayoutTemplatesListLazyQuery_rawHookResult = ReturnType<typeof useLayoutTemplatesListLazyQuery_raw>;
export type LayoutTemplatesListSuspenseQuery_rawHookResult = ReturnType<typeof useLayoutTemplatesListSuspenseQuery_raw>;
export type LayoutTemplatesListQueryResult = Apollo.QueryResult<LayoutTemplatesListQuery, LayoutTemplatesListQueryVariables>;
export const WebhookEndpointsDocument = gql`
    query WebhookEndpoints {
  WebhookEndpoints {
    count
    nodes {
      ...FWebhookEndpoint
    }
  }
}
    ${FWebhookEndpointFragmentDoc}`;

/**
 * __useWebhookEndpointsQuery_raw__
 *
 * To run a query within a React component, call `useWebhookEndpointsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWebhookEndpointsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWebhookEndpointsQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useWebhookEndpointsQuery_raw(baseOptions?: Apollo.QueryHookOptions<WebhookEndpointsQuery, WebhookEndpointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WebhookEndpointsQuery, WebhookEndpointsQueryVariables>(WebhookEndpointsDocument, options);
      }
export function useWebhookEndpointsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WebhookEndpointsQuery, WebhookEndpointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WebhookEndpointsQuery, WebhookEndpointsQueryVariables>(WebhookEndpointsDocument, options);
        }
// @ts-ignore
export function useWebhookEndpointsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WebhookEndpointsQuery, WebhookEndpointsQueryVariables>): Apollo.UseSuspenseQueryResult<WebhookEndpointsQuery, WebhookEndpointsQueryVariables>;
export function useWebhookEndpointsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebhookEndpointsQuery, WebhookEndpointsQueryVariables>): Apollo.UseSuspenseQueryResult<WebhookEndpointsQuery | undefined, WebhookEndpointsQueryVariables>;
export function useWebhookEndpointsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WebhookEndpointsQuery, WebhookEndpointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WebhookEndpointsQuery, WebhookEndpointsQueryVariables>(WebhookEndpointsDocument, options);
        }
export type WebhookEndpointsQuery_rawHookResult = ReturnType<typeof useWebhookEndpointsQuery_raw>;
export type WebhookEndpointsLazyQuery_rawHookResult = ReturnType<typeof useWebhookEndpointsLazyQuery_raw>;
export type WebhookEndpointsSuspenseQuery_rawHookResult = ReturnType<typeof useWebhookEndpointsSuspenseQuery_raw>;
export type WebhookEndpointsQueryResult = Apollo.QueryResult<WebhookEndpointsQuery, WebhookEndpointsQueryVariables>;
export const WorkflowDocument = gql`
    query Workflow($id: ID!) {
  Workflow(id: $id) {
    ...FWorkflow
    ...FWorkflowStatistics
  }
}
    ${FWorkflowFragmentDoc}
${FWorkflowStatisticsFragmentDoc}`;

/**
 * __useWorkflowQuery_raw__
 *
 * To run a query within a React component, call `useWorkflowQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkflowQuery_raw(baseOptions: Apollo.QueryHookOptions<WorkflowQuery, WorkflowQueryVariables> & ({ variables: WorkflowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowQuery, WorkflowQueryVariables>(WorkflowDocument, options);
      }
export function useWorkflowLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowQuery, WorkflowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowQuery, WorkflowQueryVariables>(WorkflowDocument, options);
        }
// @ts-ignore
export function useWorkflowSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowQuery, WorkflowQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowQuery, WorkflowQueryVariables>;
export function useWorkflowSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowQuery, WorkflowQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowQuery | undefined, WorkflowQueryVariables>;
export function useWorkflowSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowQuery, WorkflowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowQuery, WorkflowQueryVariables>(WorkflowDocument, options);
        }
export type WorkflowQuery_rawHookResult = ReturnType<typeof useWorkflowQuery_raw>;
export type WorkflowLazyQuery_rawHookResult = ReturnType<typeof useWorkflowLazyQuery_raw>;
export type WorkflowSuspenseQuery_rawHookResult = ReturnType<typeof useWorkflowSuspenseQuery_raw>;
export type WorkflowQueryResult = Apollo.QueryResult<WorkflowQuery, WorkflowQueryVariables>;
export const WorkflowEventDocument = gql`
    query WorkflowEvent($id: ID!) {
  WorkflowEvent(id: $id) {
    ...FWorkflowEvent
  }
}
    ${FWorkflowEventFragmentDoc}`;

/**
 * __useWorkflowEventQuery_raw__
 *
 * To run a query within a React component, call `useWorkflowEventQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowEventQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowEventQuery_raw({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkflowEventQuery_raw(baseOptions: Apollo.QueryHookOptions<WorkflowEventQuery, WorkflowEventQueryVariables> & ({ variables: WorkflowEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowEventQuery, WorkflowEventQueryVariables>(WorkflowEventDocument, options);
      }
export function useWorkflowEventLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowEventQuery, WorkflowEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowEventQuery, WorkflowEventQueryVariables>(WorkflowEventDocument, options);
        }
// @ts-ignore
export function useWorkflowEventSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowEventQuery, WorkflowEventQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowEventQuery, WorkflowEventQueryVariables>;
export function useWorkflowEventSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowEventQuery, WorkflowEventQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowEventQuery | undefined, WorkflowEventQueryVariables>;
export function useWorkflowEventSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowEventQuery, WorkflowEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowEventQuery, WorkflowEventQueryVariables>(WorkflowEventDocument, options);
        }
export type WorkflowEventQuery_rawHookResult = ReturnType<typeof useWorkflowEventQuery_raw>;
export type WorkflowEventLazyQuery_rawHookResult = ReturnType<typeof useWorkflowEventLazyQuery_raw>;
export type WorkflowEventSuspenseQuery_rawHookResult = ReturnType<typeof useWorkflowEventSuspenseQuery_raw>;
export type WorkflowEventQueryResult = Apollo.QueryResult<WorkflowEventQuery, WorkflowEventQueryVariables>;
export const WorkflowEventsDocument = gql`
    query WorkflowEvents($page: Int, $filter: WorkflowEventsFilterInput) {
  WorkflowEvents(page: $page, filter: $filter) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FWorkflowEvent
    }
  }
}
    ${FWorkflowEventFragmentDoc}`;

/**
 * __useWorkflowEventsQuery_raw__
 *
 * To run a query within a React component, call `useWorkflowEventsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowEventsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowEventsQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useWorkflowEventsQuery_raw(baseOptions?: Apollo.QueryHookOptions<WorkflowEventsQuery, WorkflowEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowEventsQuery, WorkflowEventsQueryVariables>(WorkflowEventsDocument, options);
      }
export function useWorkflowEventsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowEventsQuery, WorkflowEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowEventsQuery, WorkflowEventsQueryVariables>(WorkflowEventsDocument, options);
        }
// @ts-ignore
export function useWorkflowEventsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowEventsQuery, WorkflowEventsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowEventsQuery, WorkflowEventsQueryVariables>;
export function useWorkflowEventsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowEventsQuery, WorkflowEventsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowEventsQuery | undefined, WorkflowEventsQueryVariables>;
export function useWorkflowEventsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowEventsQuery, WorkflowEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowEventsQuery, WorkflowEventsQueryVariables>(WorkflowEventsDocument, options);
        }
export type WorkflowEventsQuery_rawHookResult = ReturnType<typeof useWorkflowEventsQuery_raw>;
export type WorkflowEventsLazyQuery_rawHookResult = ReturnType<typeof useWorkflowEventsLazyQuery_raw>;
export type WorkflowEventsSuspenseQuery_rawHookResult = ReturnType<typeof useWorkflowEventsSuspenseQuery_raw>;
export type WorkflowEventsQueryResult = Apollo.QueryResult<WorkflowEventsQuery, WorkflowEventsQueryVariables>;
export const WorkflowRunTimelineLogItemsDocument = gql`
    query WorkflowRunTimelineLogItems($page: Int, $id: ID!) {
  TimelineLogItems: WorkflowRunTimelineLogItems(page: $page, id: $id) {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FTimelineLogItem
    }
  }
}
    ${FTimelineLogItemFragmentDoc}`;

/**
 * __useWorkflowRunTimelineLogItemsQuery_raw__
 *
 * To run a query within a React component, call `useWorkflowRunTimelineLogItemsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowRunTimelineLogItemsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowRunTimelineLogItemsQuery_raw({
 *   variables: {
 *      page: // value for 'page'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWorkflowRunTimelineLogItemsQuery_raw(baseOptions: Apollo.QueryHookOptions<WorkflowRunTimelineLogItemsQuery, WorkflowRunTimelineLogItemsQueryVariables> & ({ variables: WorkflowRunTimelineLogItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowRunTimelineLogItemsQuery, WorkflowRunTimelineLogItemsQueryVariables>(WorkflowRunTimelineLogItemsDocument, options);
      }
export function useWorkflowRunTimelineLogItemsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowRunTimelineLogItemsQuery, WorkflowRunTimelineLogItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowRunTimelineLogItemsQuery, WorkflowRunTimelineLogItemsQueryVariables>(WorkflowRunTimelineLogItemsDocument, options);
        }
// @ts-ignore
export function useWorkflowRunTimelineLogItemsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowRunTimelineLogItemsQuery, WorkflowRunTimelineLogItemsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowRunTimelineLogItemsQuery, WorkflowRunTimelineLogItemsQueryVariables>;
export function useWorkflowRunTimelineLogItemsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowRunTimelineLogItemsQuery, WorkflowRunTimelineLogItemsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowRunTimelineLogItemsQuery | undefined, WorkflowRunTimelineLogItemsQueryVariables>;
export function useWorkflowRunTimelineLogItemsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowRunTimelineLogItemsQuery, WorkflowRunTimelineLogItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowRunTimelineLogItemsQuery, WorkflowRunTimelineLogItemsQueryVariables>(WorkflowRunTimelineLogItemsDocument, options);
        }
export type WorkflowRunTimelineLogItemsQuery_rawHookResult = ReturnType<typeof useWorkflowRunTimelineLogItemsQuery_raw>;
export type WorkflowRunTimelineLogItemsLazyQuery_rawHookResult = ReturnType<typeof useWorkflowRunTimelineLogItemsLazyQuery_raw>;
export type WorkflowRunTimelineLogItemsSuspenseQuery_rawHookResult = ReturnType<typeof useWorkflowRunTimelineLogItemsSuspenseQuery_raw>;
export type WorkflowRunTimelineLogItemsQueryResult = Apollo.QueryResult<WorkflowRunTimelineLogItemsQuery, WorkflowRunTimelineLogItemsQueryVariables>;
export const WorkflowsDocument = gql`
    query Workflows {
  Workflows {
    count
    meta {
      page
      limit
    }
    nodes {
      ...FWorkflow
    }
  }
}
    ${FWorkflowFragmentDoc}`;

/**
 * __useWorkflowsQuery_raw__
 *
 * To run a query within a React component, call `useWorkflowsQuery_raw` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowsQuery_raw` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowsQuery_raw({
 *   variables: {
 *   },
 * });
 */
export function useWorkflowsQuery_raw(baseOptions?: Apollo.QueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkflowsQuery, WorkflowsQueryVariables>(WorkflowsDocument, options);
      }
export function useWorkflowsLazyQuery_raw(baseOptions?: Apollo.LazyQueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkflowsQuery, WorkflowsQueryVariables>(WorkflowsDocument, options);
        }
// @ts-ignore
export function useWorkflowsSuspenseQuery_raw(baseOptions?: Apollo.SuspenseQueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowsQuery, WorkflowsQueryVariables>;
export function useWorkflowsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>): Apollo.UseSuspenseQueryResult<WorkflowsQuery | undefined, WorkflowsQueryVariables>;
export function useWorkflowsSuspenseQuery_raw(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WorkflowsQuery, WorkflowsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WorkflowsQuery, WorkflowsQueryVariables>(WorkflowsDocument, options);
        }
export type WorkflowsQuery_rawHookResult = ReturnType<typeof useWorkflowsQuery_raw>;
export type WorkflowsLazyQuery_rawHookResult = ReturnType<typeof useWorkflowsLazyQuery_raw>;
export type WorkflowsSuspenseQuery_rawHookResult = ReturnType<typeof useWorkflowsSuspenseQuery_raw>;
export type WorkflowsQueryResult = Apollo.QueryResult<WorkflowsQuery, WorkflowsQueryVariables>;
import useApiClient from '@dashboard/hooks/usePlatformClient';

function bindClient<Options, Response>(useApolloHook: (options: Options) => Response) {
  return (options?: Options) => {
    const client = useApiClient();
    return useApolloHook({ client, ...options } as any);
  };
}

export const useArchiveWaypointTemplateMutation = bindClient(useArchiveWaypointTemplateMutation_raw);
export const useArchiveWorkflowMutation = bindClient(useArchiveWorkflowMutation_raw);
export const useCreateApiKeyMutation = bindClient(useCreateApiKeyMutation_raw);
export const useCreateContactsGroupMutation = bindClient(useCreateContactsGroupMutation_raw);
export const useCreateContactsGroupContactMutation = bindClient(useCreateContactsGroupContactMutation_raw);
export const useCreateDomainNameVerificationMutation = bindClient(useCreateDomainNameVerificationMutation_raw);
export const useCreateSenderEmailAddressMutation = bindClient(useCreateSenderEmailAddressMutation_raw);
export const useCreateStripeCustomerPortalUrlMutation = bindClient(useCreateStripeCustomerPortalUrlMutation_raw);
export const useCreateSvixCustomerPortalUrlMutation = bindClient(useCreateSvixCustomerPortalUrlMutation_raw);
export const useCreateTemplateSectionMutation = bindClient(useCreateTemplateSectionMutation_raw);
export const useCreateTemplateMutation = bindClient(useCreateTemplateMutation_raw);
export const useCreateLayoutTemplateMutation = bindClient(useCreateLayoutTemplateMutation_raw);
export const useCreateDuplicateTemplateMutation = bindClient(useCreateDuplicateTemplateMutation_raw);
export const useCreateTemplateFromSampleMutation = bindClient(useCreateTemplateFromSampleMutation_raw);
export const useCreateTemplateFromExistingMutation = bindClient(useCreateTemplateFromExistingMutation_raw);
export const useCreateLayoutFromExistingMutation = bindClient(useCreateLayoutFromExistingMutation_raw);
export const useCreateWaypointTemplatePreviewMutation = bindClient(useCreateWaypointTemplatePreviewMutation_raw);
export const useCreateWaypointTemplateUploadImageUrlMutation = bindClient(useCreateWaypointTemplateUploadImageUrlMutation_raw);
export const useCreateWorkflowMutation = bindClient(useCreateWorkflowMutation_raw);
export const useCreateWorkflowPreviewMutation = bindClient(useCreateWorkflowPreviewMutation_raw);
export const useCreateWorkflowRunCommandMutation = bindClient(useCreateWorkflowRunCommandMutation_raw);
export const useDeleteContactsGroupContactMutation = bindClient(useDeleteContactsGroupContactMutation_raw);
export const useDeleteTemplateSectionMutation = bindClient(useDeleteTemplateSectionMutation_raw);
export const usePreviewWaypointTemplateMutation = bindClient(usePreviewWaypointTemplateMutation_raw);
export const useRefreshWaypointTemplateImageStatusMutation = bindClient(useRefreshWaypointTemplateImageStatusMutation_raw);
export const useRequestDomainNameVerificationApprovalMutation = bindClient(useRequestDomainNameVerificationApprovalMutation_raw);
export const useRequestPlatformDeleteMutation = bindClient(useRequestPlatformDeleteMutation_raw);
export const useSendDnsInformationEmailMessageMutation = bindClient(useSendDnsInformationEmailMessageMutation_raw);
export const useUpdateContactsGroupMutation = bindClient(useUpdateContactsGroupMutation_raw);
export const useUpdateEmailTemplateNameMutation = bindClient(useUpdateEmailTemplateNameMutation_raw);
export const useUpdatePlatformBillingInformationMutation = bindClient(useUpdatePlatformBillingInformationMutation_raw);
export const useUpdatePlatformBillingPlanMutation = bindClient(useUpdatePlatformBillingPlanMutation_raw);
export const useUpdatePlatformSesEventTrackingMutation = bindClient(useUpdatePlatformSesEventTrackingMutation_raw);
export const useUpdateTemplateSectionsOrderMutation = bindClient(useUpdateTemplateSectionsOrderMutation_raw);
export const useUpdateTemplateSectionMutation = bindClient(useUpdateTemplateSectionMutation_raw);
export const useUpdateVerifiedEmailAddressMutation = bindClient(useUpdateVerifiedEmailAddressMutation_raw);
export const useUpdateWaypointTemplateMutation = bindClient(useUpdateWaypointTemplateMutation_raw);
export const useUpdateWaypointTemplateSectionMutation = bindClient(useUpdateWaypointTemplateSectionMutation_raw);
export const useUpdateWorkflowMutation = bindClient(useUpdateWorkflowMutation_raw);
export const useUpdateWorkflowNameMutation = bindClient(useUpdateWorkflowNameMutation_raw);
export const useApiKeysQuery = bindClient(useApiKeysQuery_raw);
export const useContactQuery = bindClient(useContactQuery_raw);
export const useContactByEmailAddressQuery = bindClient(useContactByEmailAddressQuery_raw);
export const useContactsQuery = bindClient(useContactsQuery_raw);
export const useContactsGroupQuery = bindClient(useContactsGroupQuery_raw);
export const useContactsGroupContactsQuery = bindClient(useContactsGroupContactsQuery_raw);
export const useContactsGroupsQuery = bindClient(useContactsGroupsQuery_raw);
export const useCurrentPlatformUsageInformationQuery = bindClient(useCurrentPlatformUsageInformationQuery_raw);
export const useDomainNameVerificationQuery = bindClient(useDomainNameVerificationQuery_raw);
export const useDomainNameVerificationsQuery = bindClient(useDomainNameVerificationsQuery_raw);
export const useEmailMessageQuery = bindClient(useEmailMessageQuery_raw);
export const useEmailMessageLastEventQuery = bindClient(useEmailMessageLastEventQuery_raw);
export const useEmailMessageTimelineLogItemsQuery = bindClient(useEmailMessageTimelineLogItemsQuery_raw);
export const useEmailMessagesQuery = bindClient(useEmailMessagesQuery_raw);
export const useEmailMessagesExportQuery = bindClient(useEmailMessagesExportQuery_raw);
export const useEmailMessagesReportQuery = bindClient(useEmailMessagesReportQuery_raw);
export const useEmailTemplateHtmlPreviewQuery = bindClient(useEmailTemplateHtmlPreviewQuery_raw);
export const usePlatformBillingInformationQuery = bindClient(usePlatformBillingInformationQuery_raw);
export const usePlatformSesConfigurationQuery = bindClient(usePlatformSesConfigurationQuery_raw);
export const useRequestLogQuery = bindClient(useRequestLogQuery_raw);
export const useRequestLogsQuery = bindClient(useRequestLogsQuery_raw);
export const useSampleWaypointTemplatesQuery = bindClient(useSampleWaypointTemplatesQuery_raw);
export const useSampleWaypointLayoutsQuery = bindClient(useSampleWaypointLayoutsQuery_raw);
export const useTemplateSectionsQuery = bindClient(useTemplateSectionsQuery_raw);
export const useVerifiedEmailAddressesQuery = bindClient(useVerifiedEmailAddressesQuery_raw);
export const useWaypointTemplateQuery = bindClient(useWaypointTemplateQuery_raw);
export const useWaypointTemplateCountsQuery = bindClient(useWaypointTemplateCountsQuery_raw);
export const useWaypointTemplateRawQuery = bindClient(useWaypointTemplateRawQuery_raw);
export const useWaypointTemplateImageQuery = bindClient(useWaypointTemplateImageQuery_raw);
export const useWaypointTemplateImagesQuery = bindClient(useWaypointTemplateImagesQuery_raw);
export const useFilteredTemplatesListQuery = bindClient(useFilteredTemplatesListQuery_raw);
export const useStandardTemplatesListQuery = bindClient(useStandardTemplatesListQuery_raw);
export const useLayoutTemplatesListQuery = bindClient(useLayoutTemplatesListQuery_raw);
export const useWebhookEndpointsQuery = bindClient(useWebhookEndpointsQuery_raw);
export const useWorkflowQuery = bindClient(useWorkflowQuery_raw);
export const useWorkflowEventQuery = bindClient(useWorkflowEventQuery_raw);
export const useWorkflowEventsQuery = bindClient(useWorkflowEventsQuery_raw);
export const useWorkflowRunTimelineLogItemsQuery = bindClient(useWorkflowRunTimelineLogItemsQuery_raw);
export const useWorkflowsQuery = bindClient(useWorkflowsQuery_raw);
